var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.533,
    height: 150.962,
    viewBox: "0 0 206.533 150.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #4e5863;\n      }\n\n      .cls-4 {\n        fill: #9290c1;\n      }\n\n      .cls-5 {\n        fill: #5b3439;\n      }\n\n      .cls-6 {\n        fill: #bdbdbd;\n      }\n\n      .cls-7 {\n        fill: #4a0b23;\n      }\n\n      .cls-8 {\n        fill: #8b5e6d;\n      }\n\n      .cls-9 {\n        fill: #7c4b56;\n      }\n\n      .cls-10 {\n        fill: #a7878d;\n      }\n\n      .cls-11 {\n        fill: #e2cfc5;\n      }\n\n      .cls-12 {\n        fill: #9b7a83;\n      }\n\n      .cls-13 {\n        fill: #390614;\n      }\n\n      .cls-14 {\n        fill: #765662;\n      }\n\n      .cls-15 {\n        fill: #966879;\n      }\n\n      .cls-16 {\n        fill: #94d9fa;\n      }\n\n      .cls-17 {\n        fill: #919191;\n      }\n\n      .cls-18 {\n        fill: #a97f7f;\n      }\n\n      .cls-19 {\n        fill: #ecdcce;\n      }\n\n      .cls-20 {\n        fill: #828282;\n      }\n\n      .cls-21 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-22 {\n        fill: #d0dcd7;\n      }\n\n      .cls-23 {\n        fill: #fdfdfd;\n      }\n\n      .cls-24 {\n        fill: #5a4f80;\n      }\n\n      .cls-25 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-26 {\n        fill: #c3cf70;\n      }\n\n      .cls-27 {\n        fill: #fff5e6;\n      }\n\n      .cls-28 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-29 {\n        fill: #74739d;\n      }\n\n      .cls-30 {\n        fill: #979797;\n      }\n\n      .cls-31 {\n        fill: #9ab161;\n      }\n\n      .cls-32 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-33 {\n        clip-path: url(#clip-path-9);\n      }\n\n      .cls-34 {\n        fill: #f2635a;\n      }\n\n      .cls-35 {\n        fill: #7686ef;\n      }\n\n      .cls-36 {\n        fill: #edf0b4;\n      }\n\n      .cls-37 {\n        fill: #cfd582;\n      }\n\n      .cls-38 {\n        fill: #ebdfca;\n      }\n\n      .cls-39 {\n        fill: #804a5c;\n      }\n\n      .cls-40 {\n        fill: #799ec9;\n      }\n\n      .cls-41 {\n        fill: #c60d05;\n      }\n\n      .cls-42 {\n        fill: #4b4b91;\n      }\n\n      .cls-43 {\n        fill: #a32c31;\n      }\n\n      .cls-44 {\n        clip-path: url(#clip-path-15);\n      }\n\n      .cls-45 {\n        opacity: 0.38;\n      }\n\n      .cls-46 {\n        clip-path: url(#clip-path-17);\n      }\n\n      .cls-47 {\n        fill: #500a1e;\n      }\n\n      .cls-48 {\n        opacity: 0.25;\n      }\n\n      .cls-49 {\n        clip-path: url(#clip-path-18);\n      }\n\n      .cls-50 {\n        clip-path: url(#clip-path-19);\n      }\n\n      .cls-51 {\n        fill: #411928;\n      }\n\n      .cls-52 {\n        fill: #4e2132;\n      }\n\n      .cls-53 {\n        fill: #814e5b;\n      }\n\n      .cls-54 {\n        fill: #7a4955;\n      }\n\n      .cls-55 {\n        clip-path: url(#clip-path-20);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-57 {\n        clip-path: url(#clip-path-21);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-59 {\n        clip-path: url(#clip-path-22);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-61 {\n        fill: #6e3f4b;\n      }\n\n      .cls-62 {\n        clip-path: url(#clip-path-24);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-64 {\n        opacity: 0.8;\n      }\n\n      .cls-65 {\n        clip-path: url(#clip-path-26);\n      }\n\n      .cls-66 {\n        fill: #976e6f;\n      }\n\n      .cls-67 {\n        opacity: 0.9;\n      }\n\n      .cls-68 {\n        clip-path: url(#clip-path-27);\n      }\n\n      .cls-69 {\n        fill: #e6d5c6;\n      }\n\n      .cls-70 {\n        opacity: 0.4;\n      }\n\n      .cls-71 {\n        clip-path: url(#clip-path-28);\n      }\n\n      .cls-72 {\n        clip-path: url(#clip-path-29);\n      }\n\n      .cls-73 {\n        clip-path: url(#clip-path-30);\n      }\n\n      .cls-74 {\n        clip-path: url(#clip-path-31);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-76 {\n        clip-path: url(#clip-path-33);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-78 {\n        fill: #552837;\n      }\n\n      .cls-79 {\n        clip-path: url(#clip-path-35);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-81 {\n        clip-path: url(#clip-path-37);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-83 {\n        clip-path: url(#clip-path-38);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-85 {\n        clip-path: url(#clip-path-40);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-87 {\n        clip-path: url(#clip-path-42);\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-89 {\n        clip-path: url(#clip-path-44);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-91 {\n        clip-path: url(#clip-path-46);\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-93 {\n        clip-path: url(#clip-path-47);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-95 {\n        clip-path: url(#clip-path-49);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-97 {\n        clip-path: url(#clip-path-56);\n      }\n\n      .cls-98 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-99 {\n        clip-path: url(#clip-path-58);\n      }\n\n      .cls-100 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-101 {\n        clip-path: url(#clip-path-60);\n      }\n\n      .cls-102 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-103 {\n        clip-path: url(#clip-path-62);\n      }\n\n      .cls-104 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-105 {\n        clip-path: url(#clip-path-63);\n      }\n\n      .cls-106 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-107 {\n        clip-path: url(#clip-path-65);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-109 {\n        clip-path: url(#clip-path-67);\n      }\n\n      .cls-110 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-111 {\n        clip-path: url(#clip-path-69);\n      }\n\n      .cls-112 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-113 {\n        clip-path: url(#clip-path-71);\n      }\n\n      .cls-114 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-115 {\n        opacity: 0.7;\n      }\n\n      .cls-116 {\n        clip-path: url(#clip-path-73);\n      }\n\n      .cls-117 {\n        clip-path: url(#clip-path-74);\n      }\n\n      .cls-118 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-119 {\n        clip-path: url(#clip-path-76);\n      }\n\n      .cls-120 {\n        fill: #8b5865;\n      }\n\n      .cls-121 {\n        fill: #decbbe;\n      }\n\n      .cls-122 {\n        fill: #f2efe2;\n      }\n\n      .cls-123 {\n        clip-path: url(#clip-path-77);\n      }\n\n      .cls-124 {\n        fill: #ffe166;\n      }\n\n      .cls-125 {\n        fill: #fad241;\n      }\n\n      .cls-126 {\n        fill: #ffe66f;\n      }\n\n      .cls-127 {\n        opacity: 0.47;\n      }\n\n      .cls-128 {\n        clip-path: url(#clip-path-78);\n      }\n\n      .cls-129 {\n        fill: #820500;\n      }\n\n      .cls-130 {\n        fill: #fddd61;\n      }\n\n      .cls-131 {\n        opacity: 0.45;\n      }\n\n      .cls-132 {\n        clip-path: url(#clip-path-79);\n      }\n\n      .cls-133 {\n        opacity: 0.42;\n      }\n\n      .cls-134 {\n        clip-path: url(#clip-path-80);\n      }\n\n      .cls-135 {\n        fill: #820000;\n      }\n\n      .cls-136 {\n        fill: #fadc5f;\n      }\n\n      .cls-137 {\n        fill: #c57c2d;\n      }\n\n      .cls-138 {\n        fill: #69505f;\n      }\n\n      .cls-139 {\n        fill: #5f4655;\n      }\n\n      .cls-140 {\n        fill: #6e5564;\n      }\n\n      .cls-141 {\n        clip-path: url(#clip-path-81);\n      }\n\n      .cls-142 {\n        fill: #3c0a28;\n      }\n\n      .cls-143 {\n        opacity: 0.5;\n      }\n\n      .cls-144 {\n        clip-path: url(#clip-path-82);\n      }\n\n      .cls-145 {\n        fill: #644b5a;\n      }\n\n      .cls-146 {\n        fill: #b76d2c;\n      }\n\n      .cls-147 {\n        fill: #3c1623;\n      }\n\n      .cls-148 {\n        clip-path: url(#clip-path-83);\n      }\n\n      .cls-149 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-150 {\n        clip-path: url(#clip-path-85);\n      }\n\n      .cls-151 {\n        fill: #320b16;\n      }\n\n      .cls-152 {\n        clip-path: url(#clip-path-86);\n      }\n\n      .cls-153 {\n        clip-path: url(#clip-path-87);\n      }\n\n      .cls-154 {\n        clip-path: url(#clip-path-89);\n      }\n\n      .cls-155 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-156 {\n        clip-path: url(#clip-path-91);\n      }\n\n      .cls-157 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-158 {\n        clip-path: url(#clip-path-93);\n      }\n\n      .cls-159 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-160 {\n        clip-path: url(#clip-path-94);\n      }\n\n      .cls-161 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-162 {\n        fill: #73434f;\n      }\n\n      .cls-163 {\n        clip-path: url(#clip-path-96);\n      }\n\n      .cls-164 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-165 {\n        opacity: 0.95;\n      }\n\n      .cls-166 {\n        clip-path: url(#clip-path-98);\n      }\n\n      .cls-167 {\n        clip-path: url(#clip-path-99);\n      }\n\n      .cls-168 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-169 {\n        clip-path: url(#clip-path-101);\n      }\n\n      .cls-170 {\n        clip-path: url(#clip-path-102);\n      }\n\n      .cls-171 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-172 {\n        fill: #633442;\n      }\n\n      .cls-173 {\n        clip-path: url(#clip-path-104);\n      }\n\n      .cls-174 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-175 {\n        clip-path: url(#clip-path-106);\n      }\n\n      .cls-176 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-177 {\n        clip-path: url(#clip-path-108);\n      }\n\n      .cls-178 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-179 {\n        clip-path: url(#clip-path-110);\n      }\n\n      .cls-180 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-181 {\n        clip-path: url(#clip-path-112);\n      }\n\n      .cls-182 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-183 {\n        clip-path: url(#clip-path-114);\n      }\n\n      .cls-184 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-185 {\n        clip-path: url(#clip-path-116);\n      }\n\n      .cls-186 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-187 {\n        clip-path: url(#clip-path-118);\n      }\n\n      .cls-188 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-189 {\n        clip-path: url(#clip-path-119);\n      }\n\n      .cls-190 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-191 {\n        fill: #8a6c73;\n      }\n\n      .cls-192 {\n        clip-path: url(#clip-path-121);\n      }\n\n      .cls-193 {\n        fill: #32000a;\n      }\n\n      .cls-194 {\n        fill: #a08387;\n      }\n\n      .cls-195 {\n        clip-path: url(#clip-path-122);\n      }\n\n      .cls-196 {\n        clip-path: url(#clip-path-126);\n      }\n\n      .cls-197 {\n        fill: #552838;\n      }\n\n      .cls-198 {\n        fill: #5c2f40;\n      }\n\n      .cls-199 {\n        clip-path: url(#clip-path-127);\n      }\n\n      .cls-200 {\n        fill: #8d5c68;\n      }\n\n      .cls-201 {\n        opacity: 0.2;\n      }\n\n      .cls-202 {\n        clip-path: url(#clip-path-128);\n      }\n\n      .cls-203 {\n        clip-path: url(#clip-path-129);\n      }\n\n      .cls-204 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-205 {\n        clip-path: url(#clip-path-131);\n      }\n\n      .cls-206 {\n        clip-path: url(#clip-path-132);\n      }\n\n      .cls-207 {\n        clip-path: url(#clip-path-133);\n      }\n\n      .cls-208 {\n        clip-path: url(#clip-path-134);\n      }\n\n      .cls-209 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-210 {\n        clip-path: url(#clip-path-136);\n      }\n\n      .cls-211 {\n        fill: #861616;\n      }\n\n      .cls-212 {\n        opacity: 0.35;\n      }\n\n      .cls-213 {\n        clip-path: url(#clip-path-137);\n      }\n\n      .cls-214 {\n        fill: #ca8530;\n      }\n\n      .cls-215 {\n        fill: #502131;\n      }\n\n      .cls-216 {\n        fill: #fdd952;\n      }\n\n      .cls-217 {\n        clip-path: url(#clip-path-139);\n      }\n\n      .cls-218 {\n        clip-path: url(#clip-path-140);\n      }\n\n      .cls-219 {\n        fill: #e5b33d;\n      }\n\n      .cls-220 {\n        clip-path: url(#clip-path-141);\n      }\n\n      .cls-221 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-222 {\n        clip-path: url(#clip-path-142);\n      }\n\n      .cls-223 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-224 {\n        clip-path: url(#clip-path-144);\n      }\n\n      .cls-225 {\n        clip-path: url(#clip-path-145);\n      }\n\n      .cls-226 {\n        fill: #e9bb32;\n      }\n\n      .cls-227 {\n        clip-path: url(#clip-path-146);\n      }\n\n      .cls-228 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-229 {\n        opacity: 0.39;\n      }\n\n      .cls-230 {\n        clip-path: url(#clip-path-148);\n      }\n\n      .cls-231 {\n        clip-path: url(#clip-path-149);\n      }\n\n      .cls-232 {\n        clip-path: url(#clip-path-150);\n      }\n\n      .cls-233 {\n        opacity: 0.44;\n      }\n\n      .cls-234 {\n        clip-path: url(#clip-path-152);\n      }\n\n      .cls-235 {\n        clip-path: url(#clip-path-153);\n      }\n\n      .cls-236 {\n        opacity: 0.46;\n      }\n\n      .cls-237 {\n        clip-path: url(#clip-path-154);\n      }\n\n      .cls-238 {\n        clip-path: url(#clip-path-170);\n      }\n\n      .cls-239 {\n        clip-path: url(#clip-path-171);\n      }\n\n      .cls-240 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-241 {\n        fill: #603240;\n      }\n\n      .cls-242 {\n        fill: #461e2d;\n      }\n\n      .cls-243 {\n        fill: #572939;\n      }\n\n      .cls-244 {\n        clip-path: url(#clip-path-173);\n      }\n\n      .cls-245 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-246 {\n        clip-path: url(#clip-path-175);\n      }\n\n      .cls-247 {\n        fill: #58283b;\n      }\n\n      .cls-248 {\n        clip-path: url(#clip-path-176);\n      }\n\n      .cls-249 {\n        clip-path: url(#clip-path-177);\n      }\n\n      .cls-250 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-251 {\n        clip-path: url(#clip-path-179);\n      }\n\n      .cls-252 {\n        clip-path: url(#clip-path-180);\n      }\n\n      .cls-253 {\n        fill: #552737;\n      }\n\n      .cls-254 {\n        clip-path: url(#clip-path-181);\n      }\n\n      .cls-255 {\n        fill: #623342;\n      }\n\n      .cls-256 {\n        clip-path: url(#clip-path-183);\n      }\n\n      .cls-257 {\n        clip-path: url(#clip-path-184);\n      }\n\n      .cls-258 {\n        clip-path: url(#clip-path-186);\n      }\n\n      .cls-259 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-260 {\n        clip-path: url(#clip-path-187);\n      }\n\n      .cls-261 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-262 {\n        clip-path: url(#clip-path-189);\n      }\n\n      .cls-263 {\n        clip-path: url(#clip-path-190);\n      }\n\n      .cls-264 {\n        clip-path: url(#clip-path-191);\n      }\n\n      .cls-265 {\n        clip-path: url(#clip-path-192);\n      }\n\n      .cls-266 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-267 {\n        clip-path: url(#clip-path-193);\n      }\n\n      .cls-268 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-269 {\n        fill: #cd8830;\n      }\n\n      .cls-270 {\n        clip-path: url(#clip-path-195);\n      }\n\n      .cls-271 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-272 {\n        fill: #89696c;\n      }\n\n      .cls-273 {\n        fill: #d59838;\n      }\n\n      .cls-274 {\n        fill: #937376;\n      }\n\n      .cls-275 {\n        clip-path: url(#clip-path-197);\n      }\n\n      .cls-276 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-277 {\n        clip-path: url(#clip-path-198);\n      }\n\n      .cls-278 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-279 {\n        fill: #c0772a;\n      }\n\n      .cls-280 {\n        clip-path: url(#clip-path-200);\n      }\n\n      .cls-281 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-282 {\n        opacity: 0.33;\n      }\n\n      .cls-283 {\n        clip-path: url(#clip-path-202);\n      }\n\n      .cls-284 {\n        clip-path: url(#clip-path-203);\n      }\n\n      .cls-285 {\n        clip-path: url(#clip-path-204);\n      }\n\n      .cls-286 {\n        clip-path: url(#clip-path-205);\n      }\n\n      .cls-287 {\n        clip-path: url(#clip-path-206);\n      }\n\n      .cls-288 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-289 {\n        fill: #d0b6b3;\n      }\n\n      .cls-290 {\n        clip-path: url(#clip-path-208);\n      }\n\n      .cls-291 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-292 {\n        fill: #d7c9c2;\n      }\n\n      .cls-293 {\n        opacity: 0.85;\n      }\n\n      .cls-294 {\n        clip-path: url(#clip-path-210);\n      }\n\n      .cls-295 {\n        clip-path: url(#clip-path-211);\n      }\n\n      .cls-296 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-297 {\n        clip-path: url(#clip-path-212);\n      }\n\n      .cls-298 {\n        clip-path: url(#clip-path-213);\n      }\n\n      .cls-299 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-300 {\n        clip-path: url(#clip-path-214);\n      }\n\n      .cls-301 {\n        fill: #ffa831;\n      }\n\n      .cls-302 {\n        clip-path: url(#clip-path-215);\n      }\n\n      .cls-303 {\n        clip-path: url(#clip-path-217);\n      }\n\n      .cls-304 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-305 {\n        clip-path: url(#clip-path-219);\n      }\n\n      .cls-306 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-307 {\n        clip-path: url(#clip-path-222);\n      }\n\n      .cls-308 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-309 {\n        clip-path: url(#clip-path-224);\n      }\n\n      .cls-310 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-311 {\n        fill: #f5cd3c;\n      }\n\n      .cls-312 {\n        clip-path: url(#clip-path-226);\n      }\n\n      .cls-313 {\n        clip-path: url(#clip-path-227);\n      }\n\n      .cls-314 {\n        fill: #691616;\n      }\n\n      .cls-315 {\n        fill: #ffe369;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25266",
    "data-name": "Rectangle 25266",
    className: "cls-1",
    width: 200,
    height: 141.409
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71157",
    "data-name": "Path 71157",
    className: "cls-1",
    d: "M263.813,2.085l76.163,44.26a.922.922,0,0,1,.934-.065L264.748,2.019a.747.747,0,0,0-.379-.1,1.119,1.119,0,0,0-.556.164",
    transform: "translate(-263.813 -1.921)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71165",
    "data-name": "Path 71165",
    className: "cls-1",
    d: "M242.2,3.2c-2.733,4.706-5.557,9.456-8.632,13.924-1.436,2.095-2.664,4.339-4.1,6.431a41.684,41.684,0,0,1-3.117,4.708q-.194.212-.4.41c-1.037.991-1.084,2.408-.535,2.8l.046.03L301.62,75.766c-.015-.009-.03-.02-.046-.031-.549-.394-.5-1.81.535-2.8q.21-.2.4-.411a41.728,41.728,0,0,0,3.119-4.708c1.441-2.091,2.669-4.336,4.1-6.43,3.074-4.469,5.9-9.218,8.631-13.924a2.48,2.48,0,0,1,.855-.926L243.058,2.274a2.473,2.473,0,0,0-.854.926",
    transform: "translate(-225.065 -2.274)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71172",
    "data-name": "Path 71172",
    className: "cls-1",
    d: "M199.513,58.088l76.163,44.261c3.192-1.843,5.981-1.417,8.722-.991a18.742,18.742,0,0,0,4.426.334L212.662,57.431a18.743,18.743,0,0,1-4.426-.334,23.412,23.412,0,0,0-3.619-.369,9.84,9.84,0,0,0-5.1,1.36",
    transform: "translate(-199.513 -56.728)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71185",
    "data-name": "Path 71185",
    className: "cls-1",
    d: "M181.133,61.165c-2.149,2.607-4.3,5.171-6.262,8.015-1.051,1.522-2.032,3.063-3.175,4.491-.822,1.031-1.352,2.152-2.143,3.1a5.847,5.847,0,0,1-.869.851c-1.126.883-1.13,2.325-.487,2.7l76.162,44.261c-.643-.373-.639-1.818.488-2.7a5.82,5.82,0,0,0,.868-.851c.791-.943,1.321-2.064,2.142-3.1,1.144-1.427,2.125-2.968,3.176-4.49,1.964-2.845,4.113-5.409,6.261-8.015a2.377,2.377,0,0,1,.625-.558l-76.162-44.26a2.365,2.365,0,0,0-.625.557",
    transform: "translate(-167.765 -60.608)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71203",
    "data-name": "Path 71203",
    className: "cls-1",
    d: "M25.981,134.067c-1.27.733-1.555,2.648-.864,3.05l76.163,44.261c-.691-.4-.406-2.318.864-3.051l66.966-38.664L92.948,95.4,25.981,134.067",
    transform: "translate(-24.751 -95.404)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23474",
    "data-name": "Rectangle 23474",
    className: "cls-1",
    width: 58.331,
    height: 42.534
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23251",
    "data-name": "Rectangle 23251",
    className: "cls-1",
    width: 24.311,
    height: 21.075
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23252",
    "data-name": "Rectangle 23252",
    className: "cls-1",
    width: 12.539,
    height: 7.161
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23253",
    "data-name": "Rectangle 23253",
    className: "cls-1",
    width: 31.041,
    height: 13.852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62279",
    "data-name": "Path 62279",
    className: "cls-1",
    d: "M60.114,312.038l2.8-1.615a4.053,4.053,0,0,1,.057-.686,2.715,2.715,0,0,0-.935-.181c-1.138,0-1.918.9-1.918,2.482",
    transform: "translate(-60.114 -309.556)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.822,
    y1: 7.034,
    x2: -0.806,
    y2: 7.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62280",
    "data-name": "Path 62280",
    className: "cls-1",
    d: "M74.818,296.174l-2.8,1.615c-1.107.639-1.107,2.71,0,4.627s2.9,2.952,4.007,2.314l2.8-1.615c1.107-.639,1.107-2.711,0-4.627-.885-1.533-2.21-2.5-3.271-2.5a1.454,1.454,0,0,0-.736.189",
    transform: "translate(-71.192 -295.985)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.168,
    y1: 2.139,
    x2: -0.164,
    y2: 2.139,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#6e3f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62281",
    "data-name": "Path 62281",
    className: "cls-1",
    d: "M94.682,296.174l-2.406,1.389c.881-.509,2.948.483,4.068,2.278,1.182,1.895,1.2,3.936-.107,4.689l2.452-1.415c1.107-.639,1.107-2.711,0-4.627-.885-1.533-2.21-2.5-3.271-2.5a1.454,1.454,0,0,0-.736.189",
    transform: "translate(-92.276 -295.985)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.344,
    y1: 2.392,
    x2: -0.339,
    y2: 2.392,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#582a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62284",
    "data-name": "Path 62284",
    className: "cls-1",
    d: "M93.75,352.518c-.607.35-.607,1.486,0,2.537s1.59,1.619,2.2,1.269.607-1.486,0-2.537a2.433,2.433,0,0,0-1.793-1.372.8.8,0,0,0-.4.1",
    transform: "translate(-93.295 -352.415)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.868,
    y1: 4.207,
    x2: -0.857,
    y2: 4.207,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2efe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#a57d82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e6e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23260",
    "data-name": "Rectangle 23260",
    className: "cls-1",
    width: 0.924,
    height: 0.453
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23261",
    "data-name": "Rectangle 23261",
    className: "cls-1",
    width: 1.054,
    height: 2.507
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23262",
    "data-name": "Rectangle 23262",
    className: "cls-1",
    width: 0.079,
    height: 0.286
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23263",
    "data-name": "Rectangle 23263",
    className: "cls-1",
    width: 0.44,
    height: 0.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23264",
    "data-name": "Rectangle 23264",
    className: "cls-1",
    width: 2.567,
    height: 3.755
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62291",
    "data-name": "Path 62291",
    className: "cls-1",
    d: "M111,386.438l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.14l.125-.072c.067-.039.067-.165,0-.281a.27.27,0,0,0-.2-.152.088.088,0,0,0-.045.011",
    transform: "translate(-110.829 -386.427)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -8.907,
    y1: 28.032,
    x2: -8.826,
    y2: 28.032,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62293",
    "data-name": "Path 62293",
    className: "cls-1",
    d: "M105.527,368.009l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.14l.125-.072c.067-.039.067-.165,0-.281a.269.269,0,0,0-.2-.152.088.088,0,0,0-.045.011",
    transform: "translate(-105.352 -367.998)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -8.459,
    y1: 29.509,
    x2: -8.377,
    y2: 29.509,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#643241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62295",
    "data-name": "Path 62295",
    className: "cls-1",
    d: "M124.226,400.4l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.14l.125-.072c.067-.039.067-.165,0-.281a.269.269,0,0,0-.2-.152.087.087,0,0,0-.045.011",
    transform: "translate(-124.051 -400.385)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -9.99,
    y1: 26.913,
    x2: -9.908,
    y2: 26.913,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62297",
    "data-name": "Path 62297",
    className: "cls-1",
    d: "M108.761,366.462l-.507.293c-.273.158-.273.669,0,1.142s.716.729.989.571l.507-.292c.273-.158.273-.669,0-1.142a1.1,1.1,0,0,0-.807-.618.358.358,0,0,0-.182.047",
    transform: "translate(-108.049 -366.415)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2.009,
    y1: 7.387,
    x2: -1.989,
    y2: 7.387,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62298",
    "data-name": "Path 62298",
    className: "cls-1",
    d: "M116.676,366.462l-.225.13c.273-.158.784.058,1.142.483a1.54,1.54,0,0,1,.246.394,1.587,1.587,0,0,0-.174-.436,1.1,1.1,0,0,0-.807-.618.358.358,0,0,0-.182.047",
    transform: "translate(-116.451 -366.415)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -4.858,
    y1: 20.242,
    x2: -4.816,
    y2: 20.242,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62300",
    "data-name": "Path 62300",
    className: "cls-1",
    d: "M111,355.9l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.141l.125-.072c.067-.039.067-.165,0-.281a.27.27,0,0,0-.2-.152.089.089,0,0,0-.045.011",
    transform: "translate(-110.829 -355.892)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -8.907,
    y1: 30.478,
    x2: -8.825,
    y2: 30.478,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62305",
    "data-name": "Path 62305",
    className: "cls-1",
    d: "M142.8,390.229c-.067.039-.067.165,0,.281a.291.291,0,0,0,.179.15,2.854,2.854,0,0,0-.094-.48Z",
    transform: "translate(-142.749 -390.18)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -17.97,
    y1: 37.057,
    x2: -17.843,
    y2: 37.057,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62307",
    "data-name": "Path 62307",
    className: "cls-1",
    d: "M137.448,401.705l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.141l.125-.072c.067-.039.067-.165,0-.281a.27.27,0,0,0-.2-.152.088.088,0,0,0-.045.012",
    transform: "translate(-137.273 -401.694)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -11.074,
    y1: 26.809,
    x2: -10.992,
    y2: 26.809,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62309",
    "data-name": "Path 62309",
    className: "cls-1",
    d: "M180.013,356.908l-2.8,1.615c-1.107.639-1.107,2.711,0,4.627s2.9,2.952,4.007,2.314l2.8-1.615c1.107-.639,1.107-2.711,0-4.627-.885-1.533-2.21-2.5-3.271-2.5a1.454,1.454,0,0,0-.736.189",
    transform: "translate(-176.386 -356.719)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.656,
    y1: 1.86,
    x2: -0.651,
    y2: 1.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62310",
    "data-name": "Path 62310",
    className: "cls-1",
    d: "M199.877,356.908l-2.406,1.389c.881-.509,2.948.483,4.068,2.278,1.182,1.895,1.2,3.936-.107,4.689l2.452-1.416c1.107-.639,1.107-2.711,0-4.627-.885-1.533-2.21-2.5-3.271-2.5a1.454,1.454,0,0,0-.736.189",
    transform: "translate(-197.471 -356.719)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.909,
    y1: 2.077,
    x2: -0.904,
    y2: 2.077,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62313",
    "data-name": "Path 62313",
    className: "cls-1",
    d: "M198.945,413.252c-.607.35-.607,1.486,0,2.537s1.59,1.619,2.2,1.269.607-1.486,0-2.537a2.434,2.434,0,0,0-1.793-1.372.8.8,0,0,0-.4.1",
    transform: "translate(-198.489 -413.149)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -2.067,
    y1: 3.555,
    x2: -2.055,
    y2: 3.555,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62320",
    "data-name": "Path 62320",
    className: "cls-1",
    d: "M216.2,447.172l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.14l.125-.072c.067-.039.067-.165,0-.281a.27.27,0,0,0-.2-.152.089.089,0,0,0-.045.011",
    transform: "translate(-216.024 -447.161)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -17.521,
    y1: 23.161,
    x2: -17.439,
    y2: 23.161,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62322",
    "data-name": "Path 62322",
    className: "cls-1",
    d: "M210.722,428.743l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.141l.125-.072c.067-.039.067-.165,0-.281a.27.27,0,0,0-.2-.152.088.088,0,0,0-.045.011",
    transform: "translate(-210.547 -428.732)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -17.072,
    y1: 24.639,
    x2: -16.99,
    y2: 24.639,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62324",
    "data-name": "Path 62324",
    className: "cls-1",
    d: "M229.421,461.13l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.141l.125-.072c.067-.039.067-.165,0-.281a.27.27,0,0,0-.2-.152.089.089,0,0,0-.045.011",
    transform: "translate(-229.246 -461.119)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -18.605,
    y1: 22.043,
    x2: -18.523,
    y2: 22.043,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62326",
    "data-name": "Path 62326",
    className: "cls-1",
    d: "M213.955,427.2l-.507.293c-.273.158-.273.669,0,1.142s.716.729.989.571l.507-.293c.273-.158.273-.669,0-1.142a1.1,1.1,0,0,0-.807-.618.36.36,0,0,0-.182.047",
    transform: "translate(-213.244 -427.15)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -4.129,
    y1: 6.189,
    x2: -4.109,
    y2: 6.189,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62327",
    "data-name": "Path 62327",
    className: "cls-1",
    d: "M221.871,427.2l-.225.13c.273-.158.784.058,1.142.483a1.541,1.541,0,0,1,.246.394,1.586,1.586,0,0,0-.174-.435,1.1,1.1,0,0,0-.807-.618.36.36,0,0,0-.182.047",
    transform: "translate(-221.646 -427.15)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -9.246,
    y1: 16.903,
    x2: -9.205,
    y2: 16.903,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62329",
    "data-name": "Path 62329",
    className: "cls-1",
    d: "M216.2,416.638l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.141l.125-.072c.067-.039.067-.165,0-.281a.27.27,0,0,0-.2-.152.088.088,0,0,0-.045.011",
    transform: "translate(-216.024 -416.627)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -17.523,
    y1: 25.612,
    x2: -17.441,
    y2: 25.612,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62334",
    "data-name": "Path 62334",
    className: "cls-1",
    d: "M247.995,450.964c-.067.039-.067.165,0,.281a.29.29,0,0,0,.179.15,2.834,2.834,0,0,0-.094-.48Z",
    transform: "translate(-247.944 -450.915)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -31.416,
    y1: 30.537,
    x2: -31.288,
    y2: 30.537,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62336",
    "data-name": "Path 62336",
    className: "cls-1",
    d: "M242.642,462.44l-.125.072c-.067.039-.067.165,0,.281s.176.179.243.141l.125-.072c.067-.039.067-.165,0-.281a.27.27,0,0,0-.2-.152.088.088,0,0,0-.045.011",
    transform: "translate(-242.467 -462.429)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -19.686,
    y1: 21.937,
    x2: -19.604,
    y2: 21.937,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62339",
    "data-name": "Path 62339",
    className: "cls-1",
    d: "M175.911,317.626l-.391.153-2.8,1.615.391-.153a1.2,1.2,0,0,1,1.022.16l3.473,2.005a2.39,2.39,0,0,1,.891,1.021l.944,1.96a2.2,2.2,0,0,1,.234.928v2.053l2.8-1.615V323.7a2.2,2.2,0,0,0-.234-.928l-.944-1.96a2.392,2.392,0,0,0-.891-1.021l-3.473-2.005a1.448,1.448,0,0,0-.71-.216.848.848,0,0,0-.311.056",
    transform: "translate(-172.723 -317.57)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -0.616,
    y1: 1.942,
    x2: -0.612,
    y2: 1.942,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#6a3b48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#5e303f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23307",
    "data-name": "Rectangle 23307",
    className: "cls-1",
    width: 9.233,
    height: 8.603
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62341",
    "data-name": "Path 62341",
    className: "cls-1",
    d: "M74.483,257.556l.014-.008-.014.008m2.8-1.615h0L74.5,257.548a.8.8,0,0,1,.789.082l3.473,2.005a3.156,3.156,0,0,1,1.022,1.02l.391.6,2.8-1.615-.391-.6a3.157,3.157,0,0,0-1.022-1.02l-3.473-2.005a1.024,1.024,0,0,0-.5-.153.576.576,0,0,0-.3.079",
    transform: "translate(-74.483 -255.862)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -0.352,
    y1: 3.306,
    x2: -0.346,
    y2: 3.306,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a3b48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23310",
    "data-name": "Rectangle 23310",
    className: "cls-1",
    width: 8.133,
    height: 5.098
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23314",
    "data-name": "Rectangle 23314",
    className: "cls-1",
    width: 7.573,
    height: 4.159
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23315",
    "data-name": "Rectangle 23315",
    className: "cls-1",
    width: 3.573,
    height: 3.375
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23316",
    "data-name": "Rectangle 23316",
    className: "cls-1",
    width: 6.594,
    height: 3.807
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23317",
    "data-name": "Rectangle 23317",
    className: "cls-1",
    width: 2.624,
    height: 6.262
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23318",
    "data-name": "Rectangle 23318",
    className: "cls-1",
    width: 6.245,
    height: 1.985
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23319",
    "data-name": "Rectangle 23319",
    className: "cls-1",
    width: 5.811,
    height: 4.646
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62373",
    "data-name": "Path 62373",
    className: "cls-1",
    d: "M803.428,319.914l-.921.532a.466.466,0,0,0-.211.365v2.557a.148.148,0,0,0,.062.137l.271.157,1.218-3.607-.272-.157a.109.109,0,0,0-.054-.014.19.19,0,0,0-.094.029",
    transform: "translate(-802.296 -319.885)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -11.167,
    y1: 7.363,
    x2: -11.153,
    y2: 7.363,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#754654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e4150"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23322",
    "data-name": "Rectangle 23322",
    className: "cls-1",
    width: 0.461,
    height: 0.219
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62376",
    "data-name": "Path 62376",
    className: "cls-1",
    d: "M796.461,308.788a.516.516,0,0,0-.115.049h0l-.781.451.014.025.014.025.021.036.021.036.021.036.021.036.02.034.02.034.02.034.02.034.781-.451h0a.3.3,0,0,1,.031-.015h0v0a.319.319,0,0,1,0,.035h0v.6h.379v-.6a0,0,0,0,0,0,0,.524.524,0,0,0-.014-.122.419.419,0,0,0-.061-.142.367.367,0,0,0-.112-.106.375.375,0,0,0-.147-.046h-.031a.407.407,0,0,0-.124.019",
    transform: "translate(-795.564 -308.769)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23325",
    "data-name": "Rectangle 23325",
    className: "cls-1",
    width: 1.386,
    height: 1.017
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62378",
    "data-name": "Path 62378",
    className: "cls-1",
    d: "M812.967,316.294c0,.06.085.109.189.109a.251.251,0,0,0,.154-.046,1.541,1.541,0,0,1-.343-.68Z",
    transform: "translate(-812.967 -315.677)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -137.279,
    y1: 33.409,
    x2: -137.11,
    y2: 33.409,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62380",
    "data-name": "Path 62380",
    className: "cls-1",
    d: "M434.9,521.632c-1.194-.055-2.024.859-2.024,2.477l2.137-1.234a3.287,3.287,0,0,1,.292-1.441Z",
    transform: "translate(-432.875 -521.434)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -7.138,
    y1: 3.616,
    x2: -7.121,
    y2: 3.616,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62384",
    "data-name": "Path 62384",
    className: "cls-1",
    d: "M446.919,517.973l-2.137,1.234c-1.107.639-1.107,2.711,0,4.627s2.9,2.952,4.007,2.313l2.137-1.234c1.107-.639,1.107-2.711,0-4.627-.885-1.533-2.21-2.5-3.271-2.5a1.455,1.455,0,0,0-.737.189",
    transform: "translate(-443.952 -517.784)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2.022,
    y1: 1.172,
    x2: -2.017,
    y2: 1.172,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62385",
    "data-name": "Path 62385",
    className: "cls-1",
    d: "M466.783,517.973l-1.746,1.008c.881-.509,2.948.483,4.068,2.278,1.182,1.895,1.2,3.936-.107,4.689l1.792-1.034c1.107-.639,1.107-2.711,0-4.627-.885-1.533-2.21-2.5-3.271-2.5a1.455,1.455,0,0,0-.736.189",
    transform: "translate(-465.037 -517.784)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -2.529,
    y1: 1.306,
    x2: -2.523,
    y2: 1.306,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62388",
    "data-name": "Path 62388",
    className: "cls-1",
    d: "M466.511,567.735c-.607.35-.607,1.486,0,2.537s1.591,1.619,2.2,1.268.607-1.486,0-2.537a2.433,2.433,0,0,0-1.793-1.372.8.8,0,0,0-.4.1",
    transform: "translate(-466.056 -567.632)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -5.114,
    y1: 1.897,
    x2: -5.103,
    y2: 1.897,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23336",
    "data-name": "Rectangle 23336",
    className: "cls-1",
    width: 2.839,
    height: 3.874
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62391",
    "data-name": "Path 62391",
    className: "cls-1",
    d: "M473.289,570.959c-.451.26-.451,1.1,0,1.885s1.182,1.2,1.633.943l.735-.424a3.385,3.385,0,0,0-1.633-2.828Z",
    transform: "translate(-472.951 -570.535)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -6.306,
    y1: 2.235,
    x2: -6.292,
    y2: 2.235,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23339",
    "data-name": "Rectangle 23339",
    className: "cls-1",
    width: 2.129,
    height: 3.113
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62394",
    "data-name": "Path 62394",
    className: "cls-1",
    d: "M490.163,582.237a.348.348,0,0,0,.158.273c.087.05.158.01.158-.091a.348.348,0,0,0-.158-.273.143.143,0,0,0-.07-.022c-.052,0-.087.041-.087.113",
    transform: "translate(-490.163 -582.124)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -73.376,
    y1: 18.278,
    x2: -73.226,
    y2: 18.278,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#a28283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62396",
    "data-name": "Path 62396",
    className: "cls-1",
    d: "M490.163,615.514a.348.348,0,0,0,.158.273c.087.05.158.01.158-.091a.349.349,0,0,0-.158-.273.143.143,0,0,0-.07-.021c-.052,0-.087.041-.087.113",
    transform: "translate(-490.163 -615.402)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -73.376,
    y1: 14.298,
    x2: -73.226,
    y2: 14.298,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62398",
    "data-name": "Path 62398",
    className: "cls-1",
    d: "M504.572,607.2a.349.349,0,0,0,.158.273c.087.05.158.009.158-.091a.348.348,0,0,0-.158-.273.142.142,0,0,0-.07-.022c-.052,0-.087.041-.087.113",
    transform: "translate(-504.572 -607.083)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -75.537,
    y1: 15.295,
    x2: -75.387,
    y2: 15.295,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62400",
    "data-name": "Path 62400",
    className: "cls-1",
    d: "M475.754,590.557a.349.349,0,0,0,.158.273c.087.05.158.009.158-.091a.348.348,0,0,0-.158-.273.143.143,0,0,0-.07-.022c-.052,0-.087.041-.087.113",
    transform: "translate(-475.754 -590.444)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -71.228,
    y1: 17.285,
    x2: -71.078,
    y2: 17.285,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62402",
    "data-name": "Path 62402",
    className: "cls-1",
    d: "M500.4,592.891c-.062.036-.062.151,0,.257s.161.164.223.129.062-.151,0-.258a.247.247,0,0,0-.182-.139.08.08,0,0,0-.041.011",
    transform: "translate(-500.353 -592.88)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -69.531,
    y1: 16.938,
    x2: -69.392,
    y2: 16.938,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62404",
    "data-name": "Path 62404",
    className: "cls-1",
    d: "M480.02,604.656c-.062.036-.062.151,0,.257s.161.164.223.129.062-.151,0-.257a.247.247,0,0,0-.182-.139.081.081,0,0,0-.041.011",
    transform: "translate(-479.974 -604.645)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -66.683,
    y1: 15.534,
    x2: -66.544,
    y2: 15.534,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62406",
    "data-name": "Path 62406",
    className: "cls-1",
    d: "M500.4,616.422c-.062.036-.062.151,0,.257s.161.164.223.129.062-.151,0-.258a.247.247,0,0,0-.182-.139.08.08,0,0,0-.041.011",
    transform: "translate(-500.353 -616.411)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -69.531,
    y1: 14.133,
    x2: -69.392,
    y2: 14.133,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62408",
    "data-name": "Path 62408",
    className: "cls-1",
    d: "M480.02,581.126c-.062.036-.062.151,0,.258s.161.164.223.129.062-.151,0-.258a.247.247,0,0,0-.182-.139.08.08,0,0,0-.041.01",
    transform: "translate(-479.974 -581.115)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -66.684,
    y1: 18.34,
    x2: -66.545,
    y2: 18.34,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62410",
    "data-name": "Path 62410",
    className: "cls-1",
    d: "M485.436,592.521c-.171.1-.171.42,0,.717s.449.457.621.358.171-.42,0-.717a.687.687,0,0,0-.507-.388.226.226,0,0,0-.114.029",
    transform: "translate(-485.307 -592.492)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.491,
    cy: 1.119,
    r: 0.99,
    gradientTransform: "matrix(1.249, 0, 0, -1, 7.246, 13.671)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62411",
    "data-name": "Path 62411",
    className: "cls-1",
    d: "M450.539,468.422l3.637,2.1a6.708,6.708,0,0,1,3.035,5.256v3.994l1.308-.755V475.2l-1.183-.683a6.8,6.8,0,0,0-2.9-4.141l-3.637-2.1Z",
    transform: "translate(-450.539 -468.272)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -1.937,
    y1: 1.196,
    x2: -1.932,
    y2: 1.196,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ca8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c17a2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23359",
    "data-name": "Rectangle 23359",
    className: "cls-1",
    width: 0.26,
    height: 0.709
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23360",
    "data-name": "Rectangle 23360",
    className: "cls-1",
    width: 3.806,
    height: 2.121
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23364",
    "data-name": "Rectangle 23364",
    className: "cls-1",
    width: 3.546,
    height: 1.856
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23365",
    "data-name": "Rectangle 23365",
    className: "cls-1",
    width: 1.936,
    height: 4.429
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23366",
    "data-name": "Rectangle 23366",
    className: "cls-1",
    width: 1.936,
    height: 3.121
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62431",
    "data-name": "Path 62431",
    className: "cls-1",
    d: "M492,383.125v2.031a1.514,1.514,0,0,0,.685,1.186l1.251.722v-.184l-1.092-.631a1.514,1.514,0,0,1-.685-1.186v-2.031a.542.542,0,0,1,.128-.385c-.174.043-.287.212-.287.477",
    transform: "translate(-492.004 -382.648)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -7.341,
    y1: 4.278,
    x2: -7.325,
    y2: 4.278,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe166"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23369",
    "data-name": "Rectangle 23369",
    className: "cls-1",
    width: 0.32,
    height: 0.716
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23370",
    "data-name": "Rectangle 23370",
    className: "cls-1",
    width: 4.081,
    height: 6.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23371",
    "data-name": "Rectangle 23371",
    className: "cls-1",
    width: 3.316,
    height: 3.705
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62436",
    "data-name": "Path 62436",
    className: "cls-1",
    d: "M539.034,465.285l2.021,1.167a1.318,1.318,0,0,1,.491.563l.183.379a1.319,1.319,0,0,0,.491.563l.643.371c.113.066.206.033.239-.061a.257.257,0,0,1-.079-.031l-.643-.371a1.319,1.319,0,0,1-.492-.563l-.183-.379a1.318,1.318,0,0,0-.491-.563l-2.021-1.167Z",
    transform: "translate(-539.034 -465.193)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -5.99,
    y1: 3.413,
    x2: -5.979,
    y2: 3.413,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#e1a839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#e1a839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe166"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23374",
    "data-name": "Rectangle 23374",
    className: "cls-1",
    width: 0.318,
    height: 0.092
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23375",
    "data-name": "Rectangle 23375",
    className: "cls-1",
    width: 1.508,
    height: 9.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23377",
    "data-name": "Rectangle 23377",
    className: "cls-1",
    width: 1.184,
    height: 1.056
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23378",
    "data-name": "Rectangle 23378",
    className: "cls-1",
    width: 1.234,
    height: 1.425
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62449",
    "data-name": "Path 62449",
    className: "cls-1",
    d: "M614.67,597.683l.45.259h.589l2.107-1.216-.744-.43Z",
    transform: "translate(-614.67 -596.297)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -9.978,
    y1: 2.892,
    x2: -9.962,
    y2: 2.892,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c78731"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62450",
    "data-name": "Path 62450",
    className: "cls-1",
    d: "M771.856,506.934l.744.43,2.107-1.216v-.34l-.449-.259Z",
    transform: "translate(-771.856 -505.548)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -13.158,
    y1: 4.621,
    x2: -13.14,
    y2: 4.621,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23382",
    "data-name": "Rectangle 23382",
    className: "cls-1",
    width: 12.127,
    height: 6.954
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23383",
    "data-name": "Rectangle 23383",
    className: "cls-1",
    width: 3.564,
    height: 2.23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62481",
    "data-name": "Path 62481",
    className: "cls-1",
    d: "M584.014,299.636v.552a.319.319,0,0,0,.188.262l1.393.8a1,1,0,0,0,.908,0l2.587-1.494a.319.319,0,0,0,.188-.263v-.552Z",
    transform: "translate(-584.014 -298.946)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -6.424,
    y1: 10.281,
    x2: -6.413,
    y2: 10.281,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23386",
    "data-name": "Rectangle 23386",
    className: "cls-1",
    width: 0.385,
    height: 0.436
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23387",
    "data-name": "Rectangle 23387",
    className: "cls-1",
    width: 0.469,
    height: 0.106
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23388",
    "data-name": "Rectangle 23388",
    className: "cls-1",
    width: 0.385,
    height: 0.434
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23390",
    "data-name": "Rectangle 23390",
    className: "cls-1",
    width: 0.798,
    height: 0.296
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23391",
    "data-name": "Rectangle 23391",
    className: "cls-1",
    width: 0.798,
    height: 0.625
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23392",
    "data-name": "Rectangle 23392",
    className: "cls-1",
    width: 0.285,
    height: 0.329
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-170"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23408",
    "data-name": "Rectangle 23408",
    className: "cls-1",
    width: 11.428,
    height: 11.322
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62515",
    "data-name": "Path 62515",
    className: "cls-1",
    d: "M643.975,325.583l.924,4.641a1.056,1.056,0,0,1-.42,1.066l-9.319,5.38a.445.445,0,0,1-.36.051.424.424,0,0,0,.519.041l9.319-5.38a1.055,1.055,0,0,0,.42-1.066l-.956-4.806Z",
    transform: "translate(-634.8 -325.51)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -2.303,
    y1: 1.741,
    x2: -2.299,
    y2: 1.741,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b26827"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62529",
    "data-name": "Path 62529",
    className: "cls-1",
    d: "M599.014,541.028l1.037.6V539.05l-1.037-.6Z",
    transform: "translate(-599.014 -538.451)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -33.457,
    y1: 3.576,
    x2: -33.401,
    y2: 3.576,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8b33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad241"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23413",
    "data-name": "Rectangle 23413",
    className: "cls-1",
    width: 1.037,
    height: 2.383
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-176"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23414",
    "data-name": "Rectangle 23414",
    className: "cls-1",
    width: 0.844,
    height: 1.395
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62535",
    "data-name": "Path 62535",
    className: "cls-1",
    d: "M536.285,489.4v1.213l.346.2a.237.237,0,0,0,.242.022l.159-.092a.238.238,0,0,0,.1-.218v-.432a.748.748,0,0,0-.339-.586l-.346-.2Z",
    transform: "translate(-536.285 -489.304)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -20.774,
    y1: 8.051,
    x2: -20.735,
    y2: 8.051,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23417",
    "data-name": "Rectangle 23417",
    className: "cls-1",
    width: 0.799,
    height: 2.214
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-180"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23418",
    "data-name": "Rectangle 23418",
    className: "cls-1",
    width: 12.01,
    height: 7.389
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23419",
    "data-name": "Rectangle 23419",
    className: "cls-1",
    width: 11.795,
    height: 8.109
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62541",
    "data-name": "Path 62541",
    className: "cls-1",
    d: "M576.587,515.584h-.35v.6a.013.013,0,0,0,0,0,.517.517,0,0,0,.014.122.423.423,0,0,0,.061.142.368.368,0,0,0,.112.105.372.372,0,0,0,.147.046.419.419,0,0,0,.156-.017.509.509,0,0,0,.115-.049h0l.781-.451-.02-.034-.02-.034-.02-.034-.02-.034-.021-.036-.021-.036-.021-.036-.021-.036-.014-.025-.014-.025-.781.451h0a.279.279,0,0,1-.032.015h0v0c0-.005,0-.021,0-.034h0v-.6Z",
    transform: "translate(-576.237 -515.584)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23423",
    "data-name": "Rectangle 23423",
    className: "cls-1",
    width: 1.386,
    height: 1.019
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62543",
    "data-name": "Path 62543",
    className: "cls-1",
    d: "M596.272,518.361c-.052.03-.052.128,0,.219s.137.139.189.109.052-.128,0-.219a.21.21,0,0,0-.155-.118.069.069,0,0,0-.035.009",
    transform: "translate(-596.233 -518.352)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -78.63,
    y1: 27.041,
    x2: -78.498,
    y2: 27.041,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73434f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62544",
    "data-name": "Path 62544",
    className: "cls-1",
    d: "M566.7,456.591l-.921.532a.467.467,0,0,0-.211.366v2.557a.147.147,0,0,0,.063.137l.271.157,1.218-3.607-.272-.157a.108.108,0,0,0-.054-.014.19.19,0,0,0-.094.029",
    transform: "translate(-565.564 -456.562)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -7.781,
    y1: 4.909,
    x2: -7.767,
    y2: 4.909,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23427",
    "data-name": "Rectangle 23427",
    className: "cls-1",
    width: 0.745,
    height: 0.354
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62547",
    "data-name": "Path 62547",
    className: "cls-1",
    d: "M576.653,432.885h0a.9.9,0,0,0-.415.719v.6h.378v-.6h0a.526.526,0,0,1,.226-.392h0l.781-.451-.02-.034-.02-.034-.02-.034-.02-.034-.021-.036-.021-.036-.021-.036-.021-.036-.014-.025-.014-.025-.781.451",
    transform: "translate(-576.237 -432.434)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23430",
    "data-name": "Rectangle 23430",
    className: "cls-1",
    width: 1.386,
    height: 1.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62548",
    "data-name": "Path 62548",
    className: "cls-1",
    d: "M596.272,432.289c-.052.03-.052.128,0,.219s.137.14.189.109.052-.128,0-.219a.21.21,0,0,0-.155-.118.069.069,0,0,0-.035.009",
    transform: "translate(-596.233 -432.28)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -78.63,
    y1: 37.764,
    x2: -78.498,
    y2: 37.764,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62549",
    "data-name": "Path 62549",
    className: "cls-1",
    d: "M576.236,461.225c0,.06.085.109.189.109s.189-.049.189-.109-.085-.109-.189-.109-.189.049-.189.109",
    transform: "translate(-576.236 -461.116)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -88.123,
    y1: 72.428,
    x2: -87.97,
    y2: 72.428,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62555",
    "data-name": "Path 62555",
    className: "cls-1",
    d: "M789.98,448.016l-.844,3,.419-.242a1.629,1.629,0,0,0,.717-1.118l.258-1.961Z",
    transform: "translate(-789.136 -447.698)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -15.713,
    y1: 4.682,
    x2: -15.693,
    y2: 4.682,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62560",
    "data-name": "Path 62560",
    className: "cls-1",
    d: "M640.48,542.259l.258,1.663c.058.372.361.495.718.289l.419-.242-.844-2.028Z",
    transform: "translate(-640.48 -541.941)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -14.906,
    y1: 3.992,
    x2: -14.883,
    y2: 3.992,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62561",
    "data-name": "Path 62561",
    className: "cls-1",
    d: "M641.233,542.234l.789,1.895.562-.16-.844-2.028Z",
    transform: "translate(-641.233 -541.941)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -17.621,
    y1: 4.464,
    x2: -17.593,
    y2: 4.464,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf6e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c57c2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62578",
    "data-name": "Path 62578",
    className: "cls-1",
    d: "M789.98,451.114l-.844,3,.276-.325.789-2.805Z",
    transform: "translate(-789.136 -450.987)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -13.501,
    y1: 8.41,
    x2: -13.484,
    y2: 8.41,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-202"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23443",
    "data-name": "Rectangle 23443",
    className: "cls-1",
    width: 0.793,
    height: 0.436
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-203"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23444",
    "data-name": "Rectangle 23444",
    className: "cls-1",
    width: 0.672,
    height: 0.293
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-204"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23445",
    "data-name": "Rectangle 23445",
    className: "cls-1",
    width: 0.302,
    height: 0.227
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23446",
    "data-name": "Rectangle 23446",
    className: "cls-1",
    width: 1.188,
    height: 0.601
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62587",
    "data-name": "Path 62587",
    className: "cls-1",
    d: "M560.082,372.215v.221c0,.166.233.3.52.3s.521-.135.521-.3v-.221c0-.166-.233-.3-.521-.3s-.52.135-.52.3",
    transform: "translate(-560.082 -371.915)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -31.155,
    y1: 25.545,
    x2: -31.1,
    y2: 25.545,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62590",
    "data-name": "Path 62590",
    className: "cls-1",
    d: "M564.771,365.868c-.081.14-.081.29,0,.337l.092.053c.081.047.211-.029.292-.168s.081-.29,0-.337l-.092-.053a.107.107,0,0,0-.054-.014.323.323,0,0,0-.238.182",
    transform: "translate(-564.71 -365.686)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -40.256,
    y1: 27.431,
    x2: -40.185,
    y2: 27.431,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#f2efe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a87f80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-210"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23452",
    "data-name": "Rectangle 23452",
    className: "cls-1",
    width: 0.932,
    height: 1.221
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62592",
    "data-name": "Path 62592",
    className: "cls-1",
    d: "M561.9,360.668c0,.131-.184.238-.412.238s-.412-.106-.412-.238l-.054.952c0,.149.209.269.466.269s.466-.121.466-.269Z",
    transform: "translate(-561.021 -360.668)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -34.848,
    y1: 17.732,
    x2: -34.786,
    y2: 17.732,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb95f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#ffaf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#ffa825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#dd7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd7300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-212"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23454",
    "data-name": "Rectangle 23454",
    className: "cls-1",
    width: 0.823,
    height: 0.475
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62593",
    "data-name": "Path 62593",
    className: "cls-1",
    d: "M562.372,356.562c.183,0,.331.086.331.191s-.148.191-.331.191-.331-.086-.331-.191.148-.191.331-.191c-.227,0-.412.106-.412.238s.184.238.412.238.412-.106.412-.238-.184-.238-.412-.238",
    transform: "translate(-561.96 -356.562)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -39.516,
    y1: 46.032,
    x2: -39.446,
    y2: 46.032,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#ffaf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#ffa825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e27b06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-214"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23455",
    "data-name": "Rectangle 23455",
    className: "cls-1",
    width: 0.663,
    height: 0.383
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-215"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23456",
    "data-name": "Rectangle 23456",
    className: "cls-1",
    width: 0.678,
    height: 0.346
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62597",
    "data-name": "Path 62597",
    className: "cls-1",
    d: "M735.79,270.771v.221c0,.166.233.3.521.3s.52-.135.52-.3v-.221c0-.166-.233-.3-.52-.3s-.521.135-.521.3",
    transform: "translate(-735.79 -270.47)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -40.927,
    y1: 32.694,
    x2: -40.871,
    y2: 32.694,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62600",
    "data-name": "Path 62600",
    className: "cls-1",
    d: "M740.48,264.422c-.081.139-.081.29,0,.337l.092.053c.081.047.211-.029.292-.168s.081-.29,0-.337l-.092-.053a.107.107,0,0,0-.054-.014.323.323,0,0,0-.238.182",
    transform: "translate(-740.419 -264.24)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -52.841,
    y1: 34.947,
    x2: -52.769,
    y2: 34.947,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62602",
    "data-name": "Path 62602",
    className: "cls-1",
    d: "M737.607,259.222c0,.131-.184.238-.412.238s-.412-.106-.412-.238l-.055.952c0,.149.209.269.466.269s.466-.12.466-.269Z",
    transform: "translate(-736.729 -259.222)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -45.76,
    y1: 22.544,
    x2: -45.698,
    y2: 22.544,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62603",
    "data-name": "Path 62603",
    className: "cls-1",
    d: "M738.081,255.117c.183,0,.331.086.331.191s-.148.191-.331.191-.331-.086-.331-.191.148-.191.331-.191c-.227,0-.412.106-.412.238s.184.238.412.238.412-.106.412-.238-.184-.238-.412-.238",
    transform: "translate(-737.669 -255.117)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -51.872,
    y1: 58.394,
    x2: -51.802,
    y2: 58.394,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-226"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23467",
    "data-name": "Rectangle 23467",
    className: "cls-1",
    width: 21.733,
    height: 15.314
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-227"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23468",
    "data-name": "Rectangle 23468",
    className: "cls-1",
    width: 1.103,
    height: 0.594
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset_Tracking",
    "data-name": "Asset Tracking",
    transform: "translate(-986.467 -257.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67451",
    "data-name": "Group 67451",
    transform: "translate(993 267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67424",
    "data-name": "Group 67424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67423",
    "data-name": "Group 67423",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71102",
    "data-name": "Path 71102",
    className: "cls-3",
    d: "M235.73,288.447l-.022-.72c-.307.189-.627.371-.957.535.326.07.66.137.979.185",
    transform: "translate(-125.745 -154.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71103",
    "data-name": "Path 71103",
    className: "cls-4",
    d: "M99.123,163.906c5.6,6.964,27.7,23.522,44.917,32.09,0,.012.007.006.007.006.228-.035.45-.068.671-.114.57-.126,1.146-.268,1.7-.44A14.722,14.722,0,0,0,149.614,194L181,174.653c2.138-1.313,3.3-2.937,3.443-4.524l0-.008a5.22,5.22,0,0,0-2.623-2.93l-72.5-40.95c-3.96-2.238-10.679-1.881-15.018.789l-1.254.771,0,.013c-7,12.074-2.343,25.646,6.074,36.091",
    transform: "translate(-48.017 -66.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71104",
    "data-name": "Path 71104",
    className: "cls-5",
    d: "M258.986,258.293l-22.174,13.668.022.72.135,4.717,10.735-6.616-.72-1.2a.707.707,0,0,1-.737.107.549.549,0,0,1-.253-.489,1.955,1.955,0,0,1,.874-1.567l12.874-8.067Z",
    transform: "translate(-126.849 -138.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71105",
    "data-name": "Path 71105",
    className: "cls-4",
    d: "M105.17,199.741a21.738,21.738,0,0,0,3-.075c.129-.013.263-.032.4-.052a6.314,6.314,0,0,0,.661-.106C92,190.941,69.9,174.383,64.3,167.419c-8.416-10.446-13.074-24.017-6.074-36.091L28.106,149.894c-1.478.9-3.278,2.522-3.467,4.426a1.1,1.1,0,0,0,.076.251,4.489,4.489,0,0,0,1.02,1.616,4.754,4.754,0,0,0,.375.354c.117.1.237.2.358.3a3.925,3.925,0,0,0,.328.228,5.51,5.51,0,0,0,.471.293L99.777,198.3a.5.5,0,0,0,.048.032,4.167,4.167,0,0,0,.4.2,12.887,12.887,0,0,0,2.982.968,15.918,15.918,0,0,0,1.965.242",
    transform: "translate(-13.198 -70.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71106",
    "data-name": "Path 71106",
    className: "cls-5",
    d: "M199.417,288.419l.16,5.437a18.211,18.211,0,0,0,17.361-.321l-.135-4.717c-.319-.048-.653-.116-.979-.185-.314.169-.638.319-.965.455a18.82,18.82,0,0,1-9.97,1.16,15.827,15.827,0,0,1-5.157-1.66,2.537,2.537,0,0,1-.267-.141.465.465,0,0,1-.049-.028",
    transform: "translate(-106.818 -154.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71107",
    "data-name": "Path 71107",
    className: "cls-5",
    d: "M27.81,145.61a7.928,7.928,0,0,0-.824.566,8.514,8.514,0,0,0-1.567,1.49,4.6,4.6,0,0,0-1.058,2.753,4.441,4.441,0,0,0,.028.578,1.025,1.025,0,0,1,.015.111c.03.12.054.23.086.343.189-1.9,1.99-3.521,3.467-4.426l30.125-18.567,0-.013A24.678,24.678,0,0,1,59.7,125.97c-.173.094-.339.189-.51.292L41.8,136.989Z",
    transform: "translate(-13.049 -67.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71108",
    "data-name": "Path 71108",
    className: "cls-5",
    d: "M113.112,123.207c-3.8-2.154-10.159-1.911-14.5.494a24.867,24.867,0,0,0-1.619,2.475l1.254-.771c4.339-2.67,11.057-3.027,15.017-.79l72.5,40.95a5.218,5.218,0,0,1,2.623,2.93c.15-1.635-.759-3.216-2.764-4.346Z",
    transform: "translate(-51.953 -65.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71109",
    "data-name": "Path 71109",
    className: "cls-5",
    d: "M314.121,232.167a2.244,2.244,0,0,1-.057.386,3.525,3.525,0,0,1-.091.385,2.22,2.22,0,0,1-.131.378,2.542,2.542,0,0,1-.136.345s-.007.008,0,.013a5.628,5.628,0,0,1-.791,1.226,6.39,6.39,0,0,1-.566.624c-.053.055-.12.117-.174.173-.086.071-.18.152-.261.23-.131.112-.273.226-.412.329-.269.205-.561.4-.843.575l.159,5.442c1.679-1.032,3.316-2.677,3.457-4.784Z",
    transform: "translate(-166.403 -124.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71110",
    "data-name": "Path 71110",
    className: "cls-6",
    d: "M317.893,233a2.852,2.852,0,0,1-.091.385,3.516,3.516,0,0,0,.091-.385",
    transform: "translate(-170.231 -124.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71111",
    "data-name": "Path 71111",
    className: "cls-6",
    d: "M317.652,233.828a3.768,3.768,0,0,1-.13.378,2.156,2.156,0,0,0,.13-.378",
    transform: "translate(-170.081 -125.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71112",
    "data-name": "Path 71112",
    className: "cls-6",
    d: "M317.364,234.641a3.46,3.46,0,0,1-.136.345,2.553,2.553,0,0,0,.136-.345",
    transform: "translate(-169.924 -125.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71113",
    "data-name": "Path 71113",
    className: "cls-6",
    d: "M316.307,235.413a6.452,6.452,0,0,1-.791,1.226,5.614,5.614,0,0,0,.791-1.226",
    transform: "translate(-169.007 -126.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71114",
    "data-name": "Path 71114",
    className: "cls-6",
    d: "M314.1,239.4c-.053.055-.12.117-.174.173.053-.055.121-.118.174-.173",
    transform: "translate(-168.153 -128.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71115",
    "data-name": "Path 71115",
    className: "cls-7",
    d: "M258.9,239.317a1.457,1.457,0,0,0-1.359.025l-26.813,16.519a.337.337,0,0,0-.117.093.514.514,0,0,0,.178.137,1.472,1.472,0,0,0,1.362-.029l26.81-16.524a.615.615,0,0,0,.117-.084.589.589,0,0,0-.179-.137",
    transform: "translate(-123.529 -128.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71116",
    "data-name": "Path 71116",
    className: "cls-8",
    d: "M56.037,135.819a7.175,7.175,0,0,0-4.207-.716,3.763,3.763,0,0,0,.724,4.384c.182.165.416.362.682.559a6.477,6.477,0,0,0,2.891-.875,2.985,2.985,0,0,0,1.121-1.112,1.938,1.938,0,0,0,.2-.57l0-.006a2.6,2.6,0,0,0-1.419-1.663",
    transform: "translate(-27.549 -72.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71117",
    "data-name": "Path 71117",
    className: "cls-9",
    d: "M56.479,134.484a7.014,7.014,0,0,0-3.824-.753,4,4,0,0,0-.366.656,7.172,7.172,0,0,1,4.207.716,2.608,2.608,0,0,1,1.419,1.662,2.3,2.3,0,0,0-1.436-2.281",
    transform: "translate(-28.009 -71.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71118",
    "data-name": "Path 71118",
    className: "cls-5",
    d: "M282.834,242.212l-12.115,7.467.755,1.268c.514-.325.961-.15.992.388a1.939,1.939,0,0,1-.883,1.561l-12.866,8.068.72,1.2,23.556-14.515Z",
    transform: "translate(-138.582 -129.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71119",
    "data-name": "Path 71119",
    className: "cls-9",
    d: "M48.121,133.753a6.7,6.7,0,0,0-2.941.871,3.107,3.107,0,0,0-1.133,1.12,1.725,1.725,0,0,0-.183,1.207,1.835,1.835,0,0,1,.2-.589,3.055,3.055,0,0,1,1.13-1.119,6.438,6.438,0,0,1,2.561-.834,4.05,4.05,0,0,1,.366-.656",
    transform: "translate(-23.475 -71.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71120",
    "data-name": "Path 71120",
    className: "cls-10",
    d: "M56.128,143.362a6.044,6.044,0,0,0,2.091-.761,3.124,3.124,0,0,0,1.133-1.121,1.7,1.7,0,0,0,.181-1.178,1.941,1.941,0,0,1-.2.571,2.992,2.992,0,0,1-1.121,1.112,6.479,6.479,0,0,1-2.891.874,4.885,4.885,0,0,0,.811.5",
    transform: "translate(-29.631 -75.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71121",
    "data-name": "Path 71121",
    className: "cls-11",
    d: "M62.455,110.111l-16.392,10.1.315.526a6.711,6.711,0,0,1,2.941-.871,7.016,7.016,0,0,1,3.825.753A2.3,2.3,0,0,1,54.58,122.9l0,.007a1.7,1.7,0,0,1-.181,1.178,3.132,3.132,0,0,1-1.133,1.121,6.042,6.042,0,0,1-2.091.76,1.746,1.746,0,0,0,1.582.186l.667,1.118,17.4-10.726c.171-.1.338-.2.51-.292a35.519,35.519,0,0,1,7.079-7.14c-4.855-2.012-11.655-1.643-15.954,1",
    transform: "translate(-24.674 -57.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71122",
    "data-name": "Path 71122",
    className: "cls-12",
    d: "M48.524,139.549a3.762,3.762,0,0,1-.724-4.384,6.436,6.436,0,0,0-2.561.834,3.054,3.054,0,0,0-1.13,1.119,1.836,1.836,0,0,0-.2.589,2.665,2.665,0,0,0,1.422,1.658,6.84,6.84,0,0,0,3.4.763c.159,0,.318-.011.473-.02-.266-.2-.5-.394-.682-.559",
    transform: "translate(-23.519 -72.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71123",
    "data-name": "Path 71123",
    className: "cls-10",
    d: "M49.183,143.04c-.155.009-.314.016-.473.02a6.84,6.84,0,0,1-3.4-.763,2.665,2.665,0,0,1-1.422-1.658,2.292,2.292,0,0,0,1.432,2.262,6.872,6.872,0,0,0,3.411.768,8.419,8.419,0,0,0,1.266-.128,4.885,4.885,0,0,1-.811-.5",
    transform: "translate(-23.497 -75.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71124",
    "data-name": "Path 71124",
    className: "cls-13",
    d: "M271.321,261.224c-.031-.538-.478-.713-.992-.388L257.456,268.9a1.956,1.956,0,0,0-.874,1.568.55.55,0,0,0,.253.489.708.708,0,0,0,.738-.108l12.866-8.068a1.938,1.938,0,0,0,.883-1.561",
    transform: "translate(-137.437 -139.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71125",
    "data-name": "Path 71125",
    className: "cls-14",
    d: "M258.946,238.793c.246-.232.2-.523-.143-.715a1.487,1.487,0,0,0-1.357.026l-26.81,16.519c-.3.182-.356.458-.158.671a.336.336,0,0,1,.117-.093l26.813-16.519a1.457,1.457,0,0,1,1.359-.025.589.589,0,0,1,.179.137",
    transform: "translate(-123.393 -127.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71126",
    "data-name": "Path 71126",
    className: "cls-15",
    d: "M258.789,239.875,231.98,256.4a1.473,1.473,0,0,1-1.363.029.509.509,0,0,1-.178-.137c-.244.228-.191.519.139.705a1.458,1.458,0,0,0,1.356-.025l26.817-16.517c.3-.189.344-.45.156-.664a.579.579,0,0,1-.117.084",
    transform: "translate(-123.354 -128.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71127",
    "data-name": "Path 71127",
    className: "cls-16",
    d: "M30.015,168.831a7.927,7.927,0,0,1,.824-.566c-.268.165-.552.358-.824.566",
    transform: "translate(-16.078 -90.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71128",
    "data-name": "Path 71128",
    className: "cls-16",
    d: "M24.328,175.445a4.6,4.6,0,0,1,1.058-2.753,4.091,4.091,0,0,0-1.03,3.331,4.35,4.35,0,0,1-.028-.578",
    transform: "translate(-13.015 -92.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71129",
    "data-name": "Path 71129",
    className: "cls-16",
    d: "M195.356,277.188a21.748,21.748,0,0,1-3,.075,15.823,15.823,0,0,1-1.965-.242,12.875,12.875,0,0,1-2.982-.968,14.457,14.457,0,0,0,7.942,1.135",
    transform: "translate(-100.389 -147.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71130",
    "data-name": "Path 71130",
    className: "cls-16",
    d: "M24.453,180.1c.024.126.054.251.084.37,0-.009.007-.013,0-.027-.032-.113-.056-.223-.086-.343",
    transform: "translate(-13.098 -96.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71131",
    "data-name": "Path 71131",
    className: "cls-16",
    d: "M24.636,180.842c0,.013,0,.018,0,.027a1.081,1.081,0,0,0,.078.224,1.067,1.067,0,0,1-.076-.251",
    transform: "translate(-13.195 -96.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71132",
    "data-name": "Path 71132",
    className: "cls-16",
    d: "M25.823,183a4.49,4.49,0,0,1-1.021-1.616A4.337,4.337,0,0,0,25.823,183",
    transform: "translate(-13.285 -97.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71133",
    "data-name": "Path 71133",
    className: "cls-16",
    d: "M27,184.864a2.535,2.535,0,0,0,.376.354,4.764,4.764,0,0,1-.376-.354",
    transform: "translate(-14.463 -99.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71134",
    "data-name": "Path 71134",
    className: "cls-6",
    d: "M2.107,173.951a5.959,5.959,0,0,1-1.858-2.814,4.331,4.331,0,0,1-.117-.512,5.223,5.223,0,0,0,1.975,3.326",
    transform: "translate(-0.071 -91.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71135",
    "data-name": "Path 71135",
    className: "cls-5",
    d: "M.109,173.33a10.748,10.748,0,0,0,.232,2.743,7.1,7.1,0,0,0,3.527,3.877l-.162-5.425c-.187-.1-.387-.232-.579-.357l-.037-.021c-.15-.1-.313-.208-.458-.324-.048-.039-.1-.068-.151-.11-.148-.11-.295-.232-.444-.366a5.227,5.227,0,0,1-1.975-3.326c-.013-.007-.011-.013-.011-.013s0-.014,0-.018A2.768,2.768,0,0,1,0,169.5c.035,1.275.076,2.551.109,3.831",
    transform: "translate(0 -90.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71136",
    "data-name": "Path 71136",
    className: "cls-6",
    d: "M4.829,178.154c-.154-.114-.295-.232-.444-.366.15.134.3.256.444.366",
    transform: "translate(-2.349 -95.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71137",
    "data-name": "Path 71137",
    className: "cls-6",
    d: "M6.125,179.137c-.15-.1-.313-.207-.458-.324.145.117.308.222.458.324",
    transform: "translate(-3.036 -95.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71138",
    "data-name": "Path 71138",
    className: "cls-6",
    d: "M7.313,179.912c-.2-.11-.387-.232-.579-.357.192.125.391.252.579.357",
    transform: "translate(-3.607 -96.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71139",
    "data-name": "Path 71139",
    className: "cls-17",
    d: "M205.254,290.442a16.749,16.749,0,0,1-5.157-1.66,15.815,15.815,0,0,0,5.157,1.66",
    transform: "translate(-107.182 -154.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71140",
    "data-name": "Path 71140",
    className: "cls-17",
    d: "M199.712,288.577c-.066-.039-.126-.065-.189-.1a2.465,2.465,0,0,0,.267.141.651.651,0,0,1-.077-.042",
    transform: "translate(-106.875 -154.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71141",
    "data-name": "Path 71141",
    className: "cls-18",
    d: "M159.631,269.569l-19.738-11.077a1.658,1.658,0,0,0-1.776.219,1,1,0,0,1,.727.135l19.619,11a1.563,1.563,0,0,1,.831,1.435.636.636,0,0,1-.221.373c.606-.144,1.214-.507,1.266-.753a1.309,1.309,0,0,0-.709-1.335",
    transform: "translate(-73.983 -138.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71142",
    "data-name": "Path 71142",
    className: "cls-18",
    d: "M104.5,239.679c-1.664-.935-2.749-1.542-2.749-1.542a1.687,1.687,0,0,0-1.805.223.99.99,0,0,1,.757.13s1.407.783,3.456,1.935c2.8,1.573,5.5,3.084,7.2,4.038,1.09.615,1.761.989,1.761.989a1.566,1.566,0,0,1,.831,1.434.572.572,0,0,1-.23.379c.612-.148,1.231-.513,1.267-.766a1.3,1.3,0,0,0-.708-1.335s-1.015-.563-2.582-1.446c-1.871-1.049-4.532-2.547-7.2-4.04",
    transform: "translate(-53.534 -127.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71143",
    "data-name": "Path 71143",
    className: "cls-19",
    d: "M157.97,270.268l-19.619-11a1,1,0,0,0-.728-.135l-.007.006a.535.535,0,0,0-.409.455,1.548,1.548,0,0,0,.831,1.434l19.613,11a1.352,1.352,0,0,0,.929.05.64.64,0,0,0,.221-.373,1.564,1.564,0,0,0-.831-1.435",
    transform: "translate(-73.489 -138.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71144",
    "data-name": "Path 71144",
    className: "cls-19",
    d: "M103.029,242.41c2.714,1.522,5.379,3.018,7.154,4.012l2.155,1.211a1.393,1.393,0,0,0,.914.053.572.572,0,0,0,.23-.379,1.565,1.565,0,0,0-.831-1.435s-.671-.374-1.761-.989c-1.7-.954-4.4-2.464-7.2-4.037-2.049-1.152-3.455-1.935-3.455-1.935a.991.991,0,0,0-.757-.131.533.533,0,0,0-.389.455,1.545,1.545,0,0,0,.828,1.433s1.25.7,3.113,1.742",
    transform: "translate(-53.069 -127.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71145",
    "data-name": "Path 71145",
    className: "cls-20",
    d: "M181.248,286.929a.858.858,0,0,0,.929.049,1.349,1.349,0,0,1-.929-.049",
    transform: "translate(-97.086 -153.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71146",
    "data-name": "Path 71146",
    className: "cls-5",
    d: "M137.954,264.155l28.7,16.213-.16-5.437-6.457-3.648-.494.918a1.31,1.31,0,0,1,.709,1.335c-.052.247-.66.61-1.266.753a.858.858,0,0,1-.929-.049l-19.613-11Z",
    transform: "translate(-73.895 -141.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71147",
    "data-name": "Path 71147",
    className: "cls-20",
    d: "M128.552,257.933a1.4,1.4,0,0,1-.914-.053.864.864,0,0,0,.914.053",
    transform: "translate(-68.369 -138.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71148",
    "data-name": "Path 71148",
    className: "cls-5",
    d: "M7.981,180.323l8.166,4.61,74.27,41.936-.494.918L70.186,216.711a1.657,1.657,0,0,0-1.776.218l-.007.007a.534.534,0,0,0-.409.455,1.546,1.546,0,0,0,.831,1.433l-.491.917L8.143,185.748Zm55.563,36.013a.864.864,0,0,0,.914.053c.612-.148,1.231-.512,1.267-.765a1.3,1.3,0,0,0-.708-1.335s-1.015-.564-2.582-1.446c-1.87-1.049-4.532-2.547-7.2-4.041l-2.749-1.542a1.686,1.686,0,0,0-1.8.223.533.533,0,0,0-.389.455,1.545,1.545,0,0,0,.829,1.433s1.25.7,3.113,1.742c2.714,1.522,5.379,3.018,7.154,4.012l2.155,1.211",
    transform: "translate(-4.275 -96.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71149",
    "data-name": "Path 71149",
    className: "cls-11",
    d: "M114.979,117.24c-3.8-2.155-10.16-1.911-14.5.494a35.494,35.494,0,0,1,7.079-7.14,14.913,14.913,0,0,1,1.4.681l88.893,50.194c2.431,1.374,3.668,3.2,3.7,5.058l.008,0c0,.173-.01.351-.025.515a2.269,2.269,0,0,1-.057.386,2.84,2.84,0,0,1-.091.386,3.828,3.828,0,0,1-.13.378,3.59,3.59,0,0,1-.136.345s-.008.008,0,.013a6.412,6.412,0,0,1-.791,1.226,6.268,6.268,0,0,1-.566.625c-.053.055-.12.117-.173.173-.086.071-.18.152-.261.23-.133.112-.273.226-.413.329-.269.205-.561.4-.843.575l-12.115,7.467-22.174,13.668c-.306.189-.627.371-.957.534a56.948,56.948,0,0,1-12.976-4.972c.228-.035.45-.068.671-.114.566-.12,1.139-.261,1.7-.44a14.728,14.728,0,0,0,3.191-1.444l31.386-19.35c2.138-1.312,3.3-2.937,3.443-4.524l0-.008c.15-1.635-.759-3.216-2.764-4.346ZM187.873,169.9l-26.81,16.519c-.3.182-.356.458-.158.671-.245.228-.191.519.139.7a1.458,1.458,0,0,0,1.356-.025l26.817-16.517c.3-.189.344-.45.156-.664.247-.232.2-.523-.142-.715a1.49,1.49,0,0,0-1.358.026",
    transform: "translate(-53.82 -59.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71150",
    "data-name": "Path 71150",
    className: "cls-11",
    d: "M21.428,134.5l-17.9,11.025c-2.032,1.251-3.646,3.168-3.435,5.72,0,0,.008.011,0,.018s0,.006.011.013a4.427,4.427,0,0,0,.117.512A5.954,5.954,0,0,0,2.075,154.6c.149.134.29.252.444.366.054.042.1.072.151.11.145.117.308.223.458.324l.037.021c.192.124.379.247.579.357l8.166,4.61.658-1.245a4.067,4.067,0,0,1-1.043-2.172,3.276,3.276,0,0,1-.048-.925c-.03-.119-.06-.243-.084-.37a1.023,1.023,0,0,0-.014-.111,4.089,4.089,0,0,1,1.03-3.331,8.516,8.516,0,0,1,1.567-1.49c.272-.208.556-.4.824-.566l13.986-8.622-.667-1.118a1.746,1.746,0,0,1-1.582-.185,8.368,8.368,0,0,1-1.266.127,6.87,6.87,0,0,1-3.411-.768,2.292,2.292,0,0,1-1.432-2.263,1.723,1.723,0,0,1,.184-1.207,3.109,3.109,0,0,1,1.132-1.12Z",
    transform: "translate(-0.039 -72.044)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67426",
    "data-name": "Group 67426",
    transform: "translate(122.501 0.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67425",
    "data-name": "Group 67425",
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71151",
    "data-name": "Path 71151",
    className: "cls-22",
    d: "M340.147,45.838a.947.947,0,0,0-.45,0,1.241,1.241,0,0,0-.357.142L296.69,21.191a1.242,1.242,0,0,1,.358-.142,1.11,1.11,0,0,1,.692.144q21.211,12.324,42.417,24.649l-.01-.005M293.455,18.7a.627.627,0,0,0-.469-.017,1.266,1.266,0,0,0-.358.143L264.7,2.6a1.228,1.228,0,0,1,.357-.143,1.035,1.035,0,0,1,.663.127l27.753,16.129-.02-.01m46.521,27.641a.921.921,0,0,1,.934-.065L264.748,2.019a.921.921,0,0,0-.934.065Z",
    transform: "translate(-263.814 -1.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71152",
    "data-name": "Path 71152",
    className: "cls-23",
    d: "M339.976,46.346,263.814,2.085a.921.921,0,0,1,.934-.065L340.911,46.28a.921.921,0,0,0-.934.065m0,0a.921.921,0,0,1,.934-.065L264.748,2.019a.921.921,0,0,0-.934.065Z",
    transform: "translate(-263.814 -1.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71153",
    "data-name": "Path 71153",
    className: "cls-22",
    d: "M294.675,19.428a.791.791,0,0,0-.431.008,1.239,1.239,0,0,0-.357.142L269,5.118a1.252,1.252,0,0,1,.358-.142,1.06,1.06,0,0,1,.72.16l24.593,14.293Z",
    transform: "translate(-266.594 -3.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71154",
    "data-name": "Path 71154",
    className: "cls-22",
    d: "M292.92,18.408a.791.791,0,0,0-.431.008,1.247,1.247,0,0,0-.358.142L267.249,4.1a1.248,1.248,0,0,1,.358-.142,1.06,1.06,0,0,1,.72.16l24.593,14.293Zm1.56.909c-3.141-1.808-3.141-1.808-27.733-16.118l-.059-.033a1.1,1.1,0,0,0-.563-.1,1.2,1.2,0,0,0-.4.147l27.926,16.229a1.247,1.247,0,0,1,.357-.142c.3-.048.328-.052.47.016",
    transform: "translate(-264.839 -2.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71155",
    "data-name": "Path 71155",
    className: "cls-22",
    d: "M378.151,67.95l-.283.079a1.333,1.333,0,0,0-.37.147L337.892,45.16a1.232,1.232,0,0,1,.358-.142,1.393,1.393,0,0,1,.872.248l3.808,2.213,35.207,20.46s.01.007.014.011",
    transform: "translate(-303.494 -25.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71156",
    "data-name": "Path 71156",
    className: "cls-22",
    d: "M376.4,66.925a2.91,2.91,0,0,0-.3.084,1.261,1.261,0,0,0-.358.142L336.137,44.135a1.232,1.232,0,0,1,.358-.142,1.393,1.393,0,0,1,.872.248l3.808,2.213,35.206,20.46s.011.007.015.011m1.676.972c-2.431-1.381-2.431-1.381-42.407-24.644l-.054-.032a2.39,2.39,0,0,0-.586-.117,1.171,1.171,0,0,0-.409.147l42.65,24.785a1.234,1.234,0,0,1,.357-.141.971.971,0,0,1,.45,0",
    transform: "translate(-301.738 -23.981)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67428",
    "data-name": "Group 67428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67427",
    "data-name": "Group 67427",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71158",
    "data-name": "Path 71158",
    className: "cls-24",
    d: "M407.077,97.4c.984-.568,1.862.4.958,1.96-3.052,5.257-6.388,10.232-9.58,15.378-2.3,3.711-4.785,8.634-7.8,11.5a2.194,2.194,0,0,1-.414.318.718.718,0,0,1-.81.043c-.549-.394-.5-1.81.535-2.8q.21-.2.4-.411a41.732,41.732,0,0,0,3.119-4.708c1.441-2.091,2.669-4.336,4.1-6.43,3.074-4.469,5.9-9.219,8.631-13.925a2.475,2.475,0,0,1,.855-.926",
    transform: "translate(-208.413 -52.086)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67430",
    "data-name": "Group 67430",
    transform: "translate(104.509 1.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67429",
    "data-name": "Group 67429",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71159",
    "data-name": "Path 71159",
    className: "cls-4",
    d: "M312.922,45.423c2.045,1.524,2.431,3.518,1.183,6.1-1.843,3.077-3.751,6.126-5.765,9.054-1.436,2.094-2.665,4.339-4.1,6.43a41.675,41.675,0,0,1-3.118,4.708c-.129.142-.262.279-.4.411-1.037.99-1.085,2.407-.535,2.8l.046.031-30.594-17.78a.377.377,0,0,1-.046-.031c-.55-.393-.5-1.81.536-2.8.138-.132.272-.27.4-.41a41.747,41.747,0,0,0,3.118-4.708c1.441-2.091,2.67-4.336,4.105-6.431,2.014-2.928,3.921-5.976,5.765-9.054,1.71-2.362,3.6-2.984,5.936-1.96ZM277.1,24.6c2.575,1.827,3.2,3.911,1.973,6.558-1.843,3.078-3.751,6.126-5.764,9.054-1.437,2.095-2.665,4.339-4.106,6.431a41.712,41.712,0,0,1-3.117,4.708c-.129.141-.262.279-.4.411-1.037.99-1.084,2.408-.535,2.8a.438.438,0,0,0,.046.031q-19.421-11.288-38.843-22.573l-.046-.03c-.549-.393-.5-1.81.536-2.8q.209-.2.4-.41a41.659,41.659,0,0,0,3.118-4.708c1.441-2.091,2.67-4.336,4.105-6.431,2.014-2.928,3.921-5.976,5.764-9.054,1.757-2.344,3.895-2.821,6.728-1.5ZM319.22,46.535,243.058,2.274a2.47,2.47,0,0,0-.854.926c-2.733,4.706-5.557,9.456-8.632,13.924-1.436,2.095-2.664,4.339-4.1,6.431a41.634,41.634,0,0,1-3.118,4.708c-.128.141-.262.278-.4.41-1.038.991-1.085,2.408-.536,2.8l.046.03,76.162,44.261c-.016-.009-.031-.02-.046-.031-.549-.394-.5-1.81.535-2.8q.21-.2.4-.411a41.729,41.729,0,0,0,3.119-4.708c1.441-2.091,2.669-4.336,4.1-6.43,3.074-4.469,5.9-9.219,8.631-13.925a2.474,2.474,0,0,1,.855-.926",
    transform: "translate(-225.065 -2.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71160",
    "data-name": "Path 71160",
    className: "cls-23",
    d: "M319.22,46.535a2.474,2.474,0,0,0-.855.926c-2.732,4.706-5.557,9.456-8.631,13.925-1.435,2.094-2.664,4.339-4.1,6.43a41.729,41.729,0,0,1-3.119,4.708q-.192.212-.4.411c-1.037.99-1.084,2.407-.535,2.8.015.011.03.021.046.031L225.458,31.5l-.046-.03c-.549-.393-.5-1.81.536-2.8.139-.132.273-.269.4-.41a41.634,41.634,0,0,0,3.118-4.708c1.44-2.091,2.669-4.336,4.1-6.431,3.074-4.469,5.9-9.218,8.632-13.924a2.47,2.47,0,0,1,.854-.926Zm0,0L243.058,2.274a2.47,2.47,0,0,0-.854.926c-2.733,4.706-5.557,9.456-8.632,13.924-1.436,2.095-2.664,4.339-4.1,6.431a41.634,41.634,0,0,1-3.118,4.708c-.128.141-.262.278-.4.41-1.038.991-1.085,2.408-.536,2.8l.046.03,76.162,44.261c-.016-.009-.031-.02-.046-.031-.549-.394-.5-1.81.535-2.8q.21-.2.4-.411a41.729,41.729,0,0,0,3.119-4.708c1.441-2.091,2.669-4.336,4.1-6.43,3.074-4.469,5.9-9.219,8.631-13.925a2.474,2.474,0,0,1,.855-.926",
    transform: "translate(-225.065 -2.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71161",
    "data-name": "Path 71161",
    className: "cls-26",
    d: "M278.788,33.782c1.622,1.126,2.141,2.41,1.541,3.814-1.845,3.078-3.751,6.126-5.765,9.054-1.437,2.095-2.665,4.339-4.1,6.431a41.718,41.718,0,0,1-3.119,4.708q-.193.212-.4.41c-1.037.99-1.084,2.408-.536,2.8l.047.03-35.8-20.8c-.015-.009-.031-.019-.046-.03-.549-.394-.5-1.81.535-2.8.139-.131.273-.269.4-.41a41.766,41.766,0,0,0,3.119-4.708c1.44-2.091,2.668-4.336,4.1-6.43,2.014-2.928,3.921-5.977,5.764-9.054,1.251-1.567,2.543-3.188,34.26,16.991",
    transform: "translate(-227.846 -9.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71162",
    "data-name": "Path 71162",
    className: "cls-27",
    d: "M277.031,31.176c1.622,1.127,2.142,2.41,1.541,3.814-1.845,3.077-3.751,6.126-5.765,9.053-1.437,2.095-2.666,4.339-4.105,6.431a41.77,41.77,0,0,1-3.119,4.708c-.129.141-.263.278-.4.41-1.037.99-1.084,2.407-.536,2.8l.047.03-35.8-20.8c-.015-.01-.031-.019-.045-.03-.549-.394-.5-1.81.535-2.8.139-.132.273-.27.4-.41A41.831,41.831,0,0,0,232.9,29.67c1.44-2.091,2.668-4.336,4.1-6.43,2.014-2.928,3.921-5.977,5.765-9.054.97-1.216,2.316-1.387,4.117-.526Zm1.089-1.86L247.978,11.8c-2.793-1.3-4.9-.859-6.646,1.393-1.925,3.186-3.833,6.235-5.846,9.163-1.436,2.095-2.665,4.339-4.105,6.431a41.606,41.606,0,0,1-3.118,4.708q-.192.212-.4.411c-1.038.99-1.085,2.407-.536,2.8l.046.03q19.423,11.287,38.842,22.573c-.016-.009-.031-.02-.046-.031-.549-.393-.5-1.81.535-2.8.14-.132.273-.27.4-.411a41.732,41.732,0,0,0,3.118-4.708c1.441-2.091,2.669-4.336,4.106-6.431,2.013-2.928,3.921-5.976,5.764-9.054a4.819,4.819,0,0,0-1.973-6.558",
    transform: "translate(-226.09 -6.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71163",
    "data-name": "Path 71163",
    className: "cls-26",
    d: "M364.551,83.126a2.417,2.417,0,0,1,.745,3.352c-1.844,3.077-3.751,6.126-5.766,9.053-1.436,2.095-2.664,4.34-4.1,6.431a41.809,41.809,0,0,1-3.119,4.708c-.128.141-.262.278-.4.41-1.037.99-1.084,2.408-.535,2.8a.4.4,0,0,0,.047.03L323.875,93.906c-.015-.009-.031-.02-.046-.03-.548-.393-.5-1.811.536-2.8.139-.132.273-.269.4-.411a41.719,41.719,0,0,0,3.118-4.708c1.441-2.091,2.669-4.337,4.106-6.431,2.013-2.928,3.921-5.976,5.764-9.054a2.471,2.471,0,0,1,3.322-.988c7.366,3.478,16.432,9.549,23.475,13.642",
    transform: "translate(-277.782 -38.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71164",
    "data-name": "Path 71164",
    className: "cls-27",
    d: "M362.789,80.785a2.418,2.418,0,0,1,.746,3.352c-1.845,3.077-3.751,6.126-5.766,9.053-1.436,2.095-2.665,4.34-4.1,6.431a41.76,41.76,0,0,1-3.119,4.708c-.128.141-.261.279-.4.411-1.038.99-1.084,2.408-.535,2.8a.537.537,0,0,0,.047.03L322.114,91.565c-.015-.009-.031-.02-.047-.03-.548-.393-.5-1.811.536-2.8.139-.132.273-.27.4-.411a41.645,41.645,0,0,0,3.118-4.708c1.441-2.091,2.669-4.337,4.106-6.431,2.013-2.928,3.921-5.976,5.764-9.054a2.487,2.487,0,0,1,3.323-.989Zm1.089-1.86L340.4,65.283c-2.276-1-4.195-.387-5.864,1.862-1.915,3.177-3.823,6.225-5.837,9.153-1.436,2.095-2.664,4.339-4.105,6.431a41.691,41.691,0,0,1-3.117,4.708c-.13.141-.262.278-.4.41-1.038.991-1.086,2.408-.535,2.8a.34.34,0,0,0,.046.03l30.595,17.78c-.016-.009-.031-.02-.046-.03-.55-.393-.5-1.811.535-2.8q.21-.2.4-.411a41.681,41.681,0,0,0,3.118-4.708c1.44-2.091,2.669-4.336,4.105-6.43,2.014-2.928,3.921-5.977,5.765-9.054,1.693-3.509-.014-5.327-1.183-6.1",
    transform: "translate(-276.02 -35.777)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67432",
    "data-name": "Group 67432",
    transform: "translate(92.644 26.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67431",
    "data-name": "Group 67431",
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71166",
    "data-name": "Path 71166",
    className: "cls-29",
    d: "M287.431,100.881c-4.289.351-8.243-2.175-13.148.658l-30.6-17.78c4.9-2.832,8.859-.306,13.149-.656ZM252.394,80.52c-4.289.35-8.243-2.175-13.149.657L200.4,58.6c4.906-2.833,8.86-.307,13.148-.658Zm36.43,21.172-76.162-44.26c-4.288.35-8.243-2.175-13.148.657l76.163,44.261c4.905-2.833,8.86-.306,13.148-.657",
    transform: "translate(-199.514 -56.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71167",
    "data-name": "Path 71167",
    className: "cls-30",
    d: "M288.824,101.691c-4.287.351-8.242-2.176-13.148.657L199.514,58.088c4.906-2.832,8.86-.307,13.148-.657Zm0,0-76.162-44.26c-4.288.35-8.243-2.175-13.148.657l76.163,44.261c4.905-2.833,8.86-.306,13.148-.657",
    transform: "translate(-199.514 -56.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71168",
    "data-name": "Path 71168",
    className: "cls-31",
    d: "M253.652,81.253c-4.288.35-8.243-2.175-13.148.657L204.7,61.1c4.906-2.832,8.861-.306,13.149-.657Z",
    transform: "translate(-202.293 -58.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71169",
    "data-name": "Path 71169",
    className: "cls-27",
    d: "M251.9,80.232c-4.288.35-8.243-2.175-13.149.657l-35.8-20.8c4.906-2.833,8.861-.307,13.149-.657Zm1.522.884L214.576,58.543c-4.289.35-8.243-2.175-13.149.657L240.27,81.773c4.906-2.833,8.86-.307,13.149-.657",
    transform: "translate(-200.538 -57.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71170",
    "data-name": "Path 71170",
    className: "cls-31",
    d: "M338.621,130.63c-4.288.35-8.243-2.176-13.148.657l-27.542-16.006c4.905-2.833,8.86-.307,13.149-.657l27.542,16.006Z",
    transform: "translate(-252.231 -87.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71171",
    "data-name": "Path 71171",
    className: "cls-27",
    d: "M336.86,129.606c-4.288.35-8.243-2.176-13.148.657L296.17,114.258c4.905-2.833,8.86-.307,13.148-.657l27.542,16.006Zm1.527.886-30.595-17.779c-4.289.35-8.244-2.176-13.148.657l30.6,17.78c4.9-2.833,8.859-.307,13.148-.658",
    transform: "translate(-250.47 -86.34)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67434",
    "data-name": "Group 67434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67433",
    "data-name": "Group 67433",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71173",
    "data-name": "Path 71173",
    className: "cls-30",
    d: "M197.621,59.788c.074-.045.147-.088.22-.13L274,103.919c-.073.042-.147.085-.221.13a2.382,2.382,0,0,0-.274.2c-1.025.855-1.225,2.51-.6,2.874L196.749,62.859c-.627-.363-.428-2.019.6-2.874a2.353,2.353,0,0,1,.275-.2",
    transform: "translate(-105.198 -31.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71174",
    "data-name": "Path 71174",
    className: "cls-27",
    d: "M272.315,106.951h0L196.153,62.69a1.2,1.2,0,0,1-.528-.984,3.093,3.093,0,0,1,1.076-2.478,2.756,2.756,0,0,1,.318-.227c.077-.047.152-.091.227-.135l.181-.1.181.1,76.7,44.573-.539.311c-.071.041-.143.083-.215.127a2.02,2.02,0,0,0-.231.166,2.365,2.365,0,0,0-.819,1.863.562.562,0,0,0,.171.421h0ZM197.428,59.595l-.035.021a1.994,1.994,0,0,0-.232.166,2.364,2.364,0,0,0-.819,1.863.557.557,0,0,0,.172.422l75.265,43.739a3.122,3.122,0,0,1,1.084-2.318l.039-.033Z",
    transform: "translate(-104.783 -31.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71175",
    "data-name": "Path 71175",
    className: "cls-30",
    d: "M198.154,60.362l76.163,44.26a1.347,1.347,0,0,0-.255.114L197.9,60.476a1.34,1.34,0,0,1,.254-.114",
    transform: "translate(-106.005 -32.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71176",
    "data-name": "Path 71176",
    className: "cls-27",
    d: "M273.229,104.7,196.347,60.022l.542-.311a1.683,1.683,0,0,1,.323-.144l.153-.049.138.08,76.865,44.668-.774.247a.962.962,0,0,0-.185.083Z",
    transform: "translate(-105.174 -31.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71177",
    "data-name": "Path 71177",
    className: "cls-24",
    d: "M361.862,153.405c4.905-2.833,8.86-.306,13.148-.657q-.192.212-.4.411c-1.037.99-1.084,2.406-.535,2.8a1.248,1.248,0,0,1-.271.059c-3.8.341-7.659-2.14-11.976.351l-.178.105a.4.4,0,0,1-.039.023c-.046.027-.091.049-.133.07-1.381.651-1.419-1.744-.11-2.836a2.437,2.437,0,0,1,.273-.2l.222-.13",
    transform: "translate(-193.055 -81.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71178",
    "data-name": "Path 71178",
    className: "cls-30",
    d: "M336.946,195.329c.261-.259.518-.541.771-.836a2.428,2.428,0,0,1-.771.836",
    transform: "translate(-180.486 -104.18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67436",
    "data-name": "Group 67436",
    transform: "translate(77.902 28.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67435",
    "data-name": "Group 67435",
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71179",
    "data-name": "Path 71179",
    className: "cls-4",
    d: "M256.526,104.057a2.372,2.372,0,0,0-.625.557c-2.149,2.607-4.3,5.171-6.261,8.015-1.052,1.522-2.033,3.063-3.177,4.49-.821,1.031-1.351,2.152-2.142,3.094a5.83,5.83,0,0,1-.868.852c-1.126.882-1.13,2.326-.487,2.7l-30.595-17.78c-.643-.373-.639-1.817.487-2.7a5.826,5.826,0,0,0,.869-.851c.791-.943,1.321-2.064,2.143-3.1,1.144-1.427,2.125-2.968,3.175-4.491,1.964-2.844,4.112-5.408,6.262-8.014a2.368,2.368,0,0,1,.624-.557ZM221.489,83.7a2.369,2.369,0,0,0-.625.556c-2.149,2.607-4.3,5.171-6.261,8.015-1.051,1.523-2.032,3.063-3.176,4.491-.822,1.03-1.352,2.152-2.143,3.095a5.839,5.839,0,0,1-.868.851c-1.127.883-1.131,2.326-.488,2.7L169.087,80.831c-.643-.373-.638-1.817.488-2.7a5.848,5.848,0,0,0,.868-.852c.791-.943,1.321-2.064,2.143-3.095,1.143-1.427,2.124-2.968,3.176-4.49,1.963-2.844,4.112-5.408,6.261-8.015a2.363,2.363,0,0,1,.625-.556Zm36.431,21.171L181.758,60.607a2.368,2.368,0,0,0-.625.557c-2.149,2.607-4.3,5.171-6.262,8.015-1.05,1.522-2.032,3.063-3.175,4.49-.822,1.031-1.352,2.152-2.142,3.1a5.876,5.876,0,0,1-.869.851c-1.126.882-1.13,2.325-.487,2.7l76.162,44.26c-.643-.373-.639-1.818.488-2.7a5.845,5.845,0,0,0,.868-.852c.791-.943,1.321-2.064,2.142-3.095,1.144-1.427,2.125-2.968,3.176-4.49,1.963-2.845,4.113-5.409,6.261-8.015a2.383,2.383,0,0,1,.625-.557",
    transform: "translate(-167.765 -60.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71180",
    "data-name": "Path 71180",
    className: "cls-23",
    d: "M257.92,104.868a2.383,2.383,0,0,0-.625.557c-2.148,2.606-4.3,5.17-6.261,8.015-1.051,1.522-2.032,3.063-3.176,4.49-.821,1.031-1.351,2.152-2.142,3.095a5.845,5.845,0,0,1-.868.852c-1.126.881-1.131,2.326-.488,2.7L168.2,80.315c-.643-.374-.638-1.817.487-2.7a5.876,5.876,0,0,0,.869-.851c.79-.943,1.32-2.064,2.142-3.1,1.143-1.427,2.125-2.968,3.175-4.49,1.964-2.844,4.113-5.408,6.262-8.015a2.368,2.368,0,0,1,.625-.557Zm0,0L181.758,60.607a2.368,2.368,0,0,0-.625.557c-2.149,2.607-4.3,5.171-6.262,8.015-1.05,1.522-2.032,3.063-3.175,4.49-.822,1.031-1.352,2.152-2.142,3.1a5.876,5.876,0,0,1-.869.851c-1.126.882-1.13,2.325-.487,2.7l76.162,44.26c-.643-.373-.639-1.818.488-2.7a5.845,5.845,0,0,0,.868-.852c.791-.943,1.321-2.064,2.142-3.095,1.144-1.427,2.125-2.968,3.176-4.49,1.963-2.845,4.113-5.409,6.261-8.015a2.383,2.383,0,0,1,.625-.557",
    transform: "translate(-167.765 -60.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71181",
    "data-name": "Path 71181",
    className: "cls-26",
    d: "M222.748,84.429a2.372,2.372,0,0,0-.625.557c-2.149,2.606-4.3,5.171-6.262,8.015-1.051,1.523-2.032,3.063-3.175,4.491-.822,1.03-1.352,2.152-2.142,3.095a5.847,5.847,0,0,1-.869.851c-1.126.883-1.13,2.326-.488,2.7l-35.8-20.805c-.644-.374-.639-1.817.487-2.7a5.873,5.873,0,0,0,.869-.851c.79-.943,1.32-2.065,2.142-3.095,1.144-1.428,2.125-2.969,3.176-4.491,1.964-2.844,4.112-5.408,6.261-8.015a2.375,2.375,0,0,1,.625-.557Z",
    transform: "translate(-170.545 -62.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71182",
    "data-name": "Path 71182",
    className: "cls-27",
    d: "M220.993,83.409a2.372,2.372,0,0,0-.625.557c-2.149,2.606-4.3,5.171-6.262,8.015-1.051,1.523-2.032,3.063-3.175,4.491-.822,1.03-1.352,2.152-2.143,3.095a5.85,5.85,0,0,1-.869.851c-1.126.882-1.13,2.325-.487,2.7l-35.8-20.805c-.643-.373-.638-1.817.487-2.7a5.829,5.829,0,0,0,.869-.851c.79-.943,1.32-2.064,2.142-3.095,1.143-1.428,2.125-2.969,3.175-4.491,1.964-2.844,4.112-5.408,6.262-8.015a2.372,2.372,0,0,1,.625-.557Zm1.521.885L183.672,61.721a2.374,2.374,0,0,0-.625.557c-2.149,2.606-4.3,5.171-6.261,8.014-1.051,1.523-2.032,3.063-3.176,4.491-.822,1.031-1.352,2.152-2.143,3.095a5.849,5.849,0,0,1-.868.852c-1.126.882-1.131,2.325-.488,2.7L208.955,104c-.644-.373-.639-1.817.488-2.7a5.82,5.82,0,0,0,.868-.851c.791-.943,1.321-2.064,2.143-3.095,1.144-1.427,2.124-2.968,3.176-4.491,1.963-2.844,4.112-5.408,6.261-8.015a2.362,2.362,0,0,1,.625-.556",
    transform: "translate(-168.79 -61.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71183",
    "data-name": "Path 71183",
    className: "cls-26",
    d: "M307.716,133.808a2.36,2.36,0,0,0-.625.556c-2.149,2.607-4.3,5.171-6.262,8.015-1.05,1.523-2.031,3.064-3.175,4.491-.822,1.031-1.352,2.153-2.143,3.095a5.85,5.85,0,0,1-.868.852c-1.126.882-1.131,2.325-.488,2.7l-27.541-16.006c-.643-.374-.639-1.817.487-2.7a5.876,5.876,0,0,0,.869-.852c.79-.942,1.321-2.064,2.143-3.094,1.143-1.427,2.124-2.968,3.175-4.491,1.964-2.845,4.112-5.408,6.262-8.015a2.355,2.355,0,0,1,.625-.557Z",
    transform: "translate(-220.482 -91.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71184",
    "data-name": "Path 71184",
    className: "cls-27",
    d: "M305.955,132.785a2.359,2.359,0,0,0-.625.556c-2.149,2.606-4.3,5.171-6.262,8.015-1.05,1.523-2.032,3.063-3.175,4.491-.823,1.03-1.352,2.152-2.143,3.095a5.847,5.847,0,0,1-.868.852c-1.126.882-1.131,2.325-.488,2.7l-27.541-16.006c-.644-.373-.639-1.817.487-2.7a5.9,5.9,0,0,0,.869-.852c.79-.942,1.321-2.064,2.143-3.094,1.143-1.428,2.124-2.969,3.175-4.491,1.964-2.845,4.112-5.408,6.262-8.015a2.368,2.368,0,0,1,.625-.556Zm1.527.886-30.6-17.779a2.357,2.357,0,0,0-.624.556c-2.15,2.606-4.3,5.171-6.262,8.015-1.05,1.522-2.032,3.063-3.175,4.49-.822,1.031-1.352,2.153-2.143,3.1a5.825,5.825,0,0,1-.869.851c-1.126.882-1.13,2.326-.487,2.7l30.595,17.78c-.643-.373-.639-1.817.487-2.7a5.829,5.829,0,0,0,.868-.852c.791-.942,1.321-2.063,2.142-3.094,1.143-1.427,2.124-2.969,3.177-4.49,1.963-2.845,4.112-5.408,6.261-8.015a2.373,2.373,0,0,1,.625-.557",
    transform: "translate(-218.721 -90.221)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67438",
    "data-name": "Group 67438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67437",
    "data-name": "Group 67437",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71186",
    "data-name": "Path 71186",
    className: "cls-24",
    d: "M345.778,155.793a1.348,1.348,0,0,1,.255-.114c-1.309,1.092-1.271,3.487.11,2.835-2.64,3.211-5.112,6.4-7.5,9.931a60.693,60.693,0,0,1-3.693,5.256c-.253.3-.51.578-.772.836a9.015,9.015,0,0,1-.788.7,2.553,2.553,0,0,1-.255.174,1.026,1.026,0,0,1-.741.157c-.816-.194-.915-1.814.307-2.771a5.847,5.847,0,0,0,.868-.852c.791-.943,1.321-2.064,2.142-3.095,1.144-1.427,2.125-2.968,3.176-4.49,1.963-2.845,4.113-5.409,6.261-8.015a2.383,2.383,0,0,1,.625-.557",
    transform: "translate(-177.721 -83.39)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67440",
    "data-name": "Group 67440",
    transform: "translate(11.493 44.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67439",
    "data-name": "Group 67439",
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71187",
    "data-name": "Path 71187",
    className: "cls-4",
    d: "M118.455,145.718c-1.445-.917-1.562-2.039-.3-2.859C144.6,127.55,144.6,127.55,147.339,129l15.608,9.046c1.445.916,1.564,2.038.3,2.856-26.451,15.312-26.451,15.312-29.187,13.863-5.2-3.015-10.465-5.927-15.608-9.046m-43.76,15.529c-1.957-1.218-2.374-2.636-1.037-3.529,27.337-15.823,27.337-15.823,27.508-15.9a7.065,7.065,0,0,1,5.816.741l23.5,13.624c1.956,1.218,2.373,2.637,1.037,3.53-27.333,15.822-27.333,15.822-27.508,15.9a7.072,7.072,0,0,1-5.816-.742c-7.835-4.542-15.742-8.959-23.505-13.625M106.24,138.3c-.847-.584-.563-1.27.9-2.162,26.448-15.309,26.448-15.309,27.988-14.557l5.546,3.215c.837.577.545,1.285-.894,2.166-26.443,15.307-26.443,15.307-27.99,14.553-1.663-.964-3.92-2.186-5.545-3.214M96.634,178.51c.773.493,1.521,1.022,2.3,1.5L59.845,157.3c2,1.013,2,1.013,2.608,1.344,2.317,1.423,26.831,15.649,33.2,19.267.293.181.689.416.979.6m-3.606-47.53c-1.189-.788-.264-1.668.721-2.267,26.458-15.315,26.458-15.315,28.163-14.452l6.978,4.044c1.189.788.266,1.667-.717,2.265-26.461,15.317-26.461,15.317-28.166,14.454-2.093-1.213-4.922-2.768-6.978-4.044M51.062,152.063c.522.341,1.024.71,1.556,1.036L27.4,138.442c1.348.652,1.348.652,1.667.824L50.38,151.637c.205.128.481.294.683.426M32.145,136.585c-1.751-1.073-3.489-2.636-1.829-3.987,9.077-5.255,17.531-11.583,27.23-15.763,2.408-1.037,5.347.22,6.884,1.062L94.613,135.39c1.75,1.074,3.489,2.637,1.828,3.989-9.077,5.254-17.532,11.582-27.231,15.762-2.408,1.036-5.347-.221-6.884-1.062-10.061-5.831-20.194-11.537-30.181-17.494m33.786-21.311c-1.551-.976-1.762-2.177-.524-2.989,24.349-14.094,24.349-14.094,24.5-14.166a5.85,5.85,0,0,1,4.9.435l17.452,10.115c1.551.977,1.763,2.177.527,2.987-24.348,14.095-24.348,14.095-24.5,14.166a5.855,5.855,0,0,1-4.908-.433c-5.817-3.373-11.7-6.638-17.452-10.116M169.11,139.663,92.948,95.4,25.981,134.066c-1.27.733-1.555,2.649-.864,3.051l76.162,44.261c-.691-.4-.406-2.318.865-3.051l66.966-38.664",
    transform: "translate(-24.751 -95.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71188",
    "data-name": "Path 71188",
    className: "cls-23",
    d: "M169.11,139.663l-66.966,38.664c-1.27.733-1.556,2.649-.865,3.051L25.117,137.117c-.691-.4-.406-2.318.864-3.051L92.948,95.4Zm0,0L92.948,95.4,25.981,134.066c-1.27.733-1.555,2.649-.864,3.051l76.162,44.261c-.691-.4-.406-2.318.865-3.051l66.966-38.664",
    transform: "translate(-24.751 -95.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71189",
    "data-name": "Path 71189",
    className: "cls-23",
    d: "M54.24,201.778c-.408-.267-.408-.267-22-12.8-.711-.381-.711-.381-1.557-.765q12.551,7.309,25.112,14.6l-.183-.111c-.415-.273-.957-.653-1.372-.925",
    transform: "translate(-27.929 -145.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71190",
    "data-name": "Path 71190",
    className: "cls-31",
    d: "M66.908,143.2c-9.077,5.253-18.629,9.687-27.23,15.763-.332.234-.853.94,1.471,2.429,32.865,19.049,32.865,19.049,34.375,18.347,9.078-5.255,18.629-9.687,27.231-15.762.332-.235.853-.942-1.471-2.431C68.342,142.453,68.342,142.453,66.908,143.2",
    transform: "translate(-32.588 -120.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71191",
    "data-name": "Path 71191",
    className: "cls-27",
    d: "M73.324,178.374c-1.425.531-3.408-.419-4.194-.853C36.264,158.472,36.264,158.472,37.478,157.6c9.077-5.255,17.723-11.253,27.23-15.763.851-.4,2.536-.061,4.195.853,32.865,19.049,32.865,19.049,31.652,19.924-9.077,5.254-17.918,10.915-27.231,15.762M63.185,140.952c-9.077,5.254-18.873,9.265-27.231,15.763-1.792,1.394.376,3.1,1.829,3.987,34.112,19.771,34.112,19.771,37.065,18.556,9.077-5.255,18.874-9.265,27.23-15.763,1.794-1.394-.376-3.1-1.828-3.988-34.433-19.958-34.433-19.958-37.065-18.555",
    transform: "translate(-30.389 -119.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71192",
    "data-name": "Path 71192",
    className: "cls-31",
    d: "M139.343,103.167c-8.084,4.68-16.385,8.986-24.252,14.038-.629.4-.562.965.17,1.428,18.632,10.8,18.632,10.8,19.914,10.212,8.083-4.68,16.383-8.987,24.251-14.039.63-.4.565-.964-.165-1.426-18.737-10.86-18.737-10.86-19.918-10.214",
    transform: "translate(-72.911 -99.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71193",
    "data-name": "Path 71193",
    className: "cls-27",
    d: "M132.964,127.436a2.741,2.741,0,0,1-2.462-.1c-18.7-10.84-18.7-10.84-17.622-11.544,25.284-14.635,25.284-14.635,26.718-13.939,18.7,10.838,18.7,10.838,17.616,11.541-8.084,4.679-16.053,9.556-24.251,14.038m2.645-26.562c-24.35,14.1-24.35,14.1-24.474,14.184-.609.437-1.237,1.595.746,2.843,20.149,11.679,20.149,11.679,22.611,10.421,24.348-14.093,24.348-14.093,24.473-14.184.608-.436,1.234-1.592-.75-2.84-20.222-11.722-20.222-11.722-22.607-10.423",
    transform: "translate(-70.702 -98.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71194",
    "data-name": "Path 71194",
    className: "cls-31",
    d: "M199.866,138.438c-24.906,14.417-24.906,14.417-25.134,14.857,6.812,3.949,6.812,3.949,8,3.306,24.906-14.417,24.906-14.417,25.134-14.856-6.84-3.965-6.84-3.965-8-3.306",
    transform: "translate(-105.088 -118.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71195",
    "data-name": "Path 71195",
    className: "cls-27",
    d: "M180.558,155.091a4.064,4.064,0,0,1-1.413.511l-6.584-3.816a1.988,1.988,0,0,1,.883-.818c24.936-14.434,24.936-14.434,25.665-14.549l6.584,3.817a1.993,1.993,0,0,1-.883.818c-8.084,4.679-16.134,9.416-24.251,14.038m15.608-19.048c-26.461,15.317-26.461,15.317-24.972,16.305,8.517,4.937,8.517,4.937,10.892,3.629,26.459-15.315,26.459-15.315,24.969-16.3-8.546-4.954-8.546-4.954-10.889-3.631",
    transform: "translate(-102.917 -116.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71196",
    "data-name": "Path 71196",
    className: "cls-31",
    d: "M228.605,154.384c-24.919,14.425-24.919,14.425-25.2,14.816,5.116,2.965,5.116,2.965,6.292,2.317,24.936-14.434,24.936-14.434,25.2-14.82-5.132-2.974-5.132-2.974-6.287-2.313",
    transform: "translate(-120.445 -126.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71197",
    "data-name": "Path 71197",
    className: "cls-27",
    d: "M207.507,169.989a5.142,5.142,0,0,1-1.349.547l-4.942-2.865a2.964,2.964,0,0,1,.952-.779c24.948-14.442,24.948-14.442,25.6-14.588l4.942,2.864a2.8,2.8,0,0,1-.947.781c-8.084,4.679-16.143,9.4-24.252,14.039M224.9,151.972c-26.443,15.307-26.443,15.307-25.146,16.2,6.9,4,6.9,4,9.283,2.7,26.446-15.309,26.446-15.309,25.145-16.2-6.95-4.029-6.95-4.029-9.282-2.7",
    transform: "translate(-118.259 -125.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71198",
    "data-name": "Path 71198",
    className: "cls-31",
    d: "M253.007,169c-25.34,14.668-25.34,14.668-24.306,15.337,16.587,9.614,16.587,9.614,17.85,9.016,25.339-14.668,25.339-14.668,24.305-15.337-16.673-9.664-16.673-9.664-17.849-9.016",
    transform: "translate(-133.826 -134.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71199",
    "data-name": "Path 71199",
    className: "cls-27",
    d: "M244.213,191.928a2.534,2.534,0,0,1-2.242.031c-16.586-9.614-16.586-9.614-15.553-10.345,25.28-14.633,25.28-14.633,26.493-14.069,16.587,9.614,16.587,9.614,15.553,10.345-8.084,4.679-16.069,9.531-24.252,14.039m4.933-25.236c-24.353,14.1-24.353,14.1-24.474,14.184-.615.434-1.3,1.559.522,2.714,18.093,10.486,18.093,10.486,20.544,9.221,24.352-14.1,24.352-14.1,24.474-14.183.614-.434,1.294-1.557-.526-2.712-18.159-10.526-18.159-10.526-20.539-9.225",
    transform: "translate(-131.489 -133.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71200",
    "data-name": "Path 71200",
    className: "cls-31",
    d: "M160.114,197.272c-9.077,5.255-18.49,9.927-27.23,15.762-.427.285-.907.92.674,1.968,25.336,14.685,25.336,14.685,26.9,14.017,9.077-5.255,18.49-9.927,27.231-15.763.426-.285.906-.919-.674-1.969-25.492-14.775-25.492-14.775-26.9-14.016",
    transform: "translate(-82.449 -149.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71201",
    "data-name": "Path 71201",
    className: "cls-27",
    d: "M158.256,227.627a3.937,3.937,0,0,1-3.4-.392c-25.336-14.686-25.336-14.686-24.18-15.593,28.455-16.471,28.455-16.471,30.629-15.371,25.336,14.685,25.336,14.685,24.18,15.593-9.077,5.254-17.987,10.8-27.231,15.763m-1.875-32.633c-9.077,5.254-18.735,9.506-27.231,15.762-1.915,1.411.087,2.939,1.037,3.529,26.889,15.585,26.889,15.585,29.6,14.228,9.076-5.255,18.735-9.505,27.231-15.763,1.914-1.409-.087-2.938-1.037-3.53C159,193.581,159,193.581,156.381,194.993",
    transform: "translate(-80.244 -148.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71202",
    "data-name": "Path 71202",
    className: "cls-23",
    d: "M137.116,249.909c-.543-.346-.543-.346-34.182-19.868-.858-.47-1.746-.883-2.608-1.345l39.09,22.717-.434-.267c-.561-.369-1.3-.875-1.867-1.237",
    transform: "translate(-65.233 -166.803)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67442",
    "data-name": "Group 67442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67441",
    "data-name": "Group 67441",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71204",
    "data-name": "Path 71204",
    className: "cls-24",
    d: "M190.01,232.323c-1.647.95-1.655-1.988-.008-2.939l66.966-38.664a5.819,5.819,0,0,1-.868.852c-1.223.958-1.124,2.578-.307,2.771l-65.782,37.98",
    transform: "translate(-101.115 -102.159)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67444",
    "data-name": "Group 67444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67443",
    "data-name": "Group 67443",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71205",
    "data-name": "Path 71205",
    className: "cls-23",
    d: "M162.336,168.537a.53.53,0,0,1-.286-.084l-.448-.286a.532.532,0,0,1,.573-.9l.448.287a.532.532,0,0,1-.287.98",
    transform: "translate(-86.431 -89.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71206",
    "data-name": "Path 71206",
    className: "cls-27",
    d: "M168.677,172.591a.531.531,0,0,1-.286-.084l-.7-.448a.532.532,0,0,1,.573-.9l.7.448a.532.532,0,0,1-.287.98m-2.1-1.344a.531.531,0,0,1-.286-.084l-.7-.448a.532.532,0,1,1,.573-.9l.7.448a.532.532,0,0,1-.287.98",
    transform: "translate(-88.565 -90.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71207",
    "data-name": "Path 71207",
    className: "cls-27",
    d: "M179.84,179.724a.529.529,0,0,1-.286-.084l-.7-.448a.532.532,0,1,1,.573-.9l.7.448a.532.532,0,0,1-.287.98m-2.1-1.344a.531.531,0,0,1-.287-.084l-.7-.449a.532.532,0,1,1,.573-.9l.7.449a.532.532,0,0,1-.287.98m-2.1-1.344a.53.53,0,0,1-.286-.084l-.7-.448a.532.532,0,1,1,.573-.9l.7.448a.532.532,0,0,1-.287.98",
    transform: "translate(-93.418 -94.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71208",
    "data-name": "Path 71208",
    className: "cls-27",
    d: "M188.969,185.558a.532.532,0,0,1-.287-.084l-.449-.286a.532.532,0,0,1,.573-.9l.184.118.192-.1a.532.532,0,1,1,.506.936l-.468.253a.533.533,0,0,1-.253.064",
    transform: "translate(-100.697 -98.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71209",
    "data-name": "Path 71209",
    className: "cls-27",
    d: "M194.268,181.118a.532.532,0,0,1-.253-1l.876-.473a.532.532,0,0,1,.506.936l-.877.474a.526.526,0,0,1-.252.064M196.9,179.7a.532.532,0,0,1-.254-1l.876-.474a.532.532,0,0,1,.507.936l-.877.474a.527.527,0,0,1-.252.064",
    transform: "translate(-103.774 -95.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71210",
    "data-name": "Path 71210",
    className: "cls-27",
    d: "M205.587,140.957a.532.532,0,0,1-.253-1l.876-.473a.532.532,0,0,1,.506.936l-.876.474a.528.528,0,0,1-.253.064m2.628-1.421a.532.532,0,0,1-.254-1l.876-.474a.532.532,0,0,1,.506.936l-.876.474a.528.528,0,0,1-.253.064m2.628-1.421a.532.532,0,0,1-.254-1l.876-.474a.532.532,0,1,1,.506.936l-.876.474a.528.528,0,0,1-.253.064m2.628-1.421a.532.532,0,0,1-.254-1l.876-.474a.532.532,0,0,1,.506.936l-.876.473a.53.53,0,0,1-.253.064m2.628-1.421a.532.532,0,0,1-.254-1l.876-.473a.532.532,0,1,1,.506.936l-.876.474a.534.534,0,0,1-.253.064m2.628-1.42a.532.532,0,0,1-.254-1l.876-.473a.532.532,0,1,1,.506.936l-.876.473a.529.529,0,0,1-.253.064m2.628-1.421a.532.532,0,0,1-.254-1l.876-.474a.532.532,0,1,1,.506.936l-.876.474a.532.532,0,0,1-.253.064m2.628-1.42a.532.532,0,0,1-.254-1l.876-.474a.532.532,0,1,1,.506.936l-.876.474a.529.529,0,0,1-.253.064m2.628-1.421a.532.532,0,0,1-.254-1l.876-.474a.532.532,0,0,1,.506.936l-.876.474a.529.529,0,0,1-.253.064m2.628-1.421a.532.532,0,0,1-.254-1l.876-.473a.532.532,0,0,1,.506.936l-.876.474a.529.529,0,0,1-.253.064m2.385-1.709a.532.532,0,0,1-.417-.862l.618-.781a.532.532,0,0,1,.834.66l-.618.781a.532.532,0,0,1-.417.2m1.854-2.343a.532.532,0,0,1-.417-.862l.618-.781a.532.532,0,0,1,.834.66l-.618.781a.531.531,0,0,1-.417.2m1.854-2.343a.532.532,0,0,1-.416-.862l.618-.781a.532.532,0,0,1,.834.66l-.618.781a.531.531,0,0,1-.417.2m1.854-2.343a.532.532,0,0,1-.417-.862l.618-.781a.532.532,0,0,1,.834.66l-.618.781a.532.532,0,0,1-.418.2m1.854-2.343a.532.532,0,0,1-.417-.862l.618-.781a.532.532,0,0,1,.834.66l-.618.781a.532.532,0,0,1-.418.2m1.854-2.343a.532.532,0,0,1-.417-.862l.618-.781a.532.532,0,0,1,.834.66l-.618.781a.532.532,0,0,1-.418.2m1.855-2.343a.532.532,0,0,1-.417-.862l.618-.781a.532.532,0,0,1,.834.66l-.618.781a.531.531,0,0,1-.417.2m2.214-1.8a.532.532,0,0,1-.14-1.045l.961-.263a.532.532,0,0,1,.281,1.026l-.96.263a.53.53,0,0,1-.141.019m2.882-.789a.532.532,0,0,1-.14-1.045l.961-.263a.532.532,0,1,1,.281,1.026l-.96.263a.53.53,0,0,1-.141.019m6.916-.058h-.029l-.994-.052a.532.532,0,0,1,.056-1.062l.994.052a.532.532,0,0,1-.027,1.063m-2.983-.157h-.028l-.995-.052a.532.532,0,0,1,.056-1.062l.995.052a.532.532,0,0,1-.028,1.063",
    transform: "translate(-109.838 -58.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71211",
    "data-name": "Path 71211",
    className: "cls-27",
    d: "M316.3,109.787h-.028l-.531-.028a.532.532,0,0,1-.5-.559.538.538,0,0,1,.559-.5l.237.013.137-.194a.532.532,0,0,1,.871.612l-.306.435a.532.532,0,0,1-.435.226",
    transform: "translate(-168.859 -58.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71212",
    "data-name": "Path 71212",
    className: "cls-27",
    d: "M320.292,101.334a.533.533,0,0,1-.435-.838l.632-.9a.532.532,0,0,1,.871.611l-.632.9a.531.531,0,0,1-.436.227m1.894-2.7a.532.532,0,0,1-.435-.838l.631-.9a.532.532,0,0,1,.871.612l-.631.9a.533.533,0,0,1-.436.226",
    transform: "translate(-171.28 -51.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71213",
    "data-name": "Path 71213",
    className: "cls-27",
    d: "M328.449,86.614a.533.533,0,0,1-.435-.838l.632-.9a.532.532,0,0,1,.871.611l-.631.9a.531.531,0,0,1-.436.227m1.894-2.7a.532.532,0,0,1-.435-.838l.631-.9a.532.532,0,1,1,.871.612l-.632.9a.53.53,0,0,1-.436.227m1.894-2.7a.525.525,0,0,1-.305-.1.531.531,0,0,1-.13-.741l.631-.9a.532.532,0,0,1,.871.612l-.631.9a.533.533,0,0,1-.436.226",
    transform: "translate(-175.649 -42.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71214",
    "data-name": "Path 71214",
    className: "cls-27",
    d: "M340.476,75.7a.527.527,0,0,1-.305-.1.809.809,0,0,1,.342-1.573l.486.217a.531.531,0,0,1,.219.791l-.306.435a.532.532,0,0,1-.436.226",
    transform: "translate(-181.995 -39.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71215",
    "data-name": "Path 71215",
    className: "cls-27",
    d: "M333.349,71.951a.53.53,0,0,1-.216-.046l-.778-.347a.532.532,0,0,1,.433-.971l.779.347a.532.532,0,0,1-.217,1.018m-2.336-1.042a.53.53,0,0,1-.216-.046l-.779-.347a.532.532,0,0,1,.434-.971l.779.347a.532.532,0,0,1-.217,1.017",
    transform: "translate(-176.606 -37.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71216",
    "data-name": "Path 71216",
    className: "cls-27",
    d: "M326.321,68.817a.531.531,0,0,1-.216-.046l-.486-.216a.532.532,0,0,1,.434-.971l.486.217a.532.532,0,0,1-.217,1.017",
    transform: "translate(-174.249 -36.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71217",
    "data-name": "Path 71217",
    className: "cls-34",
    d: "M160.583,165.4c0,.872-1.225,1.58-2.737,1.58s-2.737-.708-2.737-1.58,1.225-1.58,2.737-1.58,2.737.707,2.737,1.58",
    transform: "translate(-83.084 -87.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71218",
    "data-name": "Path 71218",
    className: "cls-35",
    d: "M319.625,61.8c.837.247,1.17,1.622.743,3.072s-1.452,2.426-2.289,2.18-1.17-1.622-.743-3.073,1.452-2.425,2.289-2.179",
    transform: "translate(-169.882 -33.081)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_71219",
    "data-name": "Path 71219",
    className: "cls-36",
    d: "M345.607,116.795l31.037-8.575-1.411,2.3-27.255,7.649Z",
    transform: "translate(-185.125 -57.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71220",
    "data-name": "Path 71220",
    className: "cls-36",
    d: "M375.3,97.513l2.277-.84.593-16.541-2.051-1.192Z",
    transform: "translate(-201.029 -42.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71221",
    "data-name": "Path 71221",
    className: "cls-37",
    d: "M345.607,126.687l1.5,8.819,2.644,1.5-1.77-8.94Z",
    transform: "translate(-185.125 -67.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71222",
    "data-name": "Path 71222",
    className: "cls-36",
    d: "M308.171,147.657l-34.045,3.4,3.142,1.793,34.406-3.221Z",
    transform: "translate(-146.836 -79.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71223",
    "data-name": "Path 71223",
    className: "cls-36",
    d: "M279.915,28.617,270.767,54.1l2.919,1.557,8.649-25.632Z",
    transform: "translate(-145.037 -15.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71224",
    "data-name": "Path 71224",
    className: "cls-37",
    d: "M247.23,78.738l-20.4-4.123,4.453,2.7,18.87,2.978Z",
    transform: "translate(-121.5 -39.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71225",
    "data-name": "Path 71225",
    className: "cls-36",
    d: "M284.172,60.362l18.087,11.1-1.416,2.264L283.224,62.842Z",
    transform: "translate(-151.709 -32.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71226",
    "data-name": "Path 71226",
    className: "cls-36",
    d: "M201.682,76.219l-18.623,6.1-1.387,2.821,22.805-7.292Z",
    transform: "translate(-97.313 -40.827)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67446",
    "data-name": "Group 67446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67445",
    "data-name": "Group 67445",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71227",
    "data-name": "Path 71227",
    className: "cls-11",
    d: "M27.249,183.912a5.377,5.377,0,0,1-.471-.293,3.816,3.816,0,0,1-.328-.227c-.121-.1-.241-.2-.358-.3a2.58,2.58,0,0,1-.376-.354,4.34,4.34,0,0,1-1.02-1.616,1.1,1.1,0,0,1-.078-.224,3.259,3.259,0,0,0,.048.925A4.07,4.07,0,0,0,25.71,184l-.658,1.244,74.269,41.936,6.458,3.648a.463.463,0,0,0,.049.028c.064.035.123.06.189.1a.658.658,0,0,0,.077.042,16.767,16.767,0,0,0,5.157,1.66,18.822,18.822,0,0,0,9.97-1.159c.331-.144.657-.3.965-.456a56.947,56.947,0,0,1-12.976-4.972,6.326,6.326,0,0,1-.667.1c-.132.02-.267.038-.4.052a14.459,14.459,0,0,1-7.943-1.135,3.91,3.91,0,0,1-.4-.2.494.494,0,0,1-.049-.032Z",
    transform: "translate(-13.18 -96.899)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67448",
    "data-name": "Group 67448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67447",
    "data-name": "Group 67447",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71228",
    "data-name": "Path 71228",
    className: "cls-38",
    d: "M278.606,188.433a4.112,4.112,0,0,1,.326.391.155.155,0,0,0,.015.026.666.666,0,0,1,.04.1c1.614,2.512-2.026,3.313-4.1,3.309-1.189.052-3.007-.28-4.1.021-1.694.475-1.189,1.057-2.389,1.938-1.778,1.182-6.117.424-7.764-1.348-2.463-2.844,1.081-3.087,3.06-3.909,1.291-.517,1.323-1.255,2.22-2.031a6.073,6.073,0,0,1,2.905-1.047c2.456-.436,7.585.214,9.772,2.535.01,0,.011.006.016.01m-16.938,4c1.443,1.464,4.882,1.929,6.492.941,1.087-.732,1.092-1.495,2.7-1.718,1.045-.123,2.261.058,3.325.013,1.572-.005,4.33-.333,4.276-1.7a1.6,1.6,0,0,0-.32-.841.472.472,0,0,0-.036-.087s0-.01-.008-.014a1.449,1.449,0,0,0-.316-.352c-1.927-1.911-6.482-2.431-8.678-2.061a5.8,5.8,0,0,0-2.617.875,11.72,11.72,0,0,1-2.018,1.69c-1.529.854-3.909.912-3.479,2.229a3.03,3.03,0,0,0,.682,1.025",
    transform: "translate(-139.158 -99.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71229",
    "data-name": "Path 71229",
    className: "cls-39",
    d: "M279.1,189.521c-1.928-1.911-6.482-2.431-8.678-2.061a5.809,5.809,0,0,0-2.617.874,11.7,11.7,0,0,1-2.018,1.69c-1.529.854-3.91.912-3.479,2.229.383-.758,2.2-.925,3.456-1.623a11.756,11.756,0,0,0,2.018-1.69,5.792,5.792,0,0,1,2.617-.876c2.435-.41,7.776.28,9.215,2.735l.165.014a1.6,1.6,0,0,0-.32-.841.418.418,0,0,0-.036-.087s0-.01-.007-.014a2.565,2.565,0,0,0-.316-.352",
    transform: "translate(-140.477 -100.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71230",
    "data-name": "Path 71230",
    className: "cls-40",
    d: "M262.365,192.953a3.023,3.023,0,0,0,.682,1.025c1.443,1.464,4.882,1.929,6.492.941,1.087-.732,1.092-1.495,2.7-1.718,1.045-.123,2.261.058,3.325.013,1.572-.005,4.33-.333,4.276-1.7l-.165-.014c-1.439-2.456-6.78-3.145-9.215-2.735a5.8,5.8,0,0,0-2.617.876,11.754,11.754,0,0,1-2.018,1.69c-1.253.7-3.074.865-3.456,1.623",
    transform: "translate(-140.536 -101.053)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67450",
    "data-name": "Group 67450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67449",
    "data-name": "Group 67449",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71231",
    "data-name": "Path 71231",
    className: "cls-41",
    d: "M314.922,2.385l.087-.047c-.028.016-.059.031-.087.047",
    transform: "translate(-168.688 -1.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71232",
    "data-name": "Path 71232",
    className: "cls-41",
    d: "M315.688,1.974c-.024.01-.041.022-.064.032.046-.021.091-.043.137-.062l-.073.031",
    transform: "translate(-169.064 -1.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71233",
    "data-name": "Path 71233",
    className: "cls-42",
    d: "M320.8.118c-1.2-.4-3.638.315-4.721.754a4.723,4.723,0,0,1,3.308-.008c3.93,1.325,9.314,5.657,7.926,12.847-1,5.209-6.8,13.058-7.609,12.843.155.137,1.48-.4,1.609-.438,1.35-.453,6.609-7.634,7.609-12.842,1.387-7.19-4.191-11.83-8.122-13.155",
    transform: "translate(-169.308 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71234",
    "data-name": "Path 71234",
    className: "cls-42",
    d: "M321.456,21.125a3.592,3.592,0,0,1-.952-.188c-2.572-.87-4.769-4.389-4.911-7.868-.082-2.127.624-3.74,1.772-4.478-2.051-.061-3.5,1.92-3.38,4.916.143,3.48,2.339,7,4.912,7.868a2.8,2.8,0,0,0,2.56-.25",
    transform: "translate(-168.183 -4.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71235",
    "data-name": "Path 71235",
    className: "cls-35",
    d: "M323.358,14.368c1.388-7.191-4-11.522-7.925-12.847a4.72,4.72,0,0,0-3.308.008l-.073.03c-.047.02-.092.041-.137.063-.081.038-.161.078-.239.12l-.087.048c-1.86,1.07-3.017,3.592-2.88,6.947.208,5.311,5.094,17.962,7.041,18.474.809.215,6.609-7.633,7.609-12.842m-7.291,3.062c-2.573-.87-4.769-4.389-4.912-7.868-.116-3,1.33-4.976,3.38-4.916a3.555,3.555,0,0,1,1.031.187,7.66,7.66,0,0,1,4.91,7.868c-.087,2.127-.756,3.741-1.85,4.479a2.8,2.8,0,0,1-2.56.25",
    transform: "translate(-165.354 -0.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71236",
    "data-name": "Path 71236",
    className: "cls-41",
    d: "M166.542,84.637l-.083-.055c.027.019.057.036.083.055",
    transform: "translate(-89.164 -45.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71237",
    "data-name": "Path 71237",
    className: "cls-41",
    d: "M165.751,84.164c.022.011.039.025.061.037-.044-.025-.087-.05-.132-.073l.071.036",
    transform: "translate(-88.747 -45.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71238",
    "data-name": "Path 71238",
    className: "cls-43",
    d: "M144.925,81.585c1.227-.31,3.6.592,4.65,1.112a4.72,4.72,0,0,0-3.3-.26c-4.02,1.022-9.718,4.931-8.882,12.206.6,5.27,5.786,13.538,6.609,13.385-.164.124-1.446-.507-1.57-.559-1.313-.555-6.009-8.115-6.609-13.385-.836-7.275,5.08-11.477,9.1-12.5",
    transform: "translate(-72.712 -43.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71239",
    "data-name": "Path 71239",
    className: "cls-43",
    d: "M149,102.535a3.594,3.594,0,0,0,.964-.115c2.631-.672,5.089-4.013,5.5-7.471.245-2.115-.337-3.777-1.426-4.6,2.049.1,3.341,2.181,3,5.159-.406,3.458-2.865,6.8-5.5,7.471a2.8,2.8,0,0,1-2.533-.444",
    transform: "translate(-79.81 -48.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71240",
    "data-name": "Path 71240",
    className: "cls-34",
    d: "M145.811,108.878c1.981-.361,7.816-12.6,8.429-17.884.391-3.335-.569-5.938-2.342-7.146l-.083-.055c-.076-.048-.152-.094-.23-.138-.044-.025-.087-.05-.132-.073l-.071-.036a4.725,4.725,0,0,0-3.3-.26c-4.021,1.022-9.718,4.931-8.882,12.206.6,5.27,5.786,13.538,6.609,13.385m-2.105-10.22c-1.036-.819-1.579-2.48-1.5-4.607a7.66,7.66,0,0,1,5.5-7.471,3.566,3.566,0,0,1,1.042-.109c2.049.1,3.341,2.181,3,5.159-.406,3.458-2.865,6.8-5.5,7.471a2.8,2.8,0,0,1-2.533-.444",
    transform: "translate(-74.52 -44.518)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67452",
    "data-name": "Group 67452",
    transform: "translate(1037.265 340.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63833",
    "data-name": "Group 63833",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63318",
    "data-name": "Group 63318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63317",
    "data-name": "Group 63317",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63310",
    "data-name": "Group 63310",
    className: "cls-45",
    transform: "translate(2.432 13.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63309",
    "data-name": "Group 63309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63308",
    "data-name": "Group 63308",
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62271",
    "data-name": "Path 62271",
    className: "cls-47",
    d: "M53.544,236.533,56.52,234.8l-.525-.3H54.336l-12.342,7.125.525.3h1.659l1.289-.744,3.275,1.891-3.475,2.007c-.4.238.051.83,1.252,1.524a12.453,12.453,0,0,0,5.014,1.636,1.352,1.352,0,0,0,.557-.09l.022.013-.753.435c-.4.238.051.83,1.252,1.524a12.453,12.453,0,0,0,5.014,1.636,1.35,1.35,0,0,0,.557-.09l.073.042h.987v.275l6.218,3.59h.847V243.9Z",
    transform: "translate(-41.994 -234.499)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63313",
    "data-name": "Group 63313",
    className: "cls-48",
    transform: "translate(45.792 34.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63312",
    "data-name": "Group 63312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63311",
    "data-name": "Group 63311",
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62272",
    "data-name": "Path 62272",
    className: "cls-47",
    d: "M802.434,596.393l-.237.135.476.275-11.5,6.641-.375.11h1.036l11.5-6.641Z",
    transform: "translate(-790.795 -596.393)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63316",
    "data-name": "Group 63316",
    className: "cls-45",
    transform: "translate(27.147 28.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63315",
    "data-name": "Group 63315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63314",
    "data-name": "Group 63314",
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62273",
    "data-name": "Path 62273",
    className: "cls-47",
    d: "M499.851,500.547h0l-.275-.157a.109.109,0,0,0-.049-.009h-1.641a1.5,1.5,0,0,0-.429.107l-5.088-2.938.641-.37-2.759-1.593-1.6-.273-12.107,8.137a12.34,12.34,0,0,0-4.847-1.541,1.22,1.22,0,0,0-.6.112l-2.136,1.234c-.4.238.051.83,1.252,1.524a12.453,12.453,0,0,0,5.014,1.636,1.57,1.57,0,0,0,.548-.078l-.776.448,3.689,2.13h3.434l.22-.127.332.192h.118l.264.152a.227.227,0,0,0,.129.034h1.605a1.325,1.325,0,0,0,.553-.157l.313-.15,2.182-.641,11.5-6.641-.65-.375.92-.454c.191-.094.281-.174.238-.2",
    transform: "translate(-468.82 -495.314)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62274",
    "data-name": "Path 62274",
    className: "cls-51",
    d: "M417.288,433.25l2.539,1.466v-1.5l-2.539-1.466Z",
    transform: "translate(-393.125 -406.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62275",
    "data-name": "Path 62275",
    className: "cls-52",
    d: "M417.288,422.869l2.539,1.466.945-.546-2.539-1.466Z",
    transform: "translate(-393.125 -397.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62276",
    "data-name": "Path 62276",
    className: "cls-53",
    d: "M0,139.916l.525.3,12.342-7.125-.525-.3Z",
    transform: "translate(0 -125.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62277",
    "data-name": "Path 62277",
    className: "cls-54",
    d: "M0,257.839l.525.3v-2l-.525-.3Z",
    transform: "translate(0 -241.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62278",
    "data-name": "Path 62278",
    className: "cls-52",
    d: "M21.4,138.024v2L9.062,147.145v-2Z",
    transform: "translate(-8.537 -130.031)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63320",
    "data-name": "Group 63320",
    transform: "translate(3.481 17.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63319",
    "data-name": "Group 63319",
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23255",
    "data-name": "Rectangle 23255",
    className: "cls-56",
    width: 3.712,
    height: 3.576,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -1.075, 0.62)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63322",
    "data-name": "Group 63322",
    transform: "translate(4.122 17.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63321",
    "data-name": "Group 63321",
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23256",
    "data-name": "Rectangle 23256",
    className: "cls-58",
    width: 12.501,
    height: 12.635,
    transform: "translate(-4.34 2.346) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63324",
    "data-name": "Group 63324",
    transform: "translate(5.343 17.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63323",
    "data-name": "Group 63323",
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23257",
    "data-name": "Rectangle 23257",
    className: "cls-60",
    width: 10.785,
    height: 11.16,
    transform: "translate(-3.7 2.136) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63326",
    "data-name": "Group 63326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63325",
    "data-name": "Group 63325",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62282",
    "data-name": "Path 62282",
    className: "cls-61",
    d: "M76.028,326.375c-1.107-1.917-2.9-2.952-4.007-2.313s-1.107,2.71,0,4.627,2.9,2.952,4.007,2.314,1.107-2.71,0-4.627",
    transform: "translate(-67.068 -305.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62283",
    "data-name": "Path 62283",
    className: "cls-19",
    d: "M92.5,349.047c-.693-1.2-1.817-1.849-2.51-1.449s-.693,1.7,0,2.9,1.817,1.849,2.51,1.449.693-1.7,0-2.9",
    transform: "translate(-84.292 -327.359)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63328",
    "data-name": "Group 63328",
    transform: "translate(5.402 20.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63327",
    "data-name": "Group 63327",
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23259",
    "data-name": "Rectangle 23259",
    className: "cls-63",
    width: 5.083,
    height: 5.394,
    transform: "translate(-1.996 1.065) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63345",
    "data-name": "Group 63345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63344",
    "data-name": "Group 63344",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63331",
    "data-name": "Group 63331",
    className: "cls-64",
    transform: "translate(7.32 23.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63330",
    "data-name": "Group 63330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63329",
    "data-name": "Group 63329",
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62285",
    "data-name": "Path 62285",
    className: "cls-66",
    d: "M126.411,411.837a.383.383,0,0,0,.111.257.74.74,0,0,0,.674.179.769.769,0,0,0,.139-.124,1.484,1.484,0,0,1-.924-.312",
    transform: "translate(-126.411 -411.837)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63334",
    "data-name": "Group 63334",
    className: "cls-67",
    transform: "translate(5.403 20.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63333",
    "data-name": "Group 63333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63332",
    "data-name": "Group 63332",
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62286",
    "data-name": "Path 62286",
    className: "cls-66",
    d: "M94.365,354.976c-.026-.041-.052-.082-.076-.125a2.223,2.223,0,0,1-.189-2.381.779.779,0,0,0-.335.1,1.36,1.36,0,0,0-.4,1.51,2.858,2.858,0,0,0,1,.9",
    transform: "translate(-93.311 -352.469)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62287",
    "data-name": "Path 62287",
    className: "cls-69",
    d: "M102.612,352.427a2.223,2.223,0,0,0,.189,2.381,2.35,2.35,0,0,0,1.862,1.369,2.222,2.222,0,0,0-.189-2.381,2.35,2.35,0,0,0-1.862-1.369",
    transform: "translate(-96.42 -332.017)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63337",
    "data-name": "Group 63337",
    className: "cls-70",
    transform: "translate(8.42 22.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63336",
    "data-name": "Group 63336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63335",
    "data-name": "Group 63335",
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62288",
    "data-name": "Path 62288",
    className: "cls-47",
    d: "M145.438,394.086H145.4l.079.286a2.63,2.63,0,0,0-.041-.286",
    transform: "translate(-145.4 -394.086)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63340",
    "data-name": "Group 63340",
    className: "cls-70",
    transform: "translate(6.571 22.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63339",
    "data-name": "Group 63339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63338",
    "data-name": "Group 63338",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62289",
    "data-name": "Path 62289",
    className: "cls-47",
    d: "M113.909,391.355l-.119-.43h-.309l.108.388a.4.4,0,0,0,.038.09c.067.116.176.179.243.141.049-.029.062-.1.039-.189",
    transform: "translate(-113.48 -390.925)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63343",
    "data-name": "Group 63343",
    className: "cls-70",
    transform: "translate(5.926 20.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63342",
    "data-name": "Group 63342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63341",
    "data-name": "Group 63341",
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62290",
    "data-name": "Path 62290",
    className: "cls-47",
    d: "M104.556,354.293a2.562,2.562,0,0,1,.217.164,3.667,3.667,0,0,0-.3-.661,2.35,2.35,0,0,0-1.862-1.369,2.222,2.222,0,0,0,.189,2.381c.025.043.05.084.076.125a1.057,1.057,0,0,1,.381-.789l.481,1.721a1.482,1.482,0,0,0,.924.311,1.129,1.129,0,0,0,.25-.611Z",
    transform: "translate(-102.346 -352.424)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63347",
    "data-name": "Group 63347",
    transform: "translate(6.418 22.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63346",
    "data-name": "Group 63346",
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23266",
    "data-name": "Rectangle 23266",
    className: "cls-75",
    width: 0.707,
    height: 0.722,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.252, 0.136)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63349",
    "data-name": "Group 63349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63348",
    "data-name": "Group 63348",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62292",
    "data-name": "Path 62292",
    className: "cls-61",
    d: "M111.123,387.822c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.141.067-.165,0-.281",
    transform: "translate(-104.412 -365.222)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63351",
    "data-name": "Group 63351",
    transform: "translate(6.101 21.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63350",
    "data-name": "Group 63350",
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23268",
    "data-name": "Rectangle 23268",
    className: "cls-77",
    width: 0.707,
    height: 0.722,
    transform: "translate(-0.252 0.136) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63353",
    "data-name": "Group 63353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63352",
    "data-name": "Group 63352",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62294",
    "data-name": "Path 62294",
    className: "cls-78",
    d: "M105.646,369.393c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.14.067-.165,0-.281",
    transform: "translate(-99.252 -347.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63355",
    "data-name": "Group 63355",
    transform: "translate(7.183 23.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63354",
    "data-name": "Group 63354",
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23270",
    "data-name": "Rectangle 23270",
    className: "cls-80",
    width: 0.707,
    height: 0.722,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.252, 0.136)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63357",
    "data-name": "Group 63357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63356",
    "data-name": "Group 63356",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62296",
    "data-name": "Path 62296",
    className: "cls-78",
    d: "M124.344,401.78c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.141.067-.165,0-.281",
    transform: "translate(-116.867 -378.372)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63359",
    "data-name": "Group 63359",
    transform: "translate(6.257 21.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63358",
    "data-name": "Group 63358",
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23272",
    "data-name": "Rectangle 23272",
    className: "cls-82",
    width: 2.873,
    height: 2.935,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -1.025, 0.552)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63361",
    "data-name": "Group 63361",
    transform: "translate(6.743 21.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63360",
    "data-name": "Group 63360",
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23273",
    "data-name": "Rectangle 23273",
    className: "cls-84",
    width: 1.388,
    height: 1.053,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63363",
    "data-name": "Group 63363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63362",
    "data-name": "Group 63362",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62299",
    "data-name": "Path 62299",
    className: "cls-61",
    d: "M109.243,372.085c-.273-.473-.716-.729-.989-.571s-.273.669,0,1.142.716.729.989.571.273-.669,0-1.142",
    transform: "translate(-101.792 -349.958)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63365",
    "data-name": "Group 63365",
    transform: "translate(6.418 20.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63364",
    "data-name": "Group 63364",
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23275",
    "data-name": "Rectangle 23275",
    className: "cls-86",
    width: 0.707,
    height: 0.722,
    transform: "translate(-0.252 0.136) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63367",
    "data-name": "Group 63367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63366",
    "data-name": "Group 63366",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62301",
    "data-name": "Path 62301",
    className: "cls-78",
    d: "M111.123,357.288c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.141.067-.165,0-.281",
    transform: "translate(-104.412 -336.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62302",
    "data-name": "Path 62302",
    className: "cls-51",
    d: "M124.35,359.44l.1-.059a2.957,2.957,0,0,0-.37-.34.253.253,0,0,0,.025.258c.067.116.176.179.243.141",
    transform: "translate(-116.872 -338.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62303",
    "data-name": "Path 62303",
    className: "cls-78",
    d: "M124.35,359.44a.123.123,0,0,0,.05-.114,2.9,2.9,0,0,0-.318-.284.253.253,0,0,0,.025.258c.067.116.176.179.243.141",
    transform: "translate(-116.872 -338.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62304",
    "data-name": "Path 62304",
    className: "cls-78",
    d: "M137.383,373.592q-.046-.079-.094-.155a.288.288,0,0,0,.039.233.294.294,0,0,0,.175.149c-.037-.076-.076-.151-.12-.227",
    transform: "translate(-129.328 -351.813)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63369",
    "data-name": "Group 63369",
    transform: "translate(8.266 22.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63368",
    "data-name": "Group 63368",
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23277",
    "data-name": "Rectangle 23277",
    className: "cls-88",
    width: 0.453,
    height: 0.539,
    transform: "translate(-0.225 0.12) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63371",
    "data-name": "Group 63371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63370",
    "data-name": "Group 63370",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62306",
    "data-name": "Path 62306",
    className: "cls-61",
    d: "M142.9,390.852a.11.11,0,0,0-.1,0c-.067.039-.067.165,0,.281a.29.29,0,0,0,.179.15,2.793,2.793,0,0,0-.079-.429",
    transform: "translate(-134.483 -368.207)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63373",
    "data-name": "Group 63373",
    transform: "translate(7.949 23.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63372",
    "data-name": "Group 63372",
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23279",
    "data-name": "Rectangle 23279",
    className: "cls-90",
    width: 0.707,
    height: 0.722,
    transform: "translate(-0.252 0.136) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63375",
    "data-name": "Group 63375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63374",
    "data-name": "Group 63374",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62308",
    "data-name": "Path 62308",
    className: "cls-78",
    d: "M137.566,403.09c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.141.067-.165,0-.281",
    transform: "translate(-129.323 -379.606)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63377",
    "data-name": "Group 63377",
    transform: "translate(10.214 20.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63376",
    "data-name": "Group 63376",
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23281",
    "data-name": "Rectangle 23281",
    className: "cls-92",
    width: 12.501,
    height: 12.635,
    transform: "translate(-4.34 2.346) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63379",
    "data-name": "Group 63379",
    transform: "translate(11.435 20.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63378",
    "data-name": "Group 63378",
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23282",
    "data-name": "Rectangle 23282",
    className: "cls-94",
    width: 10.785,
    height: 11.16,
    transform: "translate(-3.7 2.136) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63381",
    "data-name": "Group 63381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63380",
    "data-name": "Group 63380",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62311",
    "data-name": "Path 62311",
    className: "cls-61",
    d: "M181.223,387.109c-1.107-1.917-2.9-2.952-4.007-2.314s-1.107,2.711,0,4.627,2.9,2.952,4.007,2.314,1.107-2.711,0-4.627",
    transform: "translate(-166.172 -362.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62312",
    "data-name": "Path 62312",
    className: "cls-19",
    d: "M197.7,409.781c-.693-1.2-1.817-1.849-2.51-1.449s-.693,1.7,0,2.9,1.817,1.849,2.51,1.449.693-1.7,0-2.9",
    transform: "translate(-183.395 -384.576)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63383",
    "data-name": "Group 63383",
    transform: "translate(11.494 23.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63382",
    "data-name": "Group 63382",
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23284",
    "data-name": "Rectangle 23284",
    className: "cls-96",
    width: 5.083,
    height: 5.394,
    transform: "translate(-1.996 1.065) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63400",
    "data-name": "Group 63400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63399",
    "data-name": "Group 63399",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63386",
    "data-name": "Group 63386",
    className: "cls-64",
    transform: "translate(13.411 27.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63385",
    "data-name": "Group 63385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63384",
    "data-name": "Group 63384",
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62314",
    "data-name": "Path 62314",
    className: "cls-66",
    d: "M231.606,472.571a.383.383,0,0,0,.111.257.74.74,0,0,0,.674.179.769.769,0,0,0,.139-.124,1.484,1.484,0,0,1-.924-.312",
    transform: "translate(-231.606 -472.571)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63389",
    "data-name": "Group 63389",
    className: "cls-67",
    transform: "translate(11.495 23.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63388",
    "data-name": "Group 63388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63387",
    "data-name": "Group 63387",
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62315",
    "data-name": "Path 62315",
    className: "cls-66",
    d: "M199.56,415.71c-.026-.041-.052-.082-.076-.125a2.223,2.223,0,0,1-.189-2.381.78.78,0,0,0-.335.1,1.36,1.36,0,0,0-.4,1.51,2.859,2.859,0,0,0,1,.9",
    transform: "translate(-198.506 -413.203)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62316",
    "data-name": "Path 62316",
    className: "cls-69",
    d: "M207.807,413.162a2.223,2.223,0,0,0,.189,2.381,2.35,2.35,0,0,0,1.862,1.369,2.222,2.222,0,0,0-.189-2.381,2.35,2.35,0,0,0-1.862-1.369",
    transform: "translate(-195.523 -389.235)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63392",
    "data-name": "Group 63392",
    className: "cls-70",
    transform: "translate(14.511 26.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63391",
    "data-name": "Group 63391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63390",
    "data-name": "Group 63390",
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62317",
    "data-name": "Path 62317",
    className: "cls-47",
    d: "M250.633,454.821H250.6l.079.286a2.626,2.626,0,0,0-.041-.286",
    transform: "translate(-250.595 -454.821)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63395",
    "data-name": "Group 63395",
    className: "cls-70",
    transform: "translate(12.663 26.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63394",
    "data-name": "Group 63394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63393",
    "data-name": "Group 63393",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62318",
    "data-name": "Path 62318",
    className: "cls-47",
    d: "M219.1,452.089l-.119-.43h-.309l.108.388a.4.4,0,0,0,.038.09c.067.116.176.179.243.141.049-.029.062-.1.039-.189",
    transform: "translate(-218.675 -451.659)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63398",
    "data-name": "Group 63398",
    className: "cls-70",
    transform: "translate(12.018 23.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63397",
    "data-name": "Group 63397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63396",
    "data-name": "Group 63396",
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62319",
    "data-name": "Path 62319",
    className: "cls-47",
    d: "M209.751,415.028a2.577,2.577,0,0,1,.217.164,3.665,3.665,0,0,0-.3-.661,2.35,2.35,0,0,0-1.862-1.369,2.222,2.222,0,0,0,.189,2.381c.025.043.051.084.076.125a1.057,1.057,0,0,1,.381-.789l.481,1.721a1.481,1.481,0,0,0,.924.311,1.128,1.128,0,0,0,.25-.61Z",
    transform: "translate(-207.541 -413.159)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63402",
    "data-name": "Group 63402",
    transform: "translate(12.509 25.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63401",
    "data-name": "Group 63401",
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23291",
    "data-name": "Rectangle 23291",
    className: "cls-98",
    width: 0.707,
    height: 0.722,
    transform: "translate(-0.252 0.136) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63404",
    "data-name": "Group 63404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63403",
    "data-name": "Group 63403",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62321",
    "data-name": "Path 62321",
    className: "cls-61",
    d: "M216.318,448.557c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.141.067-.165,0-.281",
    transform: "translate(-203.515 -422.44)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63406",
    "data-name": "Group 63406",
    transform: "translate(12.192 24.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63405",
    "data-name": "Group 63405",
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23293",
    "data-name": "Rectangle 23293",
    className: "cls-100",
    width: 0.707,
    height: 0.722,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.252, 0.136)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63408",
    "data-name": "Group 63408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63407",
    "data-name": "Group 63407",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62323",
    "data-name": "Path 62323",
    className: "cls-78",
    d: "M210.841,430.127c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.141.067-.165,0-.281",
    transform: "translate(-198.355 -405.077)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63410",
    "data-name": "Group 63410",
    transform: "translate(13.275 26.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63409",
    "data-name": "Group 63409",
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23295",
    "data-name": "Rectangle 23295",
    className: "cls-102",
    width: 0.707,
    height: 0.722,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.252, 0.136)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63412",
    "data-name": "Group 63412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63411",
    "data-name": "Group 63411",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62325",
    "data-name": "Path 62325",
    className: "cls-78",
    d: "M229.539,462.514c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.141.067-.165,0-.281",
    transform: "translate(-215.971 -435.589)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63414",
    "data-name": "Group 63414",
    transform: "translate(12.348 24.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63413",
    "data-name": "Group 63413",
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23297",
    "data-name": "Rectangle 23297",
    className: "cls-104",
    width: 2.873,
    height: 2.935,
    transform: "translate(-1.025 0.552) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63416",
    "data-name": "Group 63416",
    transform: "translate(12.835 24.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63415",
    "data-name": "Group 63415",
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23298",
    "data-name": "Rectangle 23298",
    className: "cls-106",
    width: 1.388,
    height: 1.053
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63418",
    "data-name": "Group 63418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63417",
    "data-name": "Group 63417",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62328",
    "data-name": "Path 62328",
    className: "cls-61",
    d: "M214.438,432.82c-.273-.473-.716-.729-.989-.571s-.273.669,0,1.142.716.729.989.571.273-.669,0-1.142",
    transform: "translate(-200.896 -407.176)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63420",
    "data-name": "Group 63420",
    transform: "translate(12.509 24.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63419",
    "data-name": "Group 63419",
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23300",
    "data-name": "Rectangle 23300",
    className: "cls-108",
    width: 0.707,
    height: 0.722,
    transform: "translate(-0.252 0.136) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63422",
    "data-name": "Group 63422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63421",
    "data-name": "Group 63421",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62330",
    "data-name": "Path 62330",
    className: "cls-78",
    d: "M216.318,418.022c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.141.067-.165,0-.281",
    transform: "translate(-203.515 -393.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62331",
    "data-name": "Path 62331",
    className: "cls-51",
    d: "M229.544,420.174l.1-.059a2.952,2.952,0,0,0-.37-.34.253.253,0,0,0,.025.258c.067.116.176.179.243.141",
    transform: "translate(-215.976 -395.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62332",
    "data-name": "Path 62332",
    className: "cls-78",
    d: "M229.544,420.174a.123.123,0,0,0,.05-.114,2.882,2.882,0,0,0-.318-.284.253.253,0,0,0,.025.258c.067.116.176.179.243.141",
    transform: "translate(-215.976 -395.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62333",
    "data-name": "Path 62333",
    className: "cls-78",
    d: "M242.578,434.326c-.031-.053-.062-.1-.094-.155a.287.287,0,0,0,.039.233.294.294,0,0,0,.175.149c-.037-.076-.076-.151-.12-.227",
    transform: "translate(-228.432 -409.03)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63424",
    "data-name": "Group 63424",
    transform: "translate(14.357 26.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63423",
    "data-name": "Group 63423",
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23302",
    "data-name": "Rectangle 23302",
    className: "cls-110",
    width: 0.453,
    height: 0.539,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.225, 0.12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63426",
    "data-name": "Group 63426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63425",
    "data-name": "Group 63425",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62335",
    "data-name": "Path 62335",
    className: "cls-61",
    d: "M248.095,451.587a.111.111,0,0,0-.1,0c-.067.039-.067.165,0,.281a.29.29,0,0,0,.179.15,2.8,2.8,0,0,0-.079-.429",
    transform: "translate(-233.587 -425.425)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63428",
    "data-name": "Group 63428",
    transform: "translate(14.04 26.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63427",
    "data-name": "Group 63427",
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23304",
    "data-name": "Rectangle 23304",
    className: "cls-112",
    width: 0.707,
    height: 0.722,
    transform: "translate(-0.252 0.136) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63430",
    "data-name": "Group 63430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63429",
    "data-name": "Group 63429",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62337",
    "data-name": "Path 62337",
    className: "cls-78",
    d: "M242.761,463.824c-.067-.116-.176-.179-.243-.141s-.067.165,0,.281.176.179.243.14.067-.165,0-.281",
    transform: "translate(-228.427 -436.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62338",
    "data-name": "Path 62338",
    className: "cls-54",
    d: "M65.338,290.563a2.391,2.391,0,0,0-.891-1.021l-3.473-2.005a1.2,1.2,0,0,0-1.022-.16l-.391.153-.391-.6a3.156,3.156,0,0,0-1.022-1.02L54.675,283.9a.735.735,0,0,0-.891-.008l-.944.87a.875.875,0,0,0-.234.658v2.053l.435.251c0-2.216,1.556-3.114,3.475-2.006a7.027,7.027,0,0,1,2.381,2.465l1.33.768a2.491,2.491,0,0,1,2.381.284,7.681,7.681,0,0,1,3.475,6.019l.435.251v-2.053a2.2,2.2,0,0,0-.234-.928Z",
    transform: "translate(-49.559 -267.316)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63432",
    "data-name": "Group 63432",
    transform: "translate(10.002 18.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63431",
    "data-name": "Group 63431",
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23306",
    "data-name": "Rectangle 23306",
    className: "cls-114",
    width: 13.328,
    height: 13.345,
    transform: "translate(-4.22 2.41) rotate(-29.73)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63437",
    "data-name": "Group 63437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63436",
    "data-name": "Group 63436",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63435",
    "data-name": "Group 63435",
    className: "cls-115",
    transform: "translate(10.521 18.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63434",
    "data-name": "Group 63434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63433",
    "data-name": "Group 63433",
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62340",
    "data-name": "Path 62340",
    className: "cls-52",
    d: "M190.7,322.773l-.944-1.96a2.391,2.391,0,0,0-.891-1.021l-3.473-2.005a1.2,1.2,0,0,0-1.022-.16l-.391.153-2.277,1.315.224-.057a1.431,1.431,0,0,1,.784.3l3.473,2.005a5.73,5.73,0,0,1,1.125.886l1.615,1.573a1.964,1.964,0,0,1,.519.764l.767,1.609.726-.419V323.7a2.2,2.2,0,0,0-.234-.928",
    transform: "translate(-181.7 -317.57)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63439",
    "data-name": "Group 63439",
    transform: "translate(4.313 14.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63438",
    "data-name": "Group 63438",
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23309",
    "data-name": "Rectangle 23309",
    className: "cls-118",
    width: 10.048,
    height: 8.917,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -2.337, 1.349)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63462",
    "data-name": "Group 63462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63461",
    "data-name": "Group 63461",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63442",
    "data-name": "Group 63442",
    className: "cls-115",
    transform: "translate(4.665 14.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63441",
    "data-name": "Group 63441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63440",
    "data-name": "Group 63440",
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62342",
    "data-name": "Path 62342",
    className: "cls-52",
    d: "M88.309,259.04a3.157,3.157,0,0,0-1.022-1.02l-3.473-2.005a.79.79,0,0,0-.8-.074h0l-2.444,1.411c.163-.041.228.017.566.212l3.473,2.005a8.039,8.039,0,0,1,1.148.83l.67.56,2.277-1.315Z",
    transform: "translate(-80.567 -255.862)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62343",
    "data-name": "Path 62343",
    className: "cls-54",
    d: "M309.877,437.02v3.156l6.218,3.59V440.61Z",
    transform: "translate(-291.933 -411.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23311",
    "data-name": "Rectangle 23311",
    className: "cls-120",
    width: 0.931,
    height: 7.18,
    transform: "translate(17.944 25.306) rotate(-60.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62344",
    "data-name": "Path 62344",
    className: "cls-121",
    d: "M329.722,451.634l.457.264v-3.156l-.457-.264Z",
    transform: "translate(-310.629 -422.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62345",
    "data-name": "Path 62345",
    className: "cls-121",
    d: "M389.53,483.007v3.156l.457.264v-3.156Z",
    transform: "translate(-366.974 -455.038)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23312",
    "data-name": "Rectangle 23312",
    className: "cls-122",
    width: 0.931,
    height: 0.527,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 19.093, 25.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62346",
    "data-name": "Path 62346",
    className: "cls-53",
    d: "M319.4,408.363l-1.477.853,6.218,3.59,1.477-.853Z",
    transform: "translate(-299.509 -384.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62347",
    "data-name": "Path 62347",
    className: "cls-69",
    d: "M337.763,420.673l.457.264,1.477-.853-.457-.264Z",
    transform: "translate(-318.205 -395.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23313",
    "data-name": "Rectangle 23313",
    className: "cls-122",
    width: 0.931,
    height: 0.527,
    transform: "translate(22.556 27.969) rotate(-60.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62348",
    "data-name": "Path 62348",
    className: "cls-69",
    d: "M399.048,454.351l-1.477.853.457.263,1.477-.853Z",
    transform: "translate(-374.55 -428.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62349",
    "data-name": "Path 62349",
    className: "cls-52",
    d: "M419.2,470.36l-1.477.853-.466.807v3.156l.466.269,1.477-.853.466-.806v-3.156Z",
    transform: "translate(-393.098 -443.124)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63445",
    "data-name": "Group 63445",
    className: "cls-115",
    transform: "translate(18.531 23.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63444",
    "data-name": "Group 63444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63443",
    "data-name": "Group 63443",
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62350",
    "data-name": "Path 62350",
    className: "cls-52",
    d: "M321.38,408.363l-1.355.782,5.549,3.2,1.039.173.986-.569Z",
    transform: "translate(-320.025 -408.363)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62351",
    "data-name": "Path 62351",
    className: "cls-124",
    d: "M212.317,0l-.733.423,23.473,13.552.141-.766Z",
    transform: "translate(-199.332 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62352",
    "data-name": "Path 62352",
    className: "cls-125",
    d: "M228.906,20.661,205.784,7.312l-.089.485.606.35-.873,4.747,18.466,10.661Z",
    transform: "translate(-193.532 -6.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62353",
    "data-name": "Path 62353",
    className: "cls-126",
    d: "M208.455,114.372l-18.466-10.661-.949,1.515L206.669,115.4Z",
    transform: "translate(-178.094 -97.705)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63448",
    "data-name": "Group 63448",
    className: "cls-127",
    transform: "translate(10.946 6.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63447",
    "data-name": "Group 63447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63446",
    "data-name": "Group 63446",
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62354",
    "data-name": "Path 62354",
    className: "cls-129",
    d: "M192.61,105.226l-.351,1.86-3.222-1.86.949-1.515Z",
    transform: "translate(-189.037 -103.711)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62355",
    "data-name": "Path 62355",
    className: "cls-130",
    d: "M134.172,129.869l-3.373,1.947,17.628,10.178,3.372-1.947Z",
    transform: "translate(-123.225 -122.349)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63451",
    "data-name": "Group 63451",
    className: "cls-131",
    transform: "translate(7.574 7.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63450",
    "data-name": "Group 63450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63449",
    "data-name": "Group 63449",
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62356",
    "data-name": "Path 62356",
    className: "cls-129",
    d: "M134.022,133.676l-3.222-1.86,3.372-1.947,3.222,1.86Z",
    transform: "translate(-130.8 -129.869)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63454",
    "data-name": "Group 63454",
    className: "cls-133",
    transform: "translate(11.895 1.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63453",
    "data-name": "Group 63453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63452",
    "data-name": "Group 63452",
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62357",
    "data-name": "Path 62357",
    className: "cls-135",
    d: "M205.427,26.473l2.624,1.515-1.75-6.262Z",
    transform: "translate(-205.427 -21.726)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62358",
    "data-name": "Path 62358",
    className: "cls-136",
    d: "M42.414,21.288l.606.35,9.707-5.6-.606-.35Z",
    transform: "translate(-39.958 -14.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62359",
    "data-name": "Path 62359",
    className: "cls-137",
    d: "M52.878,27.33l4.512,2.605,3.372-1.947.949-1.515.873-4.747Z",
    transform: "translate(-49.816 -20.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62360",
    "data-name": "Path 62360",
    className: "cls-138",
    d: "M132.887,67.095l-4.873,1.779,7.5,3.021,4.873-1.779Z",
    transform: "translate(-120.601 -63.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62361",
    "data-name": "Path 62361",
    className: "cls-139",
    d: "M262.441,119.257l-4.873,1.779,2.99,2.159,4.873-1.779Z",
    transform: "translate(-242.653 -112.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62362",
    "data-name": "Path 62362",
    className: "cls-138",
    d: "M314.069,156.547l4.6,1.852-4.873,1.779-4.6-1.852Z",
    transform: "translate(-291.292 -147.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62363",
    "data-name": "Path 62363",
    className: "cls-140",
    d: "M41.811,97.813l-5.3,4.093,7.5,3.021,5.3-4.093Z",
    transform: "translate(-34.398 -92.149)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63457",
    "data-name": "Group 63457",
    className: "cls-131",
    transform: "translate(7.413 3.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63456",
    "data-name": "Group 63456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63455",
    "data-name": "Group 63455",
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62364",
    "data-name": "Path 62364",
    className: "cls-142",
    d: "M132.887,67.095l-4.873,1.779.513.206,5.732-1.433Z",
    transform: "translate(-128.014 -67.095)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63460",
    "data-name": "Group 63460",
    className: "cls-143",
    transform: "translate(2.114 5.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63459",
    "data-name": "Group 63459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63458",
    "data-name": "Group 63458",
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62365",
    "data-name": "Path 62365",
    className: "cls-142",
    d: "M36.512,101.906l5.3-4.093.513.206-4.439,4.439Z",
    transform: "translate(-36.512 -97.813)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62366",
    "data-name": "Path 62366",
    className: "cls-145",
    d: "M171.365,149.976l-5.3,4.093,2.99,2.159,5.3-4.094Z",
    transform: "translate(-156.451 -141.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62367",
    "data-name": "Path 62367",
    className: "cls-140",
    d: "M222.994,187.265l-5.3,4.094,4.6,1.852,5.3-4.094Z",
    transform: "translate(-205.09 -176.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62368",
    "data-name": "Path 62368",
    className: "cls-145",
    d: "M302.431,219.249l-5.3,4.093,6.071,4.385,5.3-4.093Z",
    transform: "translate(-279.927 -206.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62369",
    "data-name": "Path 62369",
    className: "cls-139",
    d: "M393.507,188.531l-4.873,1.779,6.071,4.385,4.873-1.779Z",
    transform: "translate(-366.13 -177.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62370",
    "data-name": "Path 62370",
    className: "cls-146",
    d: "M409.173,202.728l-1.626,8.842,11.638-6.719,1.626-8.842Z",
    transform: "translate(-383.947 -184.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62371",
    "data-name": "Path 62371",
    className: "cls-147",
    d: "M464.94,512.181l-1.522-.878v1.41l1.522.878Z",
    transform: "translate(-436.583 -481.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62372",
    "data-name": "Path 62372",
    className: "cls-52",
    d: "M795.753,380.676l-.189-.328.781-.451a.526.526,0,0,0,.227-.393v-.6h.379v.6a.894.894,0,0,1-.416.72Z",
    transform: "translate(-749.496 -356.965)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63464",
    "data-name": "Group 63464",
    transform: "translate(46.458 18.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63463",
    "data-name": "Group 63463",
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23321",
    "data-name": "Rectangle 23321",
    className: "cls-149",
    width: 4.048,
    height: 3.225,
    transform: "translate(-1.63 2.842) rotate(-60.162)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63469",
    "data-name": "Group 63469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63468",
    "data-name": "Group 63468",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63467",
    "data-name": "Group 63467",
    className: "cls-143",
    transform: "translate(47.265 18.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63466",
    "data-name": "Group 63466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63465",
    "data-name": "Group 63465",
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62374",
    "data-name": "Path 62374",
    className: "cls-151",
    d: "M816.7,324.438h-.461v.219h.082Z",
    transform: "translate(-816.238 -324.438)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62375",
    "data-name": "Path 62375",
    className: "cls-52",
    d: "M808.119,322.621l-.921.532a.466.466,0,0,0-.211.365v2.557c0,.135.094.189.211.122l.921-.532a.466.466,0,0,0,.211-.366v-2.557c0-.134-.094-.189-.211-.122",
    transform: "translate(-760.258 -303.912)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63474",
    "data-name": "Group 63474",
    transform: "translate(46.068 17.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63473",
    "data-name": "Group 63473",
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63472",
    "data-name": "Group 63472",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63471",
    "data-name": "Group 63471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63470",
    "data-name": "Group 63470",
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_23324",
    "data-name": "Rectangle 23324",
    width: 1.418,
    height: 1.056,
    transform: "translate(-0.012 -0.028)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAIAAADm2DRVAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAM6ADAAQAAAABAAAAJgAAAABExXeQAAAEa0lEQVRYCc2XP4/cRBjGba+99zUiAVIkcspJRIJPQJeaUIQGAUqTFLQRVdIlRQqEQpcUXEooE1GjoHCKICdRwQe5XXvze953PR6P98/d7l4uc6vZmfHY8/PzPvPOXj6bzbL3spTnSvXf38d8WOLF02fJQp9/deODq1f4JOOhm5+TZgBB41hhsYUNEPkML+2eDJqfvr+brMT7yzRW51lWFEUy4dbDe4l+uyQb6gRJ0zR108wagTUCnIFFGRV5XhRQ5jmVSgK3MzJ0imMXmOq6nk5r32XiAjHPytEIKuEVeVWWC+F2QIafYoM709SAEKuWZC6WhOEqHAC5YmVZjscVoAHuwe+/al6WbbU3h+GDwkVCJwpSeRc2X89rSWaaZXmdTxTOUQvHS/qG2JBsyOR+gmNiTKBMRSe1qINs9MGqmxywqkK/GTKCO85zlKMRLLEJ2TB8kmrKnyzliKaZgBjEW4wGzRi0WGp7GhWBrUe1mS7PIePDPj2bzxYz1Y3HTnwq1DKXSG1fBqa4ARwiVRWfajwux1W1tzcmyMwBi316Ws0Whg+BAHEslCCOUgmdYDKoGCVpE2Vmmdu4a8RdvElRASzZmHwqsiQj4JUA5NGb6+SgdCjsQdLD6qJsZwmPxxVFU8qUkPlNa8iG4ZMkCp8jyUZWLILoZ5bn0euxMJklEb2ECl/de7DuUjIkjQ8Zv5X1feuZSOJwtWQwxQOfn0KqDkDpzYq2gisdjq0FZEsshTSsP6+NSW3xyFK0FIgVUt248y1Izx79HIHpvKIrOKvjSylZYiluYU1CZ39a3+CoZDXryioABX/ET/f2lU8/AWv/s2uHjx4PrzJiYLrCszIlNZWObImlfOsZkASSQu3Wk06U0zD5Ysvruetb97dkiaUYdm2MQMq4NrTM7/KTQ0mo+GH9ldHpyzvf9cfO0CuT8KGCCAyBWiKZTgxKLavxBO+4IybfkLJZQl2ScD2zuaVYGiAIPHAiQSFLB4xyyAkpeUbUDZaKxtY0TXc9MnnVkoP9+ZNDOEwPVheHutN5w8mUp9ZlhHu/PMbma0DSyxyPPhQa8xlKHxxSJxOVkwkZdDqZ1Ccn1NaYTDVov2FWZ4Tf/j86O5ZDhDiGhsa1Nz882L+0//G/r167vbo42t5bG777h70U5attX8+zxvWvb/7zxysCJzjbe0TUAr/UVBtYahluG9De9TnZ5WsHHx3sv3n5l3HxW2pVluIBG1mqt3Db8QhS90LJ1XBMZT88+ZEzkR1g9yyViiy1haVanug7EIWGX+zI6H9x+5sVKYHwwbRN8ox4QlMS8E+Bubm3PbvTiRmsevzy6PjPo3CfN3ZoqeTJdEFrz82eaj3NmOe/COL7GWH3bZoR4ietbM93QQfX04xbIUAhl23Lg28lSHcRlm5vdmDRb40wFyDI4Dt3nbSksxgbHo82XqoZcwF6J0wmRSSSQXZoqc9s+rurYjDTrxu4YLIQwE6rVpYLJrOkYb9/Bon0wslaiQbf7y/ZW4cePkRC7NfTAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63476",
    "data-name": "Group 63476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63475",
    "data-name": "Group 63475",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_23326",
    "data-name": "Rectangle 23326",
    width: 1.448,
    height: 1.042,
    transform: "translate(46.035 17.866)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAASCAYAAACuLnWgAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGaADAAQAAAABAAAAEgAAAAAM64R1AAABL0lEQVQ4Eb2USwrCMBRFGz/4RQU/qO2gCo4F3YJjHTp0jY5dg1sQd1LvK70l/SVpBwZC8pK8c+8LaVUURV6TdtufQ1Pe8/P+cr/FSZ3RIjAE64AzDzJVnUos8DagW3Rf76jo3qGaabTAJXWFnoEjpqBnrMQBPknggQalmIgs0b3KSiwCPeQSxpHOGSsRkFYQscAlR2DiXGA6mPMB1jMtFXGAz5FJl3kBiWcZshao6+4UanHZdITFSud4PRsYNH5saSUldNnTnRfcQ6BbkldYil9XyVWtEwHev4y88wDwsU6qW4ncK93zWRLuA77Q4a7z9DuBmwuS6JxXE8eAS1zZ6lRyBIWuOYr7fiXdcSOtRM7D0QtDfF2ATx0Zkmd8XRkRV2j+nE2k0a8+L2KL/yLyA3KdSM/eyS4kAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62377",
    "data-name": "Path 62377",
    className: "cls-52",
    d: "M813.157,324.439c-.1,0-.189.049-.189.109s.085.109.189.109.189-.049.189-.109-.085-.109-.189-.109",
    transform: "translate(-765.892 -305.652)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63478",
    "data-name": "Group 63478",
    transform: "translate(47.076 18.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63477",
    "data-name": "Group 63477",
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23328",
    "data-name": "Rectangle 23328",
    className: "cls-155",
    width: 0.343,
    height: 0.726,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63480",
    "data-name": "Group 63480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63479",
    "data-name": "Group 63479",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62379",
    "data-name": "Path 62379",
    className: "cls-52",
    d: "M476.229,240.774l-1.184-5.948-8.669-5.005-11.344,6.549v5.868L465.02,248l11.209-6.471Zm-1.159-.739-.643-.371a1.318,1.318,0,0,1-.491-.563l-.183-.379a1.318,1.318,0,0,0-.491-.563l-2.021-1.167V233.38l2.721,1.571a1.257,1.257,0,0,1,.543.8l.809,4.063c.041.208-.079.318-.243.223",
    transform: "translate(-428.683 -216.513)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63482",
    "data-name": "Group 63482",
    transform: "translate(25.066 30.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63481",
    "data-name": "Group 63481",
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23330",
    "data-name": "Rectangle 23330",
    className: "cls-157",
    width: 3.441,
    height: 3.531,
    transform: "translate(-1.158 0.669) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63484",
    "data-name": "Group 63484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63483",
    "data-name": "Group 63483",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62381",
    "data-name": "Path 62381",
    className: "cls-54",
    d: "M426.15,502.35l1.621.936v.367c-1.194-.055-2.024.86-2.024,2.477l-.438-.253V503.1Z",
    transform: "translate(-400.681 -473.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62382",
    "data-name": "Path 62382",
    className: "cls-53",
    d: "M439.827,496.524l.62-.358v.716Z",
    transform: "translate(-414.359 -467.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62383",
    "data-name": "Path 62383",
    className: "cls-52",
    d: "M467.828,518.884l.344-.168-.344-.2Z",
    transform: "translate(-440.738 -488.492)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63486",
    "data-name": "Group 63486",
    transform: "translate(25.707 29.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63485",
    "data-name": "Group 63485",
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23332",
    "data-name": "Rectangle 23332",
    className: "cls-159",
    width: 11.739,
    height: 11.975,
    transform: "translate(-4.175 2.251) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63488",
    "data-name": "Group 63488",
    transform: "translate(26.928 29.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63487",
    "data-name": "Group 63487",
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23333",
    "data-name": "Rectangle 23333",
    className: "cls-161",
    width: 10.023,
    height: 10.5,
    transform: "translate(-3.535 2.041) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63490",
    "data-name": "Group 63490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63489",
    "data-name": "Group 63489",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62386",
    "data-name": "Path 62386",
    className: "cls-162",
    d: "M448.79,541.592c-1.107-1.917-2.9-2.952-4.007-2.314s-1.107,2.711,0,4.627,2.9,2.953,4.007,2.314,1.107-2.71,0-4.627",
    transform: "translate(-418.245 -507.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62387",
    "data-name": "Path 62387",
    className: "cls-19",
    d: "M465.264,564.264c-.693-1.2-1.817-1.849-2.51-1.449s-.693,1.7,0,2.9,1.817,1.849,2.51,1.449.693-1.7,0-2.9",
    transform: "translate(-435.468 -530.113)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63492",
    "data-name": "Group 63492",
    transform: "translate(26.987 32.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63491",
    "data-name": "Group 63491",
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23335",
    "data-name": "Rectangle 23335",
    className: "cls-164",
    width: 5.083,
    height: 5.394,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -1.996, 1.065)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63497",
    "data-name": "Group 63497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63496",
    "data-name": "Group 63496",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63495",
    "data-name": "Group 63495",
    className: "cls-165",
    transform: "translate(26.988 32.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63494",
    "data-name": "Group 63494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63493",
    "data-name": "Group 63493",
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62389",
    "data-name": "Path 62389",
    className: "cls-66",
    d: "M467.038,570.068a2.224,2.224,0,0,1-.19-2.381h0a.779.779,0,0,0-.335.1,1.36,1.36,0,0,0-.4,1.51,3.036,3.036,0,0,0,.813.789,3.19,3.19,0,0,0,.159.316,2.082,2.082,0,0,0,1.491,1.158.889.889,0,0,0,.221-.028.774.774,0,0,0,.1-.1,2.353,2.353,0,0,1-1.86-1.369",
    transform: "translate(-466.059 -567.687)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62390",
    "data-name": "Path 62390",
    className: "cls-18",
    d: "M475.373,567.645a2.223,2.223,0,0,0,.189,2.381,2.35,2.35,0,0,0,1.863,1.369,2.223,2.223,0,0,0-.189-2.381,2.35,2.35,0,0,0-1.862-1.369",
    transform: "translate(-447.596 -534.773)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63499",
    "data-name": "Group 63499",
    transform: "translate(27.387 33.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63498",
    "data-name": "Group 63498",
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23338",
    "data-name": "Rectangle 23338",
    className: "cls-168",
    width: 4.216,
    height: 4.462,
    transform: "translate(-1.634 0.878) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63504",
    "data-name": "Group 63504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63503",
    "data-name": "Group 63503",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63502",
    "data-name": "Group 63502",
    className: "cls-165",
    transform: "translate(27.965 33.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63501",
    "data-name": "Group 63501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63500",
    "data-name": "Group 63500",
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62392",
    "data-name": "Path 62392",
    className: "cls-66",
    d: "M484.621,571.738a3.089,3.089,0,0,0-1.18-1.2l-.494.286c.451-.26,1.182.162,1.632.942s.451,1.625,0,1.885l.495-.286a3.089,3.089,0,0,0-.453-1.624",
    transform: "translate(-482.947 -570.534)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62393",
    "data-name": "Path 62393",
    className: "cls-19",
    d: "M474.923,577.556c-.451-.781-1.182-1.2-1.633-.943s-.451,1.1,0,1.885,1.182,1.2,1.633.943.451-1.1,0-1.885",
    transform: "translate(-445.566 -543.152)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63506",
    "data-name": "Group 63506",
    transform: "translate(28.383 33.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63505",
    "data-name": "Group 63505",
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23341",
    "data-name": "Rectangle 23341",
    className: "cls-171",
    width: 0.386,
    height: 0.484,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.075, 0.013)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63508",
    "data-name": "Group 63508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63507",
    "data-name": "Group 63507",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62395",
    "data-name": "Path 62395",
    className: "cls-172",
    d: "M492.282,582.252a.169.169,0,0,0-.033-.015.177.177,0,0,0,0,.036.348.348,0,0,0,.158.273.18.18,0,0,0,.034.015.183.183,0,0,0,0-.036.348.348,0,0,0-.158-.273",
    transform: "translate(-463.741 -548.522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63510",
    "data-name": "Group 63510",
    transform: "translate(28.383 35.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63509",
    "data-name": "Group 63509",
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23343",
    "data-name": "Rectangle 23343",
    className: "cls-174",
    width: 0.386,
    height: 0.484,
    transform: "translate(-0.075 0.013) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63512",
    "data-name": "Group 63512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63511",
    "data-name": "Group 63511",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62397",
    "data-name": "Path 62397",
    className: "cls-172",
    d: "M492.282,615.53a.023.023,0,1,0-.037.021.349.349,0,0,0,.158.273.023.023,0,1,0,.037-.021.349.349,0,0,0-.158-.273",
    transform: "translate(-463.741 -579.873)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63514",
    "data-name": "Group 63514",
    transform: "translate(29.218 35.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63513",
    "data-name": "Group 63513",
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23345",
    "data-name": "Rectangle 23345",
    className: "cls-176",
    width: 0.386,
    height: 0.484,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.075, 0.013)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63516",
    "data-name": "Group 63516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63515",
    "data-name": "Group 63515",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62399",
    "data-name": "Path 62399",
    className: "cls-172",
    d: "M506.692,607.21a.17.17,0,0,0-.033-.015.173.173,0,0,0,0,.036.349.349,0,0,0,.158.273.166.166,0,0,0,.033.015.169.169,0,0,0,0-.036.348.348,0,0,0-.158-.273",
    transform: "translate(-477.317 -572.035)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63518",
    "data-name": "Group 63518",
    transform: "translate(27.549 34.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63517",
    "data-name": "Group 63517",
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23347",
    "data-name": "Rectangle 23347",
    className: "cls-178",
    width: 0.386,
    height: 0.484,
    transform: "translate(-0.075 0.013) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63520",
    "data-name": "Group 63520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63519",
    "data-name": "Group 63519",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62401",
    "data-name": "Path 62401",
    className: "cls-172",
    d: "M477.872,590.572a.179.179,0,0,0-.033-.015.169.169,0,0,0,0,.036.349.349,0,0,0,.158.273.023.023,0,1,0,.037-.022.349.349,0,0,0-.158-.273",
    transform: "translate(-450.165 -556.36)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63522",
    "data-name": "Group 63522",
    transform: "translate(28.973 34.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63521",
    "data-name": "Group 63521",
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23349",
    "data-name": "Rectangle 23349",
    className: "cls-180",
    width: 0.416,
    height: 0.486,
    transform: "translate(-0.089 0.013) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63524",
    "data-name": "Group 63524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63523",
    "data-name": "Group 63523",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62403",
    "data-name": "Path 62403",
    className: "cls-172",
    d: "M502.443,593a.326.326,0,1,0,.145.133.287.287,0,0,0-.145-.133",
    transform: "translate(-473.345 -558.659)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63526",
    "data-name": "Group 63526",
    transform: "translate(27.793 35.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63525",
    "data-name": "Group 63525",
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23351",
    "data-name": "Rectangle 23351",
    className: "cls-182",
    width: 0.416,
    height: 0.486,
    transform: "translate(-0.089 0.013) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63528",
    "data-name": "Group 63528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63527",
    "data-name": "Group 63527",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62405",
    "data-name": "Path 62405",
    className: "cls-172",
    d: "M482.064,604.762a.325.325,0,1,0,.145.133.288.288,0,0,0-.145-.133",
    transform: "translate(-454.146 -569.743)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63530",
    "data-name": "Group 63530",
    transform: "translate(28.973 35.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63529",
    "data-name": "Group 63529",
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23353",
    "data-name": "Rectangle 23353",
    className: "cls-184",
    width: 0.416,
    height: 0.486,
    transform: "translate(-0.089 0.013) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63532",
    "data-name": "Group 63532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63531",
    "data-name": "Group 63531",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62407",
    "data-name": "Path 62407",
    className: "cls-172",
    d: "M502.443,616.527a.326.326,0,1,0,.145.133.288.288,0,0,0-.145-.133",
    transform: "translate(-473.345 -580.826)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63534",
    "data-name": "Group 63534",
    transform: "translate(27.793 33.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63533",
    "data-name": "Group 63533",
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23355",
    "data-name": "Rectangle 23355",
    className: "cls-186",
    width: 0.416,
    height: 0.486,
    transform: "translate(-0.089 0.013) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63536",
    "data-name": "Group 63536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63535",
    "data-name": "Group 63535",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62409",
    "data-name": "Path 62409",
    className: "cls-172",
    d: "M482.064,581.231a.326.326,0,1,0,.145.133.288.288,0,0,0-.145-.133",
    transform: "translate(-454.146 -547.574)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63538",
    "data-name": "Group 63538",
    transform: "translate(28.102 34.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63537",
    "data-name": "Group 63537",
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23357",
    "data-name": "Rectangle 23357",
    className: "cls-188",
    width: 0.963,
    height: 1.203,
    transform: "translate(-0.043)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63540",
    "data-name": "Group 63540",
    transform: "translate(26.089 27.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63539",
    "data-name": "Group 63539",
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23358",
    "data-name": "Rectangle 23358",
    className: "cls-190",
    width: 12.344,
    height: 13.873,
    transform: "translate(-4.665 2.389) rotate(-27.112)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63566",
    "data-name": "Group 63566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63565",
    "data-name": "Group 63565",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62412",
    "data-name": "Path 62412",
    className: "cls-191",
    d: "M570.244,654.624v.559l2.573,1.485v-.559Z",
    transform: "translate(-537.223 -616.717)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63543",
    "data-name": "Group 63543",
    className: "cls-70",
    transform: "translate(33.02 37.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63542",
    "data-name": "Group 63542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63541",
    "data-name": "Group 63541",
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62413",
    "data-name": "Path 62413",
    className: "cls-193",
    d: "M570.244,654.624v.559l.26.15v-.559Z",
    transform: "translate(-570.244 -654.624)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62414",
    "data-name": "Path 62414",
    className: "cls-194",
    d: "M570.244,643.035l1.234-.712,2.573,1.485-1.234.712Z",
    transform: "translate(-537.223 -605.129)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63546",
    "data-name": "Group 63546",
    className: "cls-143",
    transform: "translate(33.02 37.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63545",
    "data-name": "Group 63545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63544",
    "data-name": "Group 63544",
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62415",
    "data-name": "Path 62415",
    className: "cls-193",
    d: "M570.5,643.185h.266l2.18,1.258,1.1-.636-2.573-1.485-1.234.712Z",
    transform: "translate(-570.244 -642.322)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62416",
    "data-name": "Path 62416",
    className: "cls-191",
    d: "M570.244,624.606v.559l2.573,1.485v-.559Z",
    transform: "translate(-537.223 -588.438)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63549",
    "data-name": "Group 63549",
    className: "cls-70",
    transform: "translate(33.02 36.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63548",
    "data-name": "Group 63548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63547",
    "data-name": "Group 63547",
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62417",
    "data-name": "Path 62417",
    className: "cls-193",
    d: "M570.244,624.606v.559l.26.15v-.559Z",
    transform: "translate(-570.244 -624.606)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62418",
    "data-name": "Path 62418",
    className: "cls-194",
    d: "M570.244,613.018l1.234-.712,2.573,1.485-1.234.712Z",
    transform: "translate(-537.223 -576.849)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63552",
    "data-name": "Group 63552",
    className: "cls-143",
    transform: "translate(33.02 35.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63551",
    "data-name": "Group 63551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63550",
    "data-name": "Group 63550",
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62419",
    "data-name": "Path 62419",
    className: "cls-193",
    d: "M570.5,613.167h.266l2.18,1.258,1.1-.636-2.573-1.485-1.234.712Z",
    transform: "translate(-570.244 -612.305)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62420",
    "data-name": "Path 62420",
    className: "cls-191",
    d: "M570.244,594.589v.559l2.573,1.485v-.559Z",
    transform: "translate(-537.223 -560.159)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63555",
    "data-name": "Group 63555",
    className: "cls-70",
    transform: "translate(33.02 34.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63554",
    "data-name": "Group 63554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63553",
    "data-name": "Group 63553",
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62421",
    "data-name": "Path 62421",
    className: "cls-193",
    d: "M570.244,594.589v.559l.26.15v-.559Z",
    transform: "translate(-570.244 -594.589)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62422",
    "data-name": "Path 62422",
    className: "cls-194",
    d: "M570.244,583l1.234-.712,2.573,1.485-1.234.712Z",
    transform: "translate(-537.223 -548.57)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63558",
    "data-name": "Group 63558",
    className: "cls-143",
    transform: "translate(33.02 33.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63557",
    "data-name": "Group 63557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63556",
    "data-name": "Group 63556",
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62423",
    "data-name": "Path 62423",
    className: "cls-193",
    d: "M573.79,586.367l-2.573-1.485-.974.562.26.15h.664l1.981,1.143Z",
    transform: "translate(-570.243 -584.881)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62424",
    "data-name": "Path 62424",
    className: "cls-197",
    d: "M643.653,413.321l-5.105.257v.9a.319.319,0,0,0,.188.262l1.689.975a1,1,0,0,0,.908,0l2.133-1.231a.319.319,0,0,0,.188-.263Z",
    transform: "translate(-601.572 -389.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62425",
    "data-name": "Path 62425",
    className: "cls-198",
    d: "M643.465,391.169l-1.689-.975a1,1,0,0,0-.908,0l-2.133,1.231a.277.277,0,0,0,0,.524l1.689.975a1,1,0,0,0,.908,0l2.133-1.231a.277.277,0,0,0,0-.524",
    transform: "translate(-601.573 -367.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62426",
    "data-name": "Path 62426",
    className: "cls-197",
    d: "M553.277,465.5l-5.105.256v.9a.319.319,0,0,0,.188.262l1.689.975a1,1,0,0,0,.908,0l2.133-1.231a.319.319,0,0,0,.188-.263Z",
    transform: "translate(-516.43 -438.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62427",
    "data-name": "Path 62427",
    className: "cls-198",
    d: "M553.089,443.347l-1.689-.975a1,1,0,0,0-.908,0L548.36,443.6a.277.277,0,0,0,0,.524l1.689.975a1,1,0,0,0,.908,0l2.133-1.231a.277.277,0,0,0,0-.524",
    transform: "translate(-516.43 -416.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62428",
    "data-name": "Path 62428",
    className: "cls-197",
    d: "M546.62,382.762c0-.289-.2-.407-.454-.262l-2.133,1.231a1,1,0,0,0-.454.786v2.463c0,.289.2.407.454.262l2.133-1.231a1,1,0,0,0,.454-.786Z",
    transform: "translate(-512.103 -360.293)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63561",
    "data-name": "Group 63561",
    className: "cls-70",
    transform: "translate(28.649 22.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63560",
    "data-name": "Group 63560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63559",
    "data-name": "Group 63559",
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62429",
    "data-name": "Path 62429",
    className: "cls-200",
    d: "M496.689,385.287l-1.251-.722a1.514,1.514,0,0,1-.685-1.186v-2.031c0-.437.307-.614.685-.4l1.251.722Z",
    transform: "translate(-494.753 -380.858)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63564",
    "data-name": "Group 63564",
    className: "cls-201",
    transform: "translate(28.649 22.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63563",
    "data-name": "Group 63563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63562",
    "data-name": "Group 63562",
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62430",
    "data-name": "Path 62430",
    className: "cls-193",
    d: "M494.752,381.347v2.031a1.357,1.357,0,0,0,.16.6c0-.01,0-.021,0-.031v-2.031c0-.437.307-.614.685-.4l1.092.631v-.478l-1.251-.722c-.378-.218-.685-.041-.685.4",
    transform: "translate(-494.752 -380.858)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63568",
    "data-name": "Group 63568",
    transform: "translate(28.49 22.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63567",
    "data-name": "Group 63567",
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23368",
    "data-name": "Rectangle 23368",
    className: "cls-204",
    width: 3.757,
    height: 4.812,
    transform: "translate(-1.809 0.942) rotate(-27.499)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63579",
    "data-name": "Group 63579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63578",
    "data-name": "Group 63578",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63571",
    "data-name": "Group 63571",
    className: "cls-67",
    transform: "translate(28.49 24.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63570",
    "data-name": "Group 63570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63569",
    "data-name": "Group 63569",
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62432",
    "data-name": "Path 62432",
    className: "cls-137",
    d: "M492.323,423.115a1.357,1.357,0,0,1-.161-.6V422.4H492v.207a1.157,1.157,0,0,0,.32.509Z",
    transform: "translate(-492.003 -422.399)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63574",
    "data-name": "Group 63574",
    className: "cls-70",
    transform: "translate(31.372 23.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63573",
    "data-name": "Group 63573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63572",
    "data-name": "Group 63572",
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62433",
    "data-name": "Path 62433",
    className: "cls-200",
    d: "M545.612,409.453l-.643-.371a1.318,1.318,0,0,1-.491-.563l-.183-.379a1.319,1.319,0,0,0-.491-.563l-2.021-1.167V402.8l2.721,1.571a1.258,1.258,0,0,1,.543.8l.809,4.063c.041.208-.079.318-.243.223",
    transform: "translate(-541.783 -402.798)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63577",
    "data-name": "Group 63577",
    className: "cls-201",
    transform: "translate(31.372 23.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63576",
    "data-name": "Group 63576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63575",
    "data-name": "Group 63575",
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62434",
    "data-name": "Path 62434",
    className: "cls-193",
    d: "M541.942,403.368l2.721,1.571a1.185,1.185,0,0,1,.436.493l-.052-.264a1.258,1.258,0,0,0-.543-.8l-2.721-1.571v3.613l.159.092Z",
    transform: "translate(-541.783 -402.799)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62435",
    "data-name": "Path 62435",
    className: "cls-137",
    d: "M539.035,404.385V408l.159-.092v-3.429Z",
    transform: "translate(-507.821 -380.969)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63581",
    "data-name": "Group 63581",
    transform: "translate(31.213 26.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63580",
    "data-name": "Group 63580",
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23373",
    "data-name": "Rectangle 23373",
    className: "cls-209",
    width: 5.123,
    height: 4.805,
    transform: "translate(-1.386 0.8) rotate(-29.999)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63598",
    "data-name": "Group 63598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63597",
    "data-name": "Group 63597",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63584",
    "data-name": "Group 63584",
    className: "cls-131",
    transform: "translate(31.213 26.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63583",
    "data-name": "Group 63583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63582",
    "data-name": "Group 63582",
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62437",
    "data-name": "Path 62437",
    className: "cls-211",
    d: "M539.194,465.193l-.159.092h.318Z",
    transform: "translate(-539.035 -465.193)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62438",
    "data-name": "Path 62438",
    className: "cls-125",
    d: "M463.7,347.932l-8.669-5.005v7.258l3.637,2.1a6.8,6.8,0,0,1,2.9,4.142l3.157,1.823V353.08Zm-4.592,1.712-1.251-.722a1.514,1.514,0,0,1-.685-1.186V345.7c0-.437.307-.614.685-.4l1.251.722Zm4.616,3.5-.643-.371a1.317,1.317,0,0,1-.491-.563l-.183-.379a1.319,1.319,0,0,0-.491-.563L459.9,350.1v-3.613l2.721,1.571a1.257,1.257,0,0,1,.543.8l.809,4.063c.041.208-.079.318-.243.223",
    transform: "translate(-428.682 -323.07)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63587",
    "data-name": "Group 63587",
    className: "cls-212",
    transform: "translate(34.534 25.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63586",
    "data-name": "Group 63586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63585",
    "data-name": "Group 63585",
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62439",
    "data-name": "Path 62439",
    className: "cls-211",
    d: "M597.894,439.8l-.2-1-1.059-3.789-.25-.033.787,2.817-.059-.034c-.015-.009-.04,0-.04.065v1.494l.063.319c.023.117,0,.2-.063.239v.3a7.11,7.11,0,0,0,.211,1.323l.212.933v.621q-.043-.135-.094-.313L596.636,440l-.25-.033.794,2.842c.23.824.331.906.409.906l.029,0c.026,0,.112-.026.112-.156v-.1l.165.724Z",
    transform: "translate(-596.386 -434.982)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62440",
    "data-name": "Path 62440",
    className: "cls-214",
    d: "M734.94,352.179l2.021,1.167a1.319,1.319,0,0,1,.491.563l.183.379a1.317,1.317,0,0,0,.491.563l.643.371c.114.066.206.033.239-.061a.258.258,0,0,1-.08-.031l-.643-.371a1.317,1.317,0,0,1-.491-.563l-.183-.379a1.318,1.318,0,0,0-.491-.563l-2.021-1.167Z",
    transform: "translate(-692.383 -331.699)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63590",
    "data-name": "Group 63590",
    className: "cls-70",
    transform: "translate(42.557 16.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63589",
    "data-name": "Group 63589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63588",
    "data-name": "Group 63588",
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62441",
    "data-name": "Path 62441",
    className: "cls-215",
    d: "M738.769,297.934l-.643-.371a1.316,1.316,0,0,1-.491-.563l-.183-.379a1.32,1.32,0,0,0-.491-.563l-2.021-1.167v-3.613l2.721,1.571a1.257,1.257,0,0,1,.543.8l.809,4.063c.041.208-.079.318-.243.223",
    transform: "translate(-734.94 -291.279)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62442",
    "data-name": "Path 62442",
    className: "cls-216",
    d: "M463.7,331.8l-8.669-5.005.263-.991,7.285,4.206Z",
    transform: "translate(-428.683 -306.94)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63593",
    "data-name": "Group 63593",
    className: "cls-131",
    transform: "translate(26.495 18.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63592",
    "data-name": "Group 63592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63591",
    "data-name": "Group 63591",
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62443",
    "data-name": "Path 62443",
    className: "cls-211",
    d: "M457.555,326.246l1.067.616.117-.44-1.068-.616Z",
    transform: "translate(-457.555 -325.806)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62444",
    "data-name": "Path 62444",
    className: "cls-125",
    d: "M456.466,479.348a5.509,5.509,0,0,0-2.492-4.317l-3.435-1.983v-2.181l3.637,2.1a6.708,6.708,0,0,1,3.035,5.256v3.994l-.744-.43Z",
    transform: "translate(-424.45 -443.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62445",
    "data-name": "Path 62445",
    className: "cls-194",
    d: "M793.252,493.959l-1.234-.712v1.425Z",
    transform: "translate(-746.156 -464.685)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63596",
    "data-name": "Group 63596",
    className: "cls-143",
    transform: "translate(45.862 28.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63595",
    "data-name": "Group 63595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63594",
    "data-name": "Group 63594",
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62446",
    "data-name": "Path 62446",
    className: "cls-193",
    d: "M793.252,493.959l-1.234-.712v1.425Z",
    transform: "translate(-792.019 -493.247)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62447",
    "data-name": "Path 62447",
    className: "cls-219",
    d: "M585.383,295.328l1.121,1.79,11.5-6.641-1.646-1.487Z",
    transform: "translate(-551.486 -272.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62448",
    "data-name": "Path 62448",
    className: "cls-125",
    d: "M615.12,620.5l-.45-.259v4.035l.45.26Z",
    transform: "translate(-579.077 -584.323)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63600",
    "data-name": "Group 63600",
    transform: "translate(35.593 34.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63599",
    "data-name": "Group 63599",
    className: "cls-220"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23380",
    "data-name": "Rectangle 23380",
    className: "cls-221",
    width: 3.547,
    height: 2.999,
    transform: "translate(-0.713 0.412) rotate(-30.04)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63602",
    "data-name": "Group 63602",
    transform: "translate(44.695 29.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63601",
    "data-name": "Group 63601",
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23381",
    "data-name": "Rectangle 23381",
    className: "cls-223",
    width: 3.377,
    height: 2.999,
    transform: "matrix(0.866, -0.501, 0.501, 0.866, -0.787, 0.455)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63610",
    "data-name": "Group 63610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63609",
    "data-name": "Group 63609",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62451",
    "data-name": "Path 62451",
    className: "cls-124",
    d: "M615,616.931l-.332.192.45.259h.589l.037-.021Z",
    transform: "translate(-579.078 -581.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62452",
    "data-name": "Path 62452",
    className: "cls-124",
    d: "M459.567,222.689l10.978-6.338,7.285,4.206L466.853,226.9Z",
    transform: "translate(-432.956 -203.823)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63605",
    "data-name": "Group 63605",
    className: "cls-131",
    transform: "translate(26.612 12.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63604",
    "data-name": "Group 63604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63603",
    "data-name": "Group 63603",
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62453",
    "data-name": "Path 62453",
    className: "cls-211",
    d: "M470.545,216.35l-10.978,6.338,1.068.616h.162l10.9-6.291Z",
    transform: "translate(-459.567 -216.35)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63608",
    "data-name": "Group 63608",
    className: "cls-45",
    transform: "translate(35.886 17.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63607",
    "data-name": "Group 63607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63606",
    "data-name": "Group 63606",
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62454",
    "data-name": "Path 62454",
    className: "cls-47",
    d: "M623.107,302.277l-.179-.1-3.2,2.23h.334a.928.928,0,0,0,.455-.109l2.587-1.494a.277.277,0,0,0,0-.524",
    transform: "translate(-619.731 -302.173)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62455",
    "data-name": "Path 62455",
    className: "cls-216",
    d: "M550.28,283.273l2.563,1.48h.285l-2.563-1.48Z",
    transform: "translate(-518.416 -266.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62456",
    "data-name": "Path 62456",
    className: "cls-126",
    d: "M545.641,283.273l-.285.329,2.563,1.48.285-.329Z",
    transform: "translate(-513.777 -266.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62457",
    "data-name": "Path 62457",
    className: "cls-126",
    d: "M545.356,283.6v-.329h.285Z",
    transform: "translate(-513.777 -266.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62458",
    "data-name": "Path 62458",
    className: "cls-216",
    d: "M580.405,265.881l2.563,1.48h.285l-2.563-1.48Z",
    transform: "translate(-546.797 -250.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62459",
    "data-name": "Path 62459",
    className: "cls-126",
    d: "M575.766,265.881l-.285.329,2.563,1.48.285-.329Z",
    transform: "translate(-542.158 -250.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62460",
    "data-name": "Path 62460",
    className: "cls-126",
    d: "M575.482,266.21v-.329h.285Z",
    transform: "translate(-542.158 -250.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62461",
    "data-name": "Path 62461",
    className: "cls-216",
    d: "M490.03,318.059l5.759,3.325h.285l-5.759-3.325Z",
    transform: "translate(-461.654 -299.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62462",
    "data-name": "Path 62462",
    className: "cls-216",
    d: "M584.567,375.812h.57l-.285-.329Z",
    transform: "translate(-550.717 -353.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62463",
    "data-name": "Path 62463",
    className: "cls-226",
    d: "M589.775,375.483v.329l-.285-.329Z",
    transform: "translate(-555.355 -353.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62464",
    "data-name": "Path 62464",
    className: "cls-126",
    d: "M485.391,318.059l-.285.329,5.759,3.325.285-.329Z",
    transform: "translate(-457.015 -299.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62465",
    "data-name": "Path 62465",
    className: "cls-126",
    d: "M485.106,318.388v-.329h.285Z",
    transform: "translate(-457.015 -299.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62466",
    "data-name": "Path 62466",
    className: "cls-216",
    d: "M520.155,300.666l5.759,3.325h.285l-5.759-3.325Z",
    transform: "translate(-490.035 -283.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62467",
    "data-name": "Path 62467",
    className: "cls-216",
    d: "M614.692,358.42h.57l-.285-.329Z",
    transform: "translate(-579.097 -337.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62468",
    "data-name": "Path 62468",
    className: "cls-226",
    d: "M619.9,358.09v.329l-.285-.329Z",
    transform: "translate(-583.736 -337.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62469",
    "data-name": "Path 62469",
    className: "cls-126",
    d: "M515.516,300.666l-.285.329,5.759,3.325.285-.329Z",
    transform: "translate(-485.396 -283.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62470",
    "data-name": "Path 62470",
    className: "cls-126",
    d: "M515.231,301v-.329h.285Z",
    transform: "translate(-485.396 -283.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62471",
    "data-name": "Path 62471",
    className: "cls-216",
    d: "M610.531,248.488l5.759,3.325h.285l-5.759-3.325Z",
    transform: "translate(-575.177 -234.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62472",
    "data-name": "Path 62472",
    className: "cls-216",
    d: "M705.068,306.241h.57l-.285-.329Z",
    transform: "translate(-664.24 -288.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62473",
    "data-name": "Path 62473",
    className: "cls-226",
    d: "M710.276,305.912v.329l-.285-.329Z",
    transform: "translate(-668.879 -288.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62474",
    "data-name": "Path 62474",
    className: "cls-126",
    d: "M605.892,248.488l-.285.329,5.759,3.325.285-.329Z",
    transform: "translate(-570.538 -234.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62475",
    "data-name": "Path 62475",
    className: "cls-126",
    d: "M605.607,248.817v-.329h.285Z",
    transform: "translate(-570.539 -234.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62476",
    "data-name": "Path 62476",
    className: "cls-216",
    d: "M640.656,231.095l5.759,3.325h.285l-5.759-3.325Z",
    transform: "translate(-603.558 -217.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62477",
    "data-name": "Path 62477",
    className: "cls-216",
    d: "M735.193,288.849h.57l-.285-.329Z",
    transform: "translate(-692.621 -271.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62478",
    "data-name": "Path 62478",
    className: "cls-226",
    d: "M740.4,288.519v.329l-.285-.329Z",
    transform: "translate(-697.26 -271.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62479",
    "data-name": "Path 62479",
    className: "cls-126",
    d: "M636.017,231.1l-.285.329,5.759,3.325.285-.329Z",
    transform: "translate(-598.919 -217.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62480",
    "data-name": "Path 62480",
    className: "cls-126",
    d: "M635.732,231.424V231.1h.285Z",
    transform: "translate(-598.919 -217.714)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63612",
    "data-name": "Group 63612",
    transform: "translate(33.818 17.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63611",
    "data-name": "Group 63611",
    className: "cls-227"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23385",
    "data-name": "Rectangle 23385",
    className: "cls-228",
    width: 5.264,
    height: 2.453,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63683",
    "data-name": "Group 63683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63682",
    "data-name": "Group 63682",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62482",
    "data-name": "Path 62482",
    className: "cls-53",
    d: "M589.09,279.57l-1.393-.8a1,1,0,0,0-.908,0L584.2,280.26a.277.277,0,0,0,0,.524l1.393.8a1,1,0,0,0,.908,0l2.588-1.494a.277.277,0,0,0,0-.524",
    transform: "translate(-550.195 -262.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62483",
    "data-name": "Path 62483",
    className: "cls-216",
    d: "M634.274,331.767l.9.517h.285l-.9-.517Z",
    transform: "translate(-597.546 -312.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62484",
    "data-name": "Path 62484",
    className: "cls-216",
    d: "M644.817,341.027h.57l-.285-.329Z",
    transform: "translate(-607.478 -320.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62485",
    "data-name": "Path 62485",
    className: "cls-226",
    d: "M650.026,340.7v.329l-.285-.329Z",
    transform: "translate(-612.117 -320.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62486",
    "data-name": "Path 62486",
    className: "cls-126",
    d: "M629.635,331.767l-.285.329.9.517.285-.329Z",
    transform: "translate(-592.907 -312.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62487",
    "data-name": "Path 62487",
    className: "cls-216",
    d: "M664.4,314.374l.9.517h.285l-.9-.517Z",
    transform: "translate(-625.926 -296.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62488",
    "data-name": "Path 62488",
    className: "cls-216",
    d: "M674.942,323.634h.57l-.285-.329Z",
    transform: "translate(-635.859 -304.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62489",
    "data-name": "Path 62489",
    className: "cls-226",
    d: "M680.151,323.3v.329l-.285-.329Z",
    transform: "translate(-640.498 -304.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62490",
    "data-name": "Path 62490",
    className: "cls-126",
    d: "M659.76,314.374l-.285.329.9.517.285-.329Z",
    transform: "translate(-621.288 -296.17)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63615",
    "data-name": "Group 63615",
    className: "cls-229",
    transform: "translate(38.187 18.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63614",
    "data-name": "Group 63614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63613",
    "data-name": "Group 63613",
    className: "cls-230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62491",
    "data-name": "Path 62491",
    className: "cls-47",
    d: "M659.659,314.81l.2-.378-.1-.058-.285.329Z",
    transform: "translate(-659.475 -314.374)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63618",
    "data-name": "Group 63618",
    className: "cls-212",
    transform: "translate(38.473 18.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63617",
    "data-name": "Group 63617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63616",
    "data-name": "Group 63616",
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62492",
    "data-name": "Path 62492",
    className: "cls-47",
    d: "M664.869,314.481l-.369-.048-.1-.058h.285Z",
    transform: "translate(-664.399 -314.374)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63621",
    "data-name": "Group 63621",
    className: "cls-229",
    transform: "translate(36.443 19.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63620",
    "data-name": "Group 63620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63619",
    "data-name": "Group 63619",
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62493",
    "data-name": "Path 62493",
    className: "cls-47",
    d: "M629.532,332.2l.2-.376-.1-.058-.285.329Z",
    transform: "translate(-629.35 -331.767)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63624",
    "data-name": "Group 63624",
    className: "cls-212",
    transform: "translate(36.728 19.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63623",
    "data-name": "Group 63623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63622",
    "data-name": "Group 63622",
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62494",
    "data-name": "Path 62494",
    className: "cls-47",
    d: "M634.744,331.874l-.369-.048-.1-.058h.285Z",
    transform: "translate(-634.274 -331.767)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63627",
    "data-name": "Group 63627",
    className: "cls-233",
    transform: "translate(31.864 16.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63626",
    "data-name": "Group 63626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63625",
    "data-name": "Group 63625",
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62495",
    "data-name": "Path 62495",
    className: "cls-211",
    d: "M550.281,283.273l.513.3h.285l-.513-.3Z",
    transform: "translate(-550.281 -283.273)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63630",
    "data-name": "Group 63630",
    className: "cls-233",
    transform: "translate(31.579 16.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63629",
    "data-name": "Group 63629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63628",
    "data-name": "Group 63628",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62496",
    "data-name": "Path 62496",
    className: "cls-211",
    d: "M545.642,283.273l.513.3-.285.329-.513-.3Z",
    transform: "translate(-545.357 -283.273)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63633",
    "data-name": "Group 63633",
    className: "cls-236",
    transform: "translate(31.579 16.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63632",
    "data-name": "Group 63632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63631",
    "data-name": "Group 63631",
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62497",
    "data-name": "Path 62497",
    className: "cls-211",
    d: "M545.357,283.6v-.329h.285Z",
    transform: "translate(-545.357 -283.274)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63636",
    "data-name": "Group 63636",
    className: "cls-233",
    transform: "translate(33.609 15.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63635",
    "data-name": "Group 63635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63634",
    "data-name": "Group 63634",
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62498",
    "data-name": "Path 62498",
    className: "cls-211",
    d: "M580.406,265.881l.513.3h.285l-.513-.3Z",
    transform: "translate(-580.406 -265.881)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63639",
    "data-name": "Group 63639",
    className: "cls-233",
    transform: "translate(33.324 15.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63638",
    "data-name": "Group 63638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63637",
    "data-name": "Group 63637",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62499",
    "data-name": "Path 62499",
    className: "cls-211",
    d: "M575.767,265.881l.513.3-.285.329-.513-.3Z",
    transform: "translate(-575.482 -265.881)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63642",
    "data-name": "Group 63642",
    className: "cls-236",
    transform: "translate(33.324 15.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63641",
    "data-name": "Group 63641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63640",
    "data-name": "Group 63640",
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62500",
    "data-name": "Path 62500",
    className: "cls-211",
    d: "M575.482,266.211v-.329h.285Z",
    transform: "translate(-575.482 -265.881)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63645",
    "data-name": "Group 63645",
    className: "cls-233",
    transform: "translate(28.376 18.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63644",
    "data-name": "Group 63644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63643",
    "data-name": "Group 63643",
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62501",
    "data-name": "Path 62501",
    className: "cls-211",
    d: "M490.03,318.059l.513.3h.285l-.513-.3Z",
    transform: "translate(-490.03 -318.059)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63648",
    "data-name": "Group 63648",
    className: "cls-233",
    transform: "translate(28.09 18.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63647",
    "data-name": "Group 63647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63646",
    "data-name": "Group 63646",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62502",
    "data-name": "Path 62502",
    className: "cls-211",
    d: "M485.391,318.059l.513.3-.285.329-.513-.3Z",
    transform: "translate(-485.106 -318.059)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63651",
    "data-name": "Group 63651",
    className: "cls-236",
    transform: "translate(28.09 18.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63650",
    "data-name": "Group 63650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63649",
    "data-name": "Group 63649",
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62503",
    "data-name": "Path 62503",
    className: "cls-211",
    d: "M485.106,318.388v-.329h.285Z",
    transform: "translate(-485.106 -318.059)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63654",
    "data-name": "Group 63654",
    className: "cls-233",
    transform: "translate(30.12 17.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63653",
    "data-name": "Group 63653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63652",
    "data-name": "Group 63652",
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62504",
    "data-name": "Path 62504",
    className: "cls-211",
    d: "M520.155,300.666l.513.3h.285l-.513-.3Z",
    transform: "translate(-520.155 -300.666)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63657",
    "data-name": "Group 63657",
    className: "cls-233",
    transform: "translate(29.835 17.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63656",
    "data-name": "Group 63656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63655",
    "data-name": "Group 63655",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62505",
    "data-name": "Path 62505",
    className: "cls-211",
    d: "M515.516,300.666l.513.3-.285.329-.513-.3Z",
    transform: "translate(-515.231 -300.666)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63660",
    "data-name": "Group 63660",
    className: "cls-236",
    transform: "translate(29.835 17.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63659",
    "data-name": "Group 63659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63658",
    "data-name": "Group 63658",
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62506",
    "data-name": "Path 62506",
    className: "cls-211",
    d: "M515.231,301v-.329h.285Z",
    transform: "translate(-515.231 -300.667)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63663",
    "data-name": "Group 63663",
    className: "cls-233",
    transform: "translate(35.353 14.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63662",
    "data-name": "Group 63662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63661",
    "data-name": "Group 63661",
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62507",
    "data-name": "Path 62507",
    className: "cls-211",
    d: "M610.532,248.488l.513.3h.285l-.513-.3Z",
    transform: "translate(-610.532 -248.488)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63666",
    "data-name": "Group 63666",
    className: "cls-233",
    transform: "translate(35.068 14.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63665",
    "data-name": "Group 63665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63664",
    "data-name": "Group 63664",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62508",
    "data-name": "Path 62508",
    className: "cls-211",
    d: "M605.893,248.488l.513.3-.285.329-.513-.3Z",
    transform: "translate(-605.608 -248.488)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63669",
    "data-name": "Group 63669",
    className: "cls-236",
    transform: "translate(35.068 14.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63668",
    "data-name": "Group 63668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63667",
    "data-name": "Group 63667",
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62509",
    "data-name": "Path 62509",
    className: "cls-211",
    d: "M605.608,248.818v-.329h.285Z",
    transform: "translate(-605.608 -248.489)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63672",
    "data-name": "Group 63672",
    className: "cls-233",
    transform: "translate(37.098 13.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63671",
    "data-name": "Group 63671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63670",
    "data-name": "Group 63670",
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62510",
    "data-name": "Path 62510",
    className: "cls-211",
    d: "M640.657,231.1l.513.3h.285l-.513-.3Z",
    transform: "translate(-640.657 -231.096)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63675",
    "data-name": "Group 63675",
    className: "cls-233",
    transform: "translate(36.813 13.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63674",
    "data-name": "Group 63674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63673",
    "data-name": "Group 63673",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62511",
    "data-name": "Path 62511",
    className: "cls-211",
    d: "M636.018,231.1l.513.3-.285.329-.513-.3Z",
    transform: "translate(-635.733 -231.096)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63678",
    "data-name": "Group 63678",
    className: "cls-236",
    transform: "translate(36.813 13.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63677",
    "data-name": "Group 63677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63676",
    "data-name": "Group 63676",
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62512",
    "data-name": "Path 62512",
    className: "cls-211",
    d: "M635.733,231.425V231.1h.285Z",
    transform: "translate(-635.733 -231.096)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62513",
    "data-name": "Path 62513",
    className: "cls-198",
    d: "M630.863,395.726l-1-.482-1.411.814c-.8-.346-2,.347-2.8,1.618l-6.481,3.742.189.95.589,1.311,10.914-6.3Z",
    transform: "translate(-583.317 -372.357)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63681",
    "data-name": "Group 63681",
    className: "cls-70",
    transform: "translate(35.449 18.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63680",
    "data-name": "Group 63680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63679",
    "data-name": "Group 63679",
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62514",
    "data-name": "Path 62514",
    className: "cls-215",
    d: "M623.166,329.8l-9.319,5.38c-.313.181-.633,0-.714-.412l-.956-4.806,10.452-6.035.956,4.806a1.055,1.055,0,0,1-.42,1.067",
    transform: "translate(-612.177 -323.923)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63685",
    "data-name": "Group 63685",
    transform: "translate(36.759 18.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63684",
    "data-name": "Group 63684",
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23410",
    "data-name": "Rectangle 23410",
    className: "cls-240",
    width: 14.957,
    height: 14.561,
    transform: "translate(-4.83 8.672) rotate(-60.884)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63687",
    "data-name": "Group 63687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63686",
    "data-name": "Group 63686",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62516",
    "data-name": "Path 62516",
    className: "cls-214",
    d: "M616.243,314.669l-11.5,6.641,1.024,5.148.589,1.311,10.914-6.3v-1.651Zm.076,6.5L607,326.549c-.313.181-.633,0-.714-.412l-.956-4.806,10.453-6.035.956,4.806a1.055,1.055,0,0,1-.42,1.066",
    transform: "translate(-569.722 -296.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62517",
    "data-name": "Path 62517",
    className: "cls-241",
    d: "M679.939,476.17l.121.07,1.7-.983-.121-.07Z",
    transform: "translate(-640.567 -447.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62518",
    "data-name": "Path 62518",
    className: "cls-242",
    d: "M680.06,492.232l-.121-.07.144.126.121.07Z",
    transform: "translate(-640.566 -463.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62519",
    "data-name": "Path 62519",
    className: "cls-52",
    d: "M683.726,476.391l-1.7.983.144.126,1.6-.921Z",
    transform: "translate(-642.53 -448.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62520",
    "data-name": "Path 62520",
    className: "cls-241",
    d: "M647.581,480.968l.121.07,2.8-1.614-.121-.07Z",
    transform: "translate(-610.082 -451.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62521",
    "data-name": "Path 62521",
    className: "cls-52",
    d: "M652.46,480.557l-2.8,1.614.037.188,2.8-1.614Z",
    transform: "translate(-612.045 -452.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62522",
    "data-name": "Path 62522",
    className: "cls-243",
    d: "M647.7,507.3l-.121-.07.037.188.121.07Z",
    transform: "translate(-610.082 -477.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62523",
    "data-name": "Path 62523",
    className: "cls-241",
    d: "M752.912,434.039l.121.07,1.7-.983-.121-.07Z",
    transform: "translate(-709.314 -407.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62524",
    "data-name": "Path 62524",
    className: "cls-242",
    d: "M753.033,450.1l-.121-.07.144.126.121.07Z",
    transform: "translate(-709.314 -423.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62525",
    "data-name": "Path 62525",
    className: "cls-52",
    d: "M756.7,434.259l-1.7.983.144.126,1.6-.921Z",
    transform: "translate(-711.278 -409.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62526",
    "data-name": "Path 62526",
    className: "cls-241",
    d: "M720.554,438.837l.121.07,2.8-1.614-.121-.07Z",
    transform: "translate(-678.83 -411.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62527",
    "data-name": "Path 62527",
    className: "cls-52",
    d: "M725.433,438.426l-2.8,1.614.037.188,2.8-1.614Z",
    transform: "translate(-680.793 -413.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62528",
    "data-name": "Path 62528",
    className: "cls-243",
    d: "M720.675,465.166l-.121-.07.037.188.121.07Z",
    transform: "translate(-678.83 -438.165)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63689",
    "data-name": "Group 63689",
    transform: "translate(34.686 31.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63688",
    "data-name": "Group 63688",
    className: "cls-244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23412",
    "data-name": "Rectangle 23412",
    className: "cls-245",
    width: 1.037,
    height: 3.175
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63697",
    "data-name": "Group 63697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63696",
    "data-name": "Group 63696",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63692",
    "data-name": "Group 63692",
    className: "cls-212",
    transform: "translate(34.686 31.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63691",
    "data-name": "Group 63691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63690",
    "data-name": "Group 63690",
    className: "cls-246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62530",
    "data-name": "Path 62530",
    className: "cls-211",
    d: "M599.014,538.451l.179.157.57,1.565a4.2,4.2,0,0,0,.287.661v-.579c-.024-.06-.048-.124-.074-.194l-.411-1.127.331.29.153.521v-.7Z",
    transform: "translate(-599.014 -538.451)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62531",
    "data-name": "Path 62531",
    className: "cls-124",
    d: "M599.014,582.947l1.037.358v.24Z",
    transform: "translate(-564.328 -549.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62532",
    "data-name": "Path 62532",
    className: "cls-247",
    d: "M626.9,605.646l-.6-.349.6-.138Z",
    transform: "translate(-590.026 -570.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62533",
    "data-name": "Path 62533",
    className: "cls-52",
    d: "M646.281,509.882v.486l-9.556,5.517V515.4Z",
    transform: "translate(-599.855 -480.356)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63695",
    "data-name": "Group 63695",
    className: "cls-212",
    transform: "translate(31.213 28.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63694",
    "data-name": "Group 63694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63693",
    "data-name": "Group 63693",
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62534",
    "data-name": "Path 62534",
    className: "cls-211",
    d: "M539.851,500.808l-.155-.554-.663.579.159.57.346.2c.187.108.338.02.338-.2v-.432a.586.586,0,0,0-.027-.168",
    transform: "translate(-539.034 -500.254)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63699",
    "data-name": "Group 63699",
    transform: "translate(31.054 28.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63698",
    "data-name": "Group 63698",
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23416",
    "data-name": "Rectangle 23416",
    className: "cls-250",
    width: 1.48,
    height: 1.777,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, -0.648, 0.345)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63713",
    "data-name": "Group 63713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63712",
    "data-name": "Group 63712",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62536",
    "data-name": "Path 62536",
    className: "cls-162",
    d: "M536.97,491.676v.432c0,.216-.152.3-.338.2l-.346-.2V490.89l.346.2a.748.748,0,0,1,.338.586",
    transform: "translate(-505.231 -462.465)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63702",
    "data-name": "Group 63702",
    className: "cls-143",
    transform: "translate(46.515 17.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63701",
    "data-name": "Group 63701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63700",
    "data-name": "Group 63700",
    className: "cls-251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62537",
    "data-name": "Path 62537",
    className: "cls-52",
    d: "M803.678,301.488l.4.233-.292-1.467-.506-.747Z",
    transform: "translate(-803.284 -299.507)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63705",
    "data-name": "Group 63705",
    className: "cls-67",
    transform: "translate(35.012 17.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63704",
    "data-name": "Group 63704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63703",
    "data-name": "Group 63703",
    className: "cls-252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62538",
    "data-name": "Path 62538",
    className: "cls-253",
    d: "M604.631,306.148l.507.747,11.5-6.641-.507-.747Z",
    transform: "translate(-604.631 -299.507)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63708",
    "data-name": "Group 63708",
    className: "cls-67",
    transform: "translate(35.518 18.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63707",
    "data-name": "Group 63707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63706",
    "data-name": "Group 63706",
    className: "cls-254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62539",
    "data-name": "Path 62539",
    className: "cls-52",
    d: "M624.883,312.41l-11.5,6.641.292,1.467,11.5-6.641Z",
    transform: "translate(-613.38 -312.41)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63711",
    "data-name": "Group 63711",
    className: "cls-67",
    transform: "translate(35.012 23.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63710",
    "data-name": "Group 63710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63709",
    "data-name": "Group 63709",
    className: "cls-251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62540",
    "data-name": "Path 62540",
    className: "cls-255",
    d: "M605.026,416.18l.4.233-.292-1.467-.507-.747Z",
    transform: "translate(-604.631 -414.199)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63718",
    "data-name": "Group 63718",
    transform: "translate(33.367 29.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63717",
    "data-name": "Group 63717",
    className: "cls-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63716",
    "data-name": "Group 63716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63715",
    "data-name": "Group 63715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63714",
    "data-name": "Group 63714",
    className: "cls-257"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_23422",
    "data-name": "Rectangle 23422",
    width: 1.418,
    height: 1.056,
    transform: "translate(-0.014 -0.024)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAIAAADm2DRVAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAM6ADAAQAAAABAAAAJgAAAABExXeQAAAEXUlEQVRYCcWYvW7UQBDH7YvvgMcAJBoCCIIED4Ao+egSCiQaQDQpoCMlaRFUBAq+hBK6iAYJngAkIoFIQQPPAfGdzW9m7LVvvY6T4xKsiz27O7v78/xn13bi1Ucr0fgRR/HMTI8jSeTST2ZiPY6emuU37ruHpfjS4TPe8GD0+8mg3x8MksGgf+jgAQCpvHh9np/nvHfFXnDoOIpiQscRbN6XyhYygRIqu5i9LzzVJGEybc/Nq7hUXfbJCpNBkyvR/8Li7sNkkSNyxp5F6uPrt8Gxk2AtISvrnVFWTO/689smWJyD+1EbWaEmGLnpOj0gG+nJ3SWYzP7wau3Ow2VvhhY1Pa+pFonTvQtXDIvbzrLsx8bX98/feJMEyGS7iGPdXMV5ilsaNDC5xIJpNBptpcOtrXR95aVHFlKT1LLssvM0tluYLKVsekI1EqxsCJocgri+8uLq7RuOL0BWUOXVKnDekxn1lILJsNIUKqJWwA2H2dvHz46dPnn83JzNElBTG1zcJoMpejVTCpw/W+lv/hAxTeWaDtN0JOfhaPXxUzdfIGau7V8M5CNUbgSLk8in+lm4VESpscjhs/lp4/unLyfOn6VjK9nEe0UzpXRiVU2xLMMst+QskmbuHtDUyIJqlpm2ezrkc1llcSIkKpmolQ5FskI7CtjkVw0Lvs3PG2uqaSBmvP7gwTtj8bqhm23n6wZM/NytM5/GZmRiSbprcKxoYQPd+dcNwraweCtAVkas7ryd3ZRP9wFNKfg0pwiNoRluloWZ3DSELUBWNtO5o3+TKWOjkjSXEJHZglieiaLmepVS5UT+dfbcXDhmvmNLuS4funDo3KSO0FiIhLKAk4qWkapqmOYXb3asTXFvCZnHhKMqlo1vnqCUMUO8lpSqoKLowepTY7LKBEyWQ90DW4TUZ4AaFWBAPt3EVT1IkJKjABJcgrcDJuKEfB5DMns+QGZO8sBEozya0XJ96Yl2klKy9BSGTBfhZElKJVeh8iZrFuvyea2BFSCRlxs1BYSu3odaDkspwaqjlNHSSI31qo9g9jZM5hAgswadnsBIuvR6/HrGaLlNSllU2DYlPmhqEROzg4nxg/LZvO4cJlOavNdDFySNoeTbmD6mHEU4VEZlKuTckXw7YTI4mfXykeLFw/Fi8IHeT+TgPwnyb4QYT/n8tOeJEGXwSaBU0H9Kqfq8zpZIcB88EFyVGUwa5cKd5wkQiIklK02TDErB0sVIjdfXK3amlOdvRSGjZ7MNiDRHy36ep7x763NTGPiTtKc5EqPZ0avZuXxeR4kEVfcXbjZ3NeoBAgpBsQ0Lg2UhYF0HN7y85kvR1alqL8h4X1u65u91ldcurcnk8yYp1iaPBYYLhs3r0Fn0HjKd/m0ORcysuU3Tts5e/cQp5Y1jxbF3WoYOroZgz3olvd792mg+++o+u7XHYmaddxW5qaRUEDpAZn68VfIls03mTVe7JlwrmXO17wVXnK5kbtim8ReW3AB+9gKHzwAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63720",
    "data-name": "Group 63720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63719",
    "data-name": "Group 63719",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62542",
    "data-name": "Path 62542",
    className: "cls-52",
    d: "M576.923,516.484a.323.323,0,0,0-.295-.269l-.01,0a.18.18,0,0,1,0-.037v-.6h-.379v.6a.41.41,0,0,0,.189.372.351.351,0,0,0,.178.047.481.481,0,0,0,.239-.069Z",
    transform: "translate(-542.869 -485.728)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63722",
    "data-name": "Group 63722",
    transform: "translate(34.525 30.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63721",
    "data-name": "Group 63721",
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23425",
    "data-name": "Rectangle 23425",
    className: "cls-259",
    width: 0.438,
    height: 0.465,
    transform: "translate(-0.172 0.092) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63724",
    "data-name": "Group 63724",
    transform: "translate(32.749 26.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63723",
    "data-name": "Group 63723",
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23426",
    "data-name": "Rectangle 23426",
    className: "cls-261",
    width: 4.048,
    height: 3.225,
    transform: "translate(-1.63 2.842) rotate(-60.162)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63729",
    "data-name": "Group 63729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63728",
    "data-name": "Group 63728",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63727",
    "data-name": "Group 63727",
    className: "cls-143",
    transform: "translate(33.557 26.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63726",
    "data-name": "Group 63726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63725",
    "data-name": "Group 63725",
    className: "cls-262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62545",
    "data-name": "Path 62545",
    className: "cls-151",
    d: "M580.2,458.788a.149.149,0,0,0-.148.015l-.148.085a.162.162,0,0,1-.081.022h-.318v.219h.082l.379-.219.135-.078a.148.148,0,0,1,.149-.015Z",
    transform: "translate(-579.506 -458.775)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62546",
    "data-name": "Path 62546",
    className: "cls-52",
    d: "M571.388,459.3l-.921.532a.466.466,0,0,0-.211.366v2.557c0,.134.094.189.211.122l.921-.532a.467.467,0,0,0,.211-.365V459.42c0-.135-.095-.189-.211-.122",
    transform: "translate(-537.235 -432.675)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63734",
    "data-name": "Group 63734",
    transform: "translate(33.367 25.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63733",
    "data-name": "Group 63733",
    className: "cls-263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63732",
    "data-name": "Group 63732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63731",
    "data-name": "Group 63731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63730",
    "data-name": "Group 63730",
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_23429",
    "data-name": "Rectangle 23429",
    width: 1.418,
    height: 1.807,
    transform: "translate(-0.014 -0.017)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAABBCAIAAADzKQu3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAM6ADAAQAAAABAAAAQQAAAABv19zNAAAFTElEQVRoBc2aP4/cRBjGd6P7IhRICBEUiUjkAyDqlKGhTMqIP10ooYooEqGgUCABUi6UKQFRQ0SCAkmkFAnfI+ezl9/zvvZ4Zmzv3t2u7XX2dsfe9cxvn+eZ1+O7LFer1WK+7dU/z3h8+PGVLsJB99BkR3798T4PH64Lt5xFs5gJMhi+/v1BpsjUZHgHFs+Bo6qq47J84/zbn3xzMxykMZ2bvUwlWHCV5fOHf7949OStixcC3ESade1DqsKYyrLiH89vXnj3xve3A9nomiHVt599EcYjUm6fpKIlrFq2f//469nDx++8/55/eETNeu0zmRQsqSQmyWWyVaWxPvjvsZONpRk6xTFHKtPm2FIlnaChLdVKkHitvEoc3rr70fVrwO1es95IIUfDZAopWRYv08mplsvac5dtl2RZpBjHNJF3RXEs7zzqLpiZyEGq2SJAGRtR++rwu9242Rsps0xSQWahMp0wUbuWfCyTbY1WtWQL5sHTPx/tgKwbKZQIFcGxHK3OO29XK3hyooaMV+C2IuuJ1GpFyJtomzx4JzoJxsYTK4iOTBHUYvHlvbvnL108I1nXvto7MwoKIhX4mmPMPjGtkerK9as+MSE9NVmXyZWwqefaSB1aeKe3bA4SdDENQ3nqY+lOR/bLD4e//fRzOD8p6KaMMQnLNseqltrCSXkDJqTCvuyNk5K9fPLU1wg+iJgonlalXC1XDoW0a5pZlSLpw1BNpDIm3z1RPUMqsPwErYDrgu7FE4z62sdLPRMFtc47+ogj5T1nz5s1u/PpDbLlp7lUddm0hCtG2mScxCrtIrPJPgppxtHd3UCWYaHP0ZFKFV5aQTfnmuIOmLwbtm8oUl0sjqwji7EsVdRP9FK5kkoVOZNgRod7GyK10b6Mb5AsruxgCagAQljQCcykAk1rBNMq6zrsnpbJT+wnI1g8GM7rQsElWSaaQqIrAVWkvI8d2Re+ySAZTGEVijAgBQeNyXQrWSP4BTnrsN49VaR6u+jRLBQI98uwZF+BdKTK5NI1Zqm7MdnY2c5mX9ZNTubllA8xqjjMNbCYkoKz7LvL3lEGtxMm7zkhw8dYMPkoKxUsgi6xtHrpL87b27dOs4DFzPMJSMOU06wk8sxBRIq7cDd93RIf377daubzkR4ZG5GQSQ+zz/j6sZDqJAX9DKAtWRCM4Esnfho40ibetHvUGg+LoVoyNHPBvIpqYqqC+QLQ5mDEBtYYDsbf/ZzvBMGQRppJNhrcJOoSnaXe1equqOJ+t2/Xif78g8veFxPw9WtdtZkBR0VRHMnVLPiQhTvp7QmGepBmQbDaQV7QzKxEvC4WPg51t8PjtZveI8YJDpzKlqy8RNniM6hFLR3bR4dJNMM4g/HlDVHTeiuDYz7uUJg1XbWaIRSiIFbYuqeBNY1gDN2S1XnKqlZE51ZGB8ZtHngZ0yDY5qkCTq1mNwKYTDDGPBfI4HEfVcyshUiBKm6Hg6M2WjeBSXRKbUVAZuWoKFnnkWYykHeXXjJSMNWL7Myxd9uceayMTjfgPvD0QOELt26GQ3vSGCCb2roeNRIy5zEH50eLyVqattXzZSY61JI1gtUDzw7XkjW/pQRJ95LUiYnEGRgmIuOaxIdsIaQ1ULr+GTh9xMMJmV0ubbCZ9RJDSmYWYuMegOVkwZ352VLN4HGk+cFSzYxHdHsAlpDtA0+IU0KmOmHFQvfA7UdmaqU5sxqmpz2QLyVTxmaSqDNsSta8vQ94GVlACo0GdvLXjEzj6xowP1gyNyeXZe2AB/7fqygW3NXZ3yL4VZ7+ZMotZ3biZL/R8HH/BzauqKDQEZ5hAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63736",
    "data-name": "Group 63736",
    transform: "translate(34.525 25.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63735",
    "data-name": "Group 63735",
    className: "cls-265"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23431",
    "data-name": "Rectangle 23431",
    className: "cls-266",
    width: 0.438,
    height: 0.465,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.172, 0.092)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63738",
    "data-name": "Group 63738",
    transform: "translate(33.367 26.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63737",
    "data-name": "Group 63737",
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23432",
    "data-name": "Rectangle 23432",
    className: "cls-268",
    width: 0.379,
    height: 0.219
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63740",
    "data-name": "Group 63740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63739",
    "data-name": "Group 63739",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62550",
    "data-name": "Path 62550",
    className: "cls-52",
    d: "M661.234,537.029l5.638-3.255.473-1.684-.312-.18-6.7,3.869.5.289Z",
    transform: "translate(-622.095 -501.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62551",
    "data-name": "Path 62551",
    className: "cls-146",
    d: "M773.921,532.769l-.441-.254-.065.232.251.145-.408,1.453.19.109Z",
    transform: "translate(-728.482 -501.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62552",
    "data-name": "Path 62552",
    className: "cls-146",
    d: "M666.711,586.771l.182.179.441.254-.508-.5Z",
    transform: "translate(-628.105 -552.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62553",
    "data-name": "Path 62553",
    className: "cls-137",
    d: "M643.526,432.091l-10.914,6.3v3.858l2.089-1.206.508.5,5.719-3.3.508-1.086,2.089-1.206Z",
    transform: "translate(-595.98 -407.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23433",
    "data-name": "Rectangle 23433",
    className: "cls-269",
    width: 0.589,
    height: 4.035,
    transform: "translate(36.043 36.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62554",
    "data-name": "Path 62554",
    className: "cls-137",
    d: "M641.42,517.121l-.473,1.684-5.754,3.322-.473-1.138-2.107,1.216v4.035l10.914-6.3V515.9Z",
    transform: "translate(-595.981 -486.031)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63742",
    "data-name": "Group 63742",
    transform: "translate(45.696 25.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63741",
    "data-name": "Group 63741",
    className: "cls-270"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23435",
    "data-name": "Rectangle 23435",
    className: "cls-271",
    width: 2.861,
    height: 3.574,
    transform: "translate(-1.433 0.821) rotate(-29.827)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63744",
    "data-name": "Group 63744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63743",
    "data-name": "Group 63743",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62556",
    "data-name": "Path 62556",
    className: "cls-272",
    d: "M632.754,642.58l-.138-.333-2.079,1.2h-.128v.487Z",
    transform: "translate(-593.905 -605.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62557",
    "data-name": "Path 62557",
    className: "cls-273",
    d: "M625.239,648l-2.345,1.354h-.229l-.233.134h.59l2.4-1.384Z",
    transform: "translate(-586.39 -610.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62558",
    "data-name": "Path 62558",
    className: "cls-146",
    d: "M668.614,641.147l-.11.064.138.333.18.1Z",
    transform: "translate(-629.794 -604.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62559",
    "data-name": "Path 62559",
    className: "cls-137",
    d: "M622.433,662.969h.232v.487l-.232.134Z",
    transform: "translate(-586.391 -624.579)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23436",
    "data-name": "Rectangle 23436",
    className: "cls-274",
    width: 0.229,
    height: 0.487,
    transform: "translate(36.275 38.39)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63746",
    "data-name": "Group 63746",
    transform: "translate(37.088 31.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63745",
    "data-name": "Group 63745",
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23438",
    "data-name": "Rectangle 23438",
    className: "cls-276",
    width: 2.453,
    height: 2.841,
    transform: "matrix(0.864, -0.504, 0.504, 0.864, -1.078, 0.629)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63748",
    "data-name": "Group 63748",
    transform: "translate(37.131 31.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63747",
    "data-name": "Group 63747",
    className: "cls-277"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23439",
    "data-name": "Rectangle 23439",
    className: "cls-278",
    width: 2.086,
    height: 2.538,
    transform: "translate(-0.774 0.321) rotate(-22.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63750",
    "data-name": "Group 63750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63749",
    "data-name": "Group 63749",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62562",
    "data-name": "Path 62562",
    className: "cls-273",
    d: "M789.87,532.848l-.233.134v.222l-1.616.933-.07.248,1.919-1.108Z",
    transform: "translate(-742.324 -501.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62563",
    "data-name": "Path 62563",
    className: "cls-279",
    d: "M817.072,523.082v-.609l.233-.134v.609Z",
    transform: "translate(-769.759 -492.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62564",
    "data-name": "Path 62564",
    className: "cls-272",
    d: "M790.773,525.488v-.83l-1.338.772-.279.991Z",
    transform: "translate(-743.459 -494.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62565",
    "data-name": "Path 62565",
    className: "cls-273",
    d: "M782.09,557.455l-.233.134v.222l-2.095,1.209-.07.248,2.4-1.384Z",
    transform: "translate(-734.544 -525.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62566",
    "data-name": "Path 62566",
    className: "cls-279",
    d: "M817.072,554.479v-.191l.233-.134v.191Z",
    transform: "translate(-769.759 -522.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62567",
    "data-name": "Path 62567",
    className: "cls-272",
    d: "M782.993,556.883v-.413l-1.956,1.129-.139.493Z",
    transform: "translate(-735.679 -524.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62568",
    "data-name": "Path 62568",
    className: "cls-272",
    d: "M632.275,617.267,632,616.6l-1.46.843h-.128v.9Z",
    transform: "translate(-593.905 -580.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62569",
    "data-name": "Path 62569",
    className: "cls-273",
    d: "M624.761,628.157l-1.866,1.078h-.229l-.233.134h.59l1.919-1.108Z",
    transform: "translate(-586.39 -591.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62570",
    "data-name": "Path 62570",
    className: "cls-146",
    d: "M657.938,615.5l-.11.064.279.67.18.1Z",
    transform: "translate(-619.736 -579.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62571",
    "data-name": "Path 62571",
    className: "cls-137",
    d: "M622.433,631.156h.232v.9l-.232.134Z",
    transform: "translate(-586.391 -594.608)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23440",
    "data-name": "Rectangle 23440",
    className: "cls-274",
    width: 0.229,
    height: 0.904,
    transform: "translate(36.275 36.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62572",
    "data-name": "Path 62572",
    className: "cls-52",
    d: "M682.177,586.414l4.517-2.608.348-1.239-5.214,3.01Z",
    transform: "translate(-642.347 -548.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62573",
    "data-name": "Path 62573",
    className: "cls-269",
    d: "M622.433,518.269v5.169h.589V519.58Z",
    transform: "translate(-586.391 -488.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62574",
    "data-name": "Path 62574",
    className: "cls-52",
    d: "M669.849,471.158,664.4,474.3l-.947-2.275,7.342-4.239Z",
    transform: "translate(-625.036 -440.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62575",
    "data-name": "Path 62575",
    className: "cls-273",
    d: "M683.872,524.077l-5.332,3.078.073.176,5.448-3.145Z",
    transform: "translate(-639.249 -493.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62576",
    "data-name": "Path 62576",
    className: "cls-146",
    d: "M771.754,467.79l-.263.152-.874,3.108.19.109Z",
    transform: "translate(-725.995 -440.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62577",
    "data-name": "Path 62577",
    className: "cls-52",
    d: "M640.525,547l-.044.025.258,1.663a.494.494,0,0,0,.137.289.565.565,0,0,0,.437-.083Z",
    transform: "translate(-603.393 -515.321)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63752",
    "data-name": "Group 63752",
    transform: "translate(45.696 26.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63751",
    "data-name": "Group 63751",
    className: "cls-280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23442",
    "data-name": "Rectangle 23442",
    className: "cls-281",
    width: 3.302,
    height: 1.878,
    transform: "matrix(0.273, -0.962, 0.962, 0.273, -0.821, 2.897)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63766",
    "data-name": "Group 63766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63765",
    "data-name": "Group 63765",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62579",
    "data-name": "Path 62579",
    className: "cls-52",
    d: "M793.9,452.261a1.63,1.63,0,0,0,.718-1.118l.234-1.782-.163.094Z",
    transform: "translate(-747.932 -423.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62580",
    "data-name": "Path 62580",
    className: "cls-273",
    d: "M681.538,564.1l-5.638,3.255.074.176,5.754-3.322Z",
    transform: "translate(-636.761 -531.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62581",
    "data-name": "Path 62581",
    className: "cls-273",
    d: "M690.978,602.079l-4.4,2.541.073.177,4.517-2.608Z",
    transform: "translate(-646.82 -567.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62582",
    "data-name": "Path 62582",
    className: "cls-146",
    d: "M763.121,582.567l-.263.152-.275.978.19.109Z",
    transform: "translate(-718.425 -548.833)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63755",
    "data-name": "Group 63755",
    className: "cls-282",
    transform: "translate(33.359 21.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63754",
    "data-name": "Group 63754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63753",
    "data-name": "Group 63753",
    className: "cls-283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62583",
    "data-name": "Path 62583",
    className: "cls-211",
    d: "M576.577,378.077l-.329-.19a.23.23,0,0,1,.1.176c0,.112-.105.209-.262.26l.382-.013c.22-.007.4-.108.41-.233Z",
    transform: "translate(-576.086 -377.887)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63758",
    "data-name": "Group 63758",
    className: "cls-282",
    transform: "translate(33.375 21.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63757",
    "data-name": "Group 63757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63756",
    "data-name": "Group 63756",
    className: "cls-284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62584",
    "data-name": "Path 62584",
    className: "cls-211",
    d: "M576.717,376.109l-.354.018.475.274.2-.227a.64.64,0,0,0-.317-.065",
    transform: "translate(-576.363 -376.108)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63761",
    "data-name": "Group 63761",
    className: "cls-282",
    transform: "translate(33.85 21.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63760",
    "data-name": "Group 63760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63759",
    "data-name": "Group 63759",
    className: "cls-285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62585",
    "data-name": "Path 62585",
    className: "cls-211",
    d: "M584.763,377.25l-.2.227h.3a.306.306,0,0,0-.105-.227",
    transform: "translate(-584.566 -377.25)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63764",
    "data-name": "Group 63764",
    className: "cls-131",
    transform: "translate(32.432 21.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63763",
    "data-name": "Group 63763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63762",
    "data-name": "Group 63762",
    className: "cls-286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62586",
    "data-name": "Path 62586",
    className: "cls-211",
    d: "M561.174,375.857l-.123-.071a.8.8,0,0,0-.3-.056H560.6c-.288,0-.521.135-.521.3s.233.3.521.3h.147c.287,0,.52-.135.52-.3a.228.228,0,0,0-.1-.174",
    transform: "translate(-560.082 -375.73)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63768",
    "data-name": "Group 63768",
    transform: "translate(32.432 21.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63767",
    "data-name": "Group 63767",
    className: "cls-287"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23448",
    "data-name": "Rectangle 23448",
    className: "cls-288",
    width: 1.041,
    height: 0.822,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63770",
    "data-name": "Group 63770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63769",
    "data-name": "Group 63769",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62588",
    "data-name": "Path 62588",
    className: "cls-53",
    d: "M560.6,371.914c-.287,0-.52.135-.52.3s.233.3.52.3.521-.135.521-.3-.233-.3-.521-.3",
    transform: "translate(-527.649 -350.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62589",
    "data-name": "Path 62589",
    className: "cls-289",
    d: "M561.486,372.457c-.258,0-.466.12-.466.269s.209.269.466.269.466-.121.466-.269-.209-.269-.466-.269",
    transform: "translate(-528.534 -350.89)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63772",
    "data-name": "Group 63772",
    transform: "translate(32.7 21.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63771",
    "data-name": "Group 63771",
    className: "cls-290"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23450",
    "data-name": "Rectangle 23450",
    className: "cls-291",
    width: 0.809,
    height: 0.782,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -0.288, 0.464)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63793",
    "data-name": "Group 63793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63792",
    "data-name": "Group 63792",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62591",
    "data-name": "Path 62591",
    className: "cls-292",
    d: "M566.366,366.79c.081-.139.211-.215.292-.168s.081.2,0,.337-.211.215-.292.168-.08-.2,0-.337",
    transform: "translate(-533.513 -345.379)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63777",
    "data-name": "Group 63777",
    className: "cls-293",
    transform: "translate(32.486 20.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63776",
    "data-name": "Group 63776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63775",
    "data-name": "Group 63775",
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63774",
    "data-name": "Group 63774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63773",
    "data-name": "Group 63773",
    className: "cls-295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23451",
    "data-name": "Rectangle 23451",
    className: "cls-296",
    width: 0.932,
    height: 1.221,
    transform: "translate(0 0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63782",
    "data-name": "Group 63782",
    className: "cls-293",
    transform: "translate(32.541 20.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63781",
    "data-name": "Group 63781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63780",
    "data-name": "Group 63780",
    className: "cls-297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63779",
    "data-name": "Group 63779",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63778",
    "data-name": "Group 63778",
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23453",
    "data-name": "Rectangle 23453",
    className: "cls-299",
    width: 0.823,
    height: 0.475,
    transform: "translate(0 0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63785",
    "data-name": "Group 63785",
    className: "cls-293",
    transform: "translate(32.621 20.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63784",
    "data-name": "Group 63784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63783",
    "data-name": "Group 63783",
    className: "cls-300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62594",
    "data-name": "Path 62594",
    className: "cls-301",
    d: "M563.678,356.562c-.183,0-.331.086-.331.191s.148.191.331.191.331-.086.331-.191-.148-.191-.331-.191",
    transform: "translate(-563.347 -356.562)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63788",
    "data-name": "Group 63788",
    className: "cls-282",
    transform: "translate(43.533 16.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63787",
    "data-name": "Group 63787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63786",
    "data-name": "Group 63786",
    className: "cls-302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62595",
    "data-name": "Path 62595",
    className: "cls-211",
    d: "M752.472,278.256l-.438-.253a.187.187,0,0,1,.022.085c0,.111-.105.209-.262.26l.382-.013a.614.614,0,0,0,.3-.08",
    transform: "translate(-751.794 -278.003)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63791",
    "data-name": "Group 63791",
    className: "cls-131",
    transform: "translate(42.607 15.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63790",
    "data-name": "Group 63790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63789",
    "data-name": "Group 63789",
    className: "cls-286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62596",
    "data-name": "Path 62596",
    className: "cls-211",
    d: "M736.311,274.886h.147c.287,0,.521-.135.521-.3a.186.186,0,0,0-.022-.085l-.352-.2a.877.877,0,0,0-.147-.012h-.147c-.287,0-.521.135-.521.3s.233.3.521.3",
    transform: "translate(-735.79 -274.285)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63795",
    "data-name": "Group 63795",
    transform: "translate(42.607 15.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63794",
    "data-name": "Group 63794",
    className: "cls-303"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23459",
    "data-name": "Rectangle 23459",
    className: "cls-304",
    width: 1.041,
    height: 0.822,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63797",
    "data-name": "Group 63797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63796",
    "data-name": "Group 63796",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62598",
    "data-name": "Path 62598",
    className: "cls-53",
    d: "M736.311,270.469c-.287,0-.521.135-.521.3s.233.3.521.3.52-.135.52-.3-.233-.3-.52-.3",
    transform: "translate(-693.183 -254.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62599",
    "data-name": "Path 62599",
    className: "cls-289",
    d: "M737.2,271.011c-.257,0-.466.121-.466.269s.209.269.466.269.466-.121.466-.269-.209-.269-.466-.269",
    transform: "translate(-694.068 -255.318)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63799",
    "data-name": "Group 63799",
    transform: "translate(42.875 15.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63798",
    "data-name": "Group 63798",
    className: "cls-305"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23461",
    "data-name": "Rectangle 23461",
    className: "cls-306",
    width: 0.809,
    height: 0.782,
    transform: "translate(-0.288 0.464) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63832",
    "data-name": "Group 63832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63831",
    "data-name": "Group 63831",
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62601",
    "data-name": "Path 62601",
    className: "cls-292",
    d: "M742.075,265.344c.081-.14.211-.215.292-.168s.081.2,0,.337-.211.215-.292.168-.081-.2,0-.337",
    transform: "translate(-699.048 -249.807)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63804",
    "data-name": "Group 63804",
    className: "cls-293",
    transform: "translate(42.661 15.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63803",
    "data-name": "Group 63803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63802",
    "data-name": "Group 63802",
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63801",
    "data-name": "Group 63801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63800",
    "data-name": "Group 63800",
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23462",
    "data-name": "Rectangle 23462",
    className: "cls-308",
    width: 0.932,
    height: 1.221
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63809",
    "data-name": "Group 63809",
    className: "cls-293",
    transform: "translate(42.715 14.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63808",
    "data-name": "Group 63808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63807",
    "data-name": "Group 63807",
    className: "cls-297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63806",
    "data-name": "Group 63806",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63805",
    "data-name": "Group 63805",
    className: "cls-309"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23464",
    "data-name": "Rectangle 23464",
    className: "cls-310",
    width: 0.823,
    height: 0.475
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63812",
    "data-name": "Group 63812",
    className: "cls-293",
    transform: "translate(42.796 14.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63811",
    "data-name": "Group 63811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63810",
    "data-name": "Group 63810",
    className: "cls-300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62604",
    "data-name": "Path 62604",
    className: "cls-301",
    d: "M739.387,255.117c-.183,0-.331.086-.331.191s.148.191.331.191.331-.086.331-.191-.148-.191-.331-.191",
    transform: "translate(-739.056 -255.117)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62605",
    "data-name": "Path 62605",
    className: "cls-311",
    d: "M32.2,146.082l-.855,4.651,20.877,12.053.855-4.651Z",
    transform: "translate(-29.531 -137.623)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63815",
    "data-name": "Group 63815",
    className: "cls-212",
    transform: "translate(1.815 8.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63814",
    "data-name": "Group 63814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63813",
    "data-name": "Group 63813",
    className: "cls-312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62606",
    "data-name": "Path 62606",
    className: "cls-211",
    d: "M53.079,158.135,32.2,146.082l-.855,4.651.579.334.729-3.961,3.893,2.248-.729,3.961.579.335.729-3.961,3.893,2.248-.729,3.961.579.335.729-3.961,3.893,2.248-.729,3.961.579.334.729-3.961,3.893,2.248-.729,3.961.579.335.729-3.961,2.408,1.39Z",
    transform: "translate(-31.346 -146.082)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62607",
    "data-name": "Path 62607",
    className: "cls-126",
    d: "M22.822,226.4l-.524.594,21.252,12.27.149-.81Z",
    transform: "translate(-21.007 -213.289)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63818",
    "data-name": "Group 63818",
    className: "cls-133",
    transform: "translate(1.291 13.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63817",
    "data-name": "Group 63817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63816",
    "data-name": "Group 63816",
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62608",
    "data-name": "Path 62608",
    className: "cls-314",
    d: "M22.3,226.992l1.1-.259-.579-.335Z",
    transform: "translate(-22.298 -226.399)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63821",
    "data-name": "Group 63821",
    className: "cls-133",
    transform: "translate(5.764 15.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63820",
    "data-name": "Group 63820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63819",
    "data-name": "Group 63819",
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62609",
    "data-name": "Path 62609",
    className: "cls-314",
    d: "M99.537,271.584l1.1-.259-.579-.335Z",
    transform: "translate(-99.537 -270.991)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63824",
    "data-name": "Group 63824",
    className: "cls-133",
    transform: "translate(10.236 18.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63823",
    "data-name": "Group 63823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63822",
    "data-name": "Group 63822",
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62610",
    "data-name": "Path 62610",
    className: "cls-314",
    d: "M176.775,316.176l1.1-.259-.579-.335Z",
    transform: "translate(-176.775 -315.583)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63827",
    "data-name": "Group 63827",
    className: "cls-133",
    transform: "translate(14.709 20.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63826",
    "data-name": "Group 63826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63825",
    "data-name": "Group 63825",
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62611",
    "data-name": "Path 62611",
    className: "cls-314",
    d: "M254.014,360.768l1.1-.259-.579-.335Z",
    transform: "translate(-254.014 -360.175)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63830",
    "data-name": "Group 63830",
    className: "cls-133",
    transform: "translate(19.181 23.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63829",
    "data-name": "Group 63829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63828",
    "data-name": "Group 63828",
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62612",
    "data-name": "Path 62612",
    className: "cls-314",
    d: "M331.252,405.36l1.1-.259-.579-.334Z",
    transform: "translate(-331.252 -404.767)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62613",
    "data-name": "Path 62613",
    className: "cls-124",
    d: "M24,108.722l-.733.423L45.63,122.057l.141-.766Z",
    transform: "translate(-21.92 -102.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62614",
    "data-name": "Path 62614",
    className: "cls-137",
    d: "M23.3,142.345l-1,5.461.524-.594.855-4.651Z",
    transform: "translate(-21.007 -134.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62615",
    "data-name": "Path 62615",
    className: "cls-137",
    d: "M100.541,186.938l-1,5.461.524-.594.855-4.651Z",
    transform: "translate(-93.773 -176.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62616",
    "data-name": "Path 62616",
    className: "cls-137",
    d: "M177.779,231.532l-1,5.461.524-.594.855-4.651Z",
    transform: "translate(-166.538 -218.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62617",
    "data-name": "Path 62617",
    className: "cls-137",
    d: "M255.017,276.125l-1,5.461.524-.594.855-4.651Z",
    transform: "translate(-239.304 -260.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62618",
    "data-name": "Path 62618",
    className: "cls-137",
    d: "M332.256,320.719l-1,5.461.524-.594.855-4.651Z",
    transform: "translate(-312.07 -302.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62619",
    "data-name": "Path 62619",
    className: "cls-125",
    d: "M26.307,125.968l-.548,2.978L3.4,116.035l-1.221,6.64,23.473,13.552,1.626-8.842,1.791,1.034v-.858ZM6.7,124.96,3.34,123.02l1-5.461L7.707,119.5Zm4.473,2.582L7.813,125.6l1-5.461,3.362,1.941Zm4.473,2.582-3.362-1.941,1-5.461,3.362,1.941Zm4.473,2.582-3.362-1.941,1-5.461,3.362,1.941Zm4.473,2.582-3.362-1.941,1-5.461,3.362,1.941Z",
    transform: "translate(-2.049 -109.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62620",
    "data-name": "Path 62620",
    className: "cls-315",
    d: "M430.557,171.534l-11.638,6.719,2.758,1.593,11.638-6.719Z",
    transform: "translate(-394.661 -161.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62621",
    "data-name": "Path 62621",
    className: "cls-137",
    d: "M478.194,199.9l-11.638,6.719v-.858l11.638-6.719Z",
    transform: "translate(-439.54 -187.512)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67455",
    "data-name": "Group 67455",
    transform: "translate(316 -410.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71242",
    "data-name": "Path 71242",
    className: "cls-35",
    d: "M113.612,127.718c.732-.422,1.326-.085,1.329.756a2.907,2.907,0,0,1-1.32,2.285c-.73.422-1.325.083-1.327-.756a2.9,2.9,0,0,1,1.319-2.284",
    transform: "translate(611.231 559.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71243",
    "data-name": "Path 71243",
    className: "cls-35",
    d: "M108.009,138.613a3.657,3.657,0,0,1,.678,2.393,8.353,8.353,0,0,1-.686,3.211,10.589,10.589,0,0,1-1.781,2.924,11.694,11.694,0,0,1-3.022,2.373l-4.459,2.574L98.687,133.8l2.5-1.444a14.848,14.848,0,0,1,3.185-1.513,2.435,2.435,0,0,1,2.281.3,2.825,2.825,0,0,1,.852,2.3,6.256,6.256,0,0,1-.378,2.118,10.072,10.072,0,0,1-1.246,2.315,2.531,2.531,0,0,1,2.127.734m-2.95,5.959a3.34,3.34,0,0,0,.652-1.973c0-.785-.261-1.261-.774-1.421s-1.372.108-2.564.8l-.629.363.013,4.688.758-.438a8.162,8.162,0,0,0,2.544-2.014m-3.335-9.2.011,3.851.663-.383a4.631,4.631,0,0,0,1.645-1.484,3.235,3.235,0,0,0,.532-1.763c0-.573-.174-.926-.513-1.068s-.863-.005-1.556.395l-.782.452",
    transform: "translate(612.727 545.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71244",
    "data-name": "Path 71244",
    className: "cls-5",
    d: "M75.306,74.11a.433.433,0,0,1,.428-.043.426.426,0,0,1,.178.389l.044,15.559a1.226,1.226,0,0,1-.176.594L69.553,101.4a1.235,1.235,0,0,1-.427.45L61.593,106.2a.435.435,0,0,1-.43.045.427.427,0,0,1-.179-.39l-.011-3.939-3.1-1.767-9.542,5.509-2.79,4.832.035,12.46a1.333,1.333,0,0,1-.6,1.047l-11.679,6.743a.44.44,0,0,1-.43.045.434.434,0,0,1-.179-.391l-.021-7.5-5.737-3.27-12.246,7.07c-.334.193-.606.038-.607-.346a1.331,1.331,0,0,1,.6-1.046l12.5-7.215a.431.431,0,0,1,.428-.042l6.093,3.472a.426.426,0,0,1,.178.389l.02,7.088,10.469-6.044L44.329,110.9a1.238,1.238,0,0,1,.176-.6l3.143-5.444a1.244,1.244,0,0,1,.429-.451l10.044-5.8a.432.432,0,0,1,.428-.043l3.457,1.97a.424.424,0,0,1,.178.389l.01,3.531,6.677-3.855,5.874-10.174L74.7,75.852,54.946,87.259,52.313,91.82a1.228,1.228,0,0,1-.427.45.432.432,0,0,1-.428.044c-.238-.136-.239-.575,0-.985l2.81-4.867a1.244,1.244,0,0,1,.427-.45Z",
    transform: "translate(674.474 594.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71245",
    "data-name": "Path 71245",
    className: "cls-34",
    d: "M5.834,220.4c.73-.422,1.325-.083,1.327.758a2.907,2.907,0,0,1-1.319,2.284c-.732.422-1.326.083-1.329-.756a2.908,2.908,0,0,1,1.32-2.287",
    transform: "translate(680.629 500.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71246",
    "data-name": "Path 71246",
    className: "cls-34",
    d: "M9.556,194.214,16,209.61l-3.288,1.9L11.4,208.324l-6.779,3.914-1.34,4.714L0,218.847l6.35-22.782ZM5.777,208.027l4.443-2.565-2.233-5.273-2.21,7.838",
    transform: "translate(670.467 522.756)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetTracking);
export default __webpack_public_path__ + "static/media/AssetTracking.bab71ce9544c265c5c90761a14ccf375.svg";
export { ForwardRef as ReactComponent };